/* AUTO-GENERATED by research/build_atlas_seed.py. Do not edit by hand.
   Regenerate with: python3 research/build_atlas_seed.py

   301 sites, 24 countries, 49 reimbursement pathways,
   consolidated from the per-region research files in research/raw/.

   Coordinates: sites with geo: 'city' are placed from a curated gazetteer. Sites with
   geo: 'approx' fall back to a country centroid because the city was not in the
   gazetteer, and the map renders those differently so a centroid is never mistaken for
   a hospital location. */

import type { Site, Country } from './atlas';

export const GEN_SITES = [
 {
  "id": "usa-mayo-phoenix",
  "name": "Mayo Clinic Hospital - Arizona",
  "short": "Mayo Phoenix",
  "city": "Phoenix",
  "region": "AZ",
  "iso3": "USA",
  "lat": 33.4484,
  "lon": -112.074,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 31,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 503,
    "living": 111,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 53,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 322,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 6,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-emory",
  "name": "Emory University Hospital",
  "short": "Emory",
  "city": "Atlanta",
  "region": "GA",
  "iso3": "USA",
  "lat": 33.749,
  "lon": -84.388,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 74,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 591,
    "living": 189,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 13,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 192,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 44,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-the-cleveland-clinic-foundation",
  "name": "The Cleveland Clinic Foundation",
  "short": "Cleveland Clinic Foundation",
  "city": "OH",
  "region": "OH",
  "iso3": "USA",
  "lat": 40.3,
  "lon": -82.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 358,
    "living": 74,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 290,
    "living": 24,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 91,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 143,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2025,
    "total": 11,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 3,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-tampa-general",
  "name": "Tampa General Hospital",
  "short": "Tampa General",
  "city": "Tampa",
  "region": "FL",
  "iso3": "USA",
  "lat": 27.9506,
  "lon": -82.4572,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 42,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 518,
    "living": 122,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 9,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 284,
    "living": 12,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 42,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-cleveland-clinic",
  "name": "Cleveland Clinic Main Campus",
  "short": "Cleveland Clinic",
  "city": "Cleveland",
  "region": "OH",
  "iso3": "USA",
  "lat": 41.4993,
  "lon": -81.6944,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 91,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 358,
    "living": 74,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 290,
    "living": 24,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 143,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-houston-methodist",
  "name": "Houston Methodist Hospital",
  "short": "Houston Methodist",
  "city": "Houston",
  "region": "TX",
  "iso3": "USA",
  "lat": 29.7604,
  "lon": -95.3698,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 73,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 327,
    "living": 132,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 11,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 338,
    "living": 15,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 83,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-university-of-california-san-francisco",
  "name": "University of California San Francisco Medical Center",
  "short": "University of California San Francisco Medic",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 354,
    "living": 123,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 183,
    "living": 29,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 58,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 89,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 20,
    "living": 10,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-university-of-california-at-los-angele",
  "name": "University of California at Los Angeles Medical Center",
  "short": "University of California at Los Angeles Medi",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 387,
    "living": 88,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 144,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 87,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 83,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 3,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-ucsf",
  "name": "UCSF Medical Center",
  "short": "UCSF",
  "city": "San Francisco",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.7749,
  "lon": -122.4194,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 58,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 354,
    "living": 123,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 20,
    "living": 10,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 183,
    "living": 29,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 89,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-ucla",
  "name": "Ronald Reagan UCLA Medical Center",
  "short": "UCLA",
  "city": "Los Angeles",
  "region": "CA",
  "iso3": "USA",
  "lat": 34.0522,
  "lon": -118.2437,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 87,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 387,
    "living": 88,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 144,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 83,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-duke",
  "name": "Duke University Hospital",
  "short": "Duke",
  "city": "Durham",
  "region": "NC",
  "iso3": "USA",
  "lat": 35.994,
  "lon": -78.8986,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 136,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 236,
    "living": 84,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 13,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 200,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 104,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-northwestern",
  "name": "Northwestern Memorial Hospital",
  "short": "Northwestern",
  "city": "Chicago",
  "region": "IL",
  "iso3": "USA",
  "lat": 41.8781,
  "lon": -87.6298,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 28,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 331,
    "living": 74,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 19,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 178,
    "living": 23,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 129,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 4,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-cedars-sinai",
  "name": "Cedars-Sinai Medical Center",
  "short": "Cedars-Sinai",
  "city": "Los Angeles",
  "region": "CA",
  "iso3": "USA",
  "lat": 34.0522,
  "lon": -118.2437,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 114,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 322,
    "living": 80,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 145,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 93,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-musc",
  "name": "Medical University of South Carolina Health",
  "short": "MUSC",
  "city": "Charleston",
  "region": "SC",
  "iso3": "USA",
  "lat": 32.7765,
  "lon": -79.9311,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 77,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 377,
    "living": 63,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 24,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 177,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 21,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-piedmont-atlanta",
  "name": "Piedmont Atlanta Hospital",
  "short": "Piedmont Atlanta",
  "city": "Atlanta",
  "region": "GA",
  "iso3": "USA",
  "lat": 33.749,
  "lon": -84.388,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 103,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 335,
    "living": 80,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 8,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 199,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-penn-medicine",
  "name": "Hospital of the University of Pennsylvania",
  "short": "Penn Medicine",
  "city": "Philadelphia",
  "region": "PA",
  "iso3": "USA",
  "lat": 39.9526,
  "lon": -75.1652,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 57,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 306,
    "living": 82,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 41,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 172,
    "living": 23,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 55,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-osu-wexner",
  "name": "Ohio State University Wexner Medical Center",
  "short": "OSU Wexner",
  "city": "Columbus",
  "region": "OH",
  "iso3": "USA",
  "lat": 39.9612,
  "lon": -82.9988,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 34,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 325,
    "living": 87,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 10,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 172,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 75,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-barnes-jewish-hospital",
  "name": "Barnes-Jewish Hospital",
  "short": "Barnes-Jewish Hospital",
  "city": "St. Louis",
  "region": "MO",
  "iso3": "USA",
  "lat": 38.636,
  "lon": -90.264,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 329,
    "living": 53,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 148,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 57,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 67,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 3,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-barnes-jewish",
  "name": "Barnes-Jewish Hospital / Washington University",
  "short": "Barnes-Jewish",
  "city": "St Louis",
  "region": "MO",
  "iso3": "USA",
  "lat": 39.5,
  "lon": -98.0,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 57,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 329,
    "living": 53,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 3,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 148,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 67,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-rochester-methodist-hospital-mayo-clin",
  "name": "Rochester Methodist Hospital (Mayo Clinic)",
  "short": "Rochester Methodist Hospital (Mayo Clinic)",
  "city": "MN",
  "region": "MN",
  "iso3": "USA",
  "lat": 46.3,
  "lon": -94.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 303,
    "living": 156,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 163,
    "living": 17,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 56,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 60,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 3,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 16,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 3,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-mayo-rochester",
  "name": "Mayo Clinic Hospital - Saint Marys Campus",
  "short": "Mayo Rochester",
  "city": "Rochester",
  "region": "MN",
  "iso3": "USA",
  "lat": 44.0121,
  "lon": -92.4802,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 56,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 303,
    "living": 156,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 16,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 163,
    "living": 17,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 60,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 3,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-mgh",
  "name": "Massachusetts General Hospital",
  "short": "MGH",
  "city": "Boston",
  "region": "MA",
  "iso3": "USA",
  "lat": 42.3601,
  "lon": -71.0589,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 57,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 238,
    "living": 81,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 210,
    "living": 10,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 84,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-new-york-university-medical-center",
  "name": "New York University Medical Center",
  "short": "New York University Medical Center",
  "city": "NY",
  "region": "NY",
  "iso3": "USA",
  "lat": 42.9,
  "lon": -75.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 308,
    "living": 72,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 123,
    "living": 7,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 72,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 74,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 6,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-nyu-langone",
  "name": "Tisch Hospital, NYU Langone Health",
  "short": "NYU Langone",
  "city": "New York",
  "region": "NY",
  "iso3": "USA",
  "lat": 40.7128,
  "lon": -74.006,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 72,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 308,
    "living": 72,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 6,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 123,
    "living": 7,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 74,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-georgetown-university-medical-center",
  "name": "Georgetown University Medical Center",
  "short": "Georgetown University Medical Center",
  "city": "Washington",
  "region": "DC",
  "iso3": "USA",
  "lat": 38.911,
  "lon": -77.076,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 369,
    "living": 54,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 151,
    "living": 26,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 8,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 38,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2025,
    "total": 16,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-mount-sinai",
  "name": "The Mount Sinai Hospital",
  "short": "Mount Sinai",
  "city": "New York",
  "region": "NY",
  "iso3": "USA",
  "lat": 40.7128,
  "lon": -74.006,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 78,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 280,
    "living": 71,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 9,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 173,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 24,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 6,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-ny-presbyterian-hospital-columbia-univ",
  "name": "NY Presbyterian Hospital/Columbia Univ. Medical Center",
  "short": "NY Presbyterian Hospital/Columbia Univ. Medi",
  "city": "New York",
  "region": "NY",
  "iso3": "USA",
  "lat": 40.842,
  "lon": -73.942,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 217,
    "living": 86,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 148,
    "living": 55,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 83,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 101,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 6,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "cze-ikem",
  "name": "Institut klinicke a experimentalni mediciny",
  "short": "IKEM",
  "city": "Prague",
  "region": "Praha",
  "iso3": "CZE",
  "lat": 50.0755,
  "lon": 14.4378,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 308,
    "living": 28,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 153,
    "living": 10,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 61,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 40,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Accreditation: EFI.",
  "note": "Effectively the Czech market in one account. IKEM has a strong research output in transplant nephrology and pathology and is a plausible low-cost, high-quality central European validation partner.",
  "source": "rest_europe"
 },
 {
  "id": "usa-nyp-columbia",
  "name": "NewYork-Presbyterian / Columbia University Irving Medical Center",
  "short": "NYP Columbia",
  "city": "New York",
  "region": "NY",
  "iso3": "USA",
  "lat": 40.7128,
  "lon": -74.006,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 83,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 217,
    "living": 86,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 6,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 148,
    "living": 55,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 101,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-medical-college-of-virginia-hospitals",
  "name": "Medical College of Virginia Hospitals",
  "short": "Medical College of Virginia Hospitals",
  "city": "Richmond",
  "region": "VA",
  "iso3": "USA",
  "lat": 37.54,
  "lon": -77.429,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 315,
    "living": 40,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 197,
    "living": 26,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 27,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 13,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-vcu-hume-lee",
  "name": "VCU Health Hume-Lee Transplant Center",
  "short": "VCU Hume-Lee",
  "city": "Richmond",
  "region": "VA",
  "iso3": "USA",
  "lat": 37.5407,
  "lon": -77.436,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 27,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 315,
    "living": 40,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 13,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 197,
    "living": 26,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 4,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-mayo-jacksonville",
  "name": "Mayo Clinic Hospital - Florida",
  "short": "Mayo Jacksonville",
  "city": "Jacksonville",
  "region": "FL",
  "iso3": "USA",
  "lat": 30.3322,
  "lon": -81.6557,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 84,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 220,
    "living": 74,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 7,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 160,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 69,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-university-of-wisconsin-hospital-and-c",
  "name": "University of Wisconsin Hospital and Clinics",
  "short": "University of Wisconsin Hospital and Clinics",
  "city": "Madison",
  "region": "WI",
  "iso3": "USA",
  "lat": 43.076,
  "lon": -89.43,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 284,
    "living": 94,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 134,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 24,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 66,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 8,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 22,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-uw-madison",
  "name": "University of Wisconsin Hospital",
  "short": "UW Madison",
  "city": "Madison",
  "region": "WI",
  "iso3": "USA",
  "lat": 43.0731,
  "lon": -89.4012,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 24,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 284,
    "living": 94,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 22,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 134,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 66,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 8,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-jackson-memorial-hospital-university-o",
  "name": "Jackson Memorial Hospital University of Miami School of Medicine",
  "short": "Jackson Memorial Hospital University of Miam",
  "city": "FL",
  "region": "FL",
  "iso3": "USA",
  "lat": 28.6,
  "lon": -82.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 285,
    "living": 42,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 110,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 15,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 85,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 9,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 17,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2025,
    "total": 11,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-baylor-dallas",
  "name": "Baylor University Medical Center",
  "short": "Baylor Dallas",
  "city": "Dallas",
  "region": "TX",
  "iso3": "USA",
  "lat": 32.7767,
  "lon": -96.797,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 88,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 268,
    "living": 114,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 9,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 120,
    "living": 12,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 41,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-intermountain",
  "name": "Intermountain Medical Center",
  "short": "Intermountain",
  "city": "Murray",
  "region": "UT",
  "iso3": "USA",
  "lat": 39.5,
  "lon": -98.0,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 32,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 252,
    "living": 74,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 4,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 227,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-uchealth-colorado",
  "name": "UCHealth University of Colorado Hospital",
  "short": "UCHealth Colorado",
  "city": "Aurora",
  "region": "CO",
  "iso3": "USA",
  "lat": 39.7294,
  "lon": -104.8319,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 77,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 234,
    "living": 67,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 10,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 148,
    "living": 11,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 46,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-university-of-colorado-hospital-health",
  "name": "University of Colorado Hospital/Health Science Center",
  "short": "University of Colorado Hospital/Health Scien",
  "city": "Aurora",
  "region": "CO",
  "iso3": "USA",
  "lat": 39.744,
  "lon": -104.838,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 234,
    "living": 67,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 148,
    "living": 11,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 77,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 46,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 10,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-methodist-specialty-and-transplant-hos",
  "name": "Methodist Specialty and Transplant Hospital",
  "short": "Methodist Specialty and Transplant Hospital",
  "city": "San Antonio",
  "region": "TX",
  "iso3": "USA",
  "lat": 29.509,
  "lon": -98.576,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 343,
    "living": 167,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 65,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 67,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 8,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 4,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-michigan-medicine",
  "name": "University Hospital, Michigan Medicine",
  "short": "Michigan Medicine",
  "city": "Ann Arbor",
  "region": "MI",
  "iso3": "USA",
  "lat": 42.2808,
  "lon": -83.743,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 38,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 272,
    "living": 57,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 9,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 140,
    "living": 5,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 27,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-indiana-university-health",
  "name": "Indiana University Health",
  "short": "Indiana University Health",
  "city": "Indianapolis",
  "region": "IN",
  "iso3": "USA",
  "lat": 39.777,
  "lon": -86.18,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 189,
    "living": 45,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 193,
    "living": 9,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 24,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 46,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 8,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 19,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2025,
    "total": 6,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-university-of-california-san-diego-med",
  "name": "University of California San Diego Medical Center",
  "short": "University of California San Diego Medical C",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 182,
    "living": 40,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 175,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 74,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 54,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-iu-methodist",
  "name": "IU Health Methodist Hospital",
  "short": "IU Methodist",
  "city": "Indianapolis",
  "region": "IN",
  "iso3": "USA",
  "lat": 39.7684,
  "lon": -86.1581,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 24,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 189,
    "living": 45,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 19,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 193,
    "living": 9,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 46,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 8,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "gbr-birmingham",
  "name": "Queen Elizabeth Hospital Birmingham / Birmingham Children's Hospital",
  "short": "Birmingham",
  "city": "Birmingham",
  "region": "West Midlands, England",
  "iso3": "GBR",
  "lat": 52.4862,
  "lon": -1.8904,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 203,
    "living": 49,
    "confidence": "verified"
   },
   {
    "organ": "kidney_paediatric",
    "year": 2024,
    "total": 13,
    "living": 5,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 205,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 26,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 26,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2024,
    "total": 3,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 5600,
   "confidence": "estimated",
   "method": "Derived: national prevalent kidney grafts 46,000 apportioned by Birmingham's share of adult+paediatric kidney transplants (216/3172 = 6.8%); liver 12,300 apportioned by Birmingham's share of liver transplants (205/931 = 22%). Crude — assumes stable historic market share and equal graft survival."
  },
  "tier": 1,
  "labNote": "Birmingham transplant H&I is served by the NHSBT H&I laboratory in Birmingham (see hi_lab entries) rather than an in-house trust lab.",
  "note": "Largest multi-organ centre in the UK (kidney + liver + cardiothoracic + intestine + paediatric). Single highest-value beachhead for a multi-organ diagnostics portfolio. Procurement via UHB NHS FT; pathology managed through the Black Country / Birmingham pathology network. NHSBT Birmingham H&I lab is the actual purchaser of HLA/chimerism reagents.",
  "source": "uk"
 },
 {
  "id": "usa-stanford-health-care",
  "name": "Stanford Health Care",
  "short": "Stanford Health Care",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 161,
    "living": 51,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 156,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 71,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 70,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 12,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-johns-hopkins",
  "name": "The Johns Hopkins Hospital",
  "short": "Johns Hopkins",
  "city": "Baltimore",
  "region": "MD",
  "iso3": "USA",
  "lat": 39.2904,
  "lon": -76.6122,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 76,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 225,
    "living": 46,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 3,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 127,
    "living": 20,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 32,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-stanford",
  "name": "Stanford Hospital",
  "short": "Stanford",
  "city": "Palo Alto",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.4419,
  "lon": -122.143,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 71,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 161,
    "living": 51,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 156,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 70,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-ut-southwestern",
  "name": "William P Clements Jr University Hospital",
  "short": "UT Southwestern",
  "city": "Dallas",
  "region": "TX",
  "iso3": "USA",
  "lat": 32.7767,
  "lon": -96.797,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 56,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 212,
    "living": 45,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 121,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 69,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-umn",
  "name": "University of Minnesota Medical Center",
  "short": "UMN",
  "city": "Minneapolis",
  "region": "MN",
  "iso3": "USA",
  "lat": 44.9778,
  "lon": -93.265,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 31,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 198,
    "living": 47,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 27,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 134,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 59,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 3,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-university-of-minnesota-medical-center",
  "name": "University of Minnesota Medical Center, Fairview",
  "short": "University of Minnesota Medical Center, Fair",
  "city": "Minneapolis",
  "region": "MN",
  "iso3": "USA",
  "lat": 44.969,
  "lon": -93.236,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 198,
    "living": 47,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 134,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 31,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 59,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 3,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 27,
    "living": 6,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-uab",
  "name": "University of Alabama at Birmingham Hospital",
  "short": "UAB",
  "city": "Birmingham",
  "region": "AL",
  "iso3": "USA",
  "lat": 33.5186,
  "lon": -86.8104,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 22,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 235,
    "living": 49,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 8,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 153,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 31,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-uw-seattle",
  "name": "University of Washington Medical Center",
  "short": "UW Seattle",
  "city": "Seattle",
  "region": "WA",
  "iso3": "USA",
  "lat": 47.6062,
  "lon": -122.3321,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 66,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 194,
    "living": 39,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 117,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 64,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-north-shore-university-hospital-northw",
  "name": "North Shore University Hospital/Northwell Health",
  "short": "North Shore University Hospital/Northwell He",
  "city": "Manhasset",
  "region": "NY",
  "iso3": "USA",
  "lat": 40.798,
  "lon": -73.697,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 211,
    "living": 51,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 151,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 36,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 27,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "pol-centralny-szpital-kliniczny-uck-wum-wa",
  "name": "Centralny Szpital Kliniczny UCK WUM, Warszawa",
  "short": "Centralny Szpital Kliniczny UCK WUM, Warszaw",
  "city": "Warsaw",
  "region": "",
  "iso3": "POL",
  "lat": 52.2297,
  "lon": 21.0122,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 89,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 305,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 21,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 9,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-uf-health-shands",
  "name": "UF Health Shands Hospital",
  "short": "UF Health Shands",
  "city": "Gainesville",
  "region": "FL",
  "iso3": "USA",
  "lat": 29.6516,
  "lon": -82.3248,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 37,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 158,
    "living": 12,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 12,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 146,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 65,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-university-of-pittsburgh-medical-cente",
  "name": "University of Pittsburgh Medical Center",
  "short": "University of Pittsburgh Medical Center",
  "city": "PA",
  "region": "PA",
  "iso3": "USA",
  "lat": 40.9,
  "lon": -77.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 170,
    "living": 80,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 140,
    "living": 82,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 33,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 59,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 7,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-upmc",
  "name": "UPMC Presbyterian",
  "short": "UPMC",
  "city": "Pittsburgh",
  "region": "PA",
  "iso3": "USA",
  "lat": 40.4406,
  "lon": -79.9959,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 33,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 170,
    "living": 80,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 7,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 140,
    "living": 82,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 59,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-nebraska-medicine",
  "name": "Nebraska Medicine",
  "short": "Nebraska Medicine",
  "city": "Omaha",
  "region": "NE",
  "iso3": "USA",
  "lat": 41.2565,
  "lon": -95.9345,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 40,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 184,
    "living": 60,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 166,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 11,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 6,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-university-hospital-university-of-texa",
  "name": "University Hospital, University of Texas Health Science Center",
  "short": "University Hospital, University of Texas Hea",
  "city": "San Antonio",
  "region": "TX",
  "iso3": "USA",
  "lat": 29.508,
  "lon": -98.577,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 201,
    "living": 46,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 182,
    "living": 74,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 25,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-chi-st-luke-s-health-baylor-college-of",
  "name": "CHI St. Luke's Health Baylor College of Medicine Medical Center",
  "short": "CHI St. Luke's Health Baylor College of Medi",
  "city": "Houston",
  "region": "TX",
  "iso3": "USA",
  "lat": 29.71,
  "lon": -95.398,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 153,
    "living": 32,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 120,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 30,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 102,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "nld-erasmus-mc",
  "name": "Erasmus MC Transplantatie Instituut",
  "short": "Erasmus MC",
  "city": "Rotterdam",
  "region": "Zuid-Holland",
  "iso3": "NLD",
  "lat": 51.9244,
  "lon": 4.4777,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 217,
    "living": 111,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 105,
    "living": 12,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 41,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 31,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Home of the Rotterdam Transplantation Lab; Sebastiaan Heidt has led the Nephrology and Transplantation Laboratory here since 2024, having previously headed the Eurotransplant Reference Laboratory. Accreditation: EFI.",
  "note": "The strongest Dutch scientific account for transplant immunology, and the one with the clearest published volume data. The arrival of the former Eurotransplant Reference Laboratory head makes it the natural Dutch partner for anything HLA- or antibody-related.",
  "source": "rest_europe"
 },
 {
  "id": "usa-ochsner",
  "name": "Ochsner Medical Center",
  "short": "Ochsner",
  "city": "New Orleans",
  "region": "LA",
  "iso3": "USA",
  "lat": 29.9511,
  "lon": -90.0715,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 24,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 197,
    "living": 50,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 11,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 142,
    "living": 9,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 14,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-university-of-chicago-medical-center",
  "name": "University of Chicago Medical Center",
  "short": "University of Chicago Medical Center",
  "city": "IL",
  "region": "IL",
  "iso3": "USA",
  "lat": 40.0,
  "lon": -89.2,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 197,
    "living": 32,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 88,
    "living": 11,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 59,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 24,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 13,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-hu-vall-d-hebron",
  "name": "Hospital Universitari Vall d'Hebron",
  "short": "HU Vall d'Hebron",
  "city": "Barcelona",
  "region": "Cataluna",
  "iso3": "ESP",
  "lat": 41.3874,
  "lon": 2.1686,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 184,
    "living": 28,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 93,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 105,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1670,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": null,
  "note": "Largest multi-organ centre in Spain. Kidney 168 adult + 16 paediatric; liver 72 adult + 21 paediatric; lung 105 (highest cumulative lung series in Spain, 1,724 since 1990). ONT named Vall d'Hebron the hospital with the most lung transplants in 2025. Part of ICS.",
  "source": "spain"
 },
 {
  "id": "usa-florida-hospital-medical-center",
  "name": "Florida Hospital Medical Center",
  "short": "Florida Hospital Medical Center",
  "city": "Orlando",
  "region": "FL",
  "iso3": "USA",
  "lat": 28.572,
  "lon": -81.37,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 160,
    "living": 27,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 116,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 56,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 31,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 13,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-saint-barnabas-medical-center",
  "name": "Saint Barnabas Medical Center",
  "short": "Saint Barnabas Medical Center",
  "city": "Livingston",
  "region": "NJ",
  "iso3": "USA",
  "lat": 40.786,
  "lon": -74.326,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 369,
    "living": 78,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-vanderbilt",
  "name": "Vanderbilt University Medical Center",
  "short": "Vanderbilt",
  "city": "Nashville",
  "region": "TN",
  "iso3": "USA",
  "lat": 36.1627,
  "lon": -86.7816,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 374,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "Third busiest US transplant centre by total volume in 2024 and a high-volume kidney, liver, heart and lung programme in one campus. One of the few single accounts in the US that can move a whole portfolio at once.",
  "source": "usa"
 },
 {
  "id": "fra-lyon-hcl",
  "name": "Hospices Civils de Lyon - Hopital Edouard Herriot, Service de Transplantation, Nephrologie et Immunologie Clinique",
  "short": "Lyon HCL",
  "city": "Lyon",
  "region": "Auvergne-Rhone-Alpes",
  "iso3": "FRA",
  "lat": 45.764,
  "lon": 4.8357,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 196,
    "living": 24,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 101,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 25,
    "living": 0,
    "confidence": "derived"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 28,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 21,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 2197,
   "confidence": "verified",
   "method": "ABM Table R52, adult team; a further 164 followed at Lyon HFME (paediatric). Source https://rams-back.agence-biomedecine.fr/uploads/TOR_52_2024_e38e0b2600.xlsx"
  },
  "tier": 1,
  "labNote": "HLA support for the Auvergne-Rhone-Alpes region is understood to be provided through the EFS Auvergne-Rhone-Alpes histocompatibility laboratory. The specific set of centres served was NOT verified in this session and is an inference from EFS regional structure - treat as unverified.",
  "note": "France's broadest multi-organ programme (six organ types including vascularised composite allotransplantation, where Lyon is a world pioneer). Prof Olivier Thaunat is Professor of Renal Transplantation and Clinical Immunology and deputy head of service, and Prof Emmanuel Morelon is the other senior figure; Thaunat is one of the most-published French transplant immunologists and a natural scientific-advisory target. Purchasing runs through HCL, one of the largest hospital groups in France, and via UniHA.",
  "source": "france"
 },
 {
  "id": "usa-university-of-virginia-health-sciences",
  "name": "University of Virginia Health Sciences Center",
  "short": "University of Virginia Health Sciences Cente",
  "city": "Charlottesville",
  "region": "VA",
  "iso3": "USA",
  "lat": 38.032,
  "lon": -78.499,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 195,
    "living": 28,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 99,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 27,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 43,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-uva",
  "name": "University of Virginia Medical Center",
  "short": "UVA",
  "city": "Charlottesville",
  "region": "VA",
  "iso3": "USA",
  "lat": 38.0293,
  "lon": -78.4767,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 27,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 195,
    "living": 28,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 99,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 43,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-henry-ford-hospital",
  "name": "Henry Ford Hospital",
  "short": "Henry Ford Hospital",
  "city": "Detroit",
  "region": "MI",
  "iso3": "USA",
  "lat": 42.366,
  "lon": -83.079,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 143,
    "living": 32,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 175,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 19,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 20,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 2,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-loma-linda-university-medical-center",
  "name": "Loma Linda University Medical Center",
  "short": "Loma Linda University Medical Center",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 222,
    "living": 35,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 97,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 22,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 23,
    "living": 6,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "fra-bordeaux-pellegrin",
  "name": "CHU de Bordeaux - Hopital Pellegrin, Service de Nephrologie-Transplantation-Dialyse",
  "short": "Bordeaux Pellegrin",
  "city": "Bordeaux",
  "region": "Nouvelle-Aquitaine",
  "iso3": "FRA",
  "lat": 44.8378,
  "lon": -0.5792,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 219,
    "living": 39,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 94,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 21,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 27,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 2258,
   "confidence": "verified",
   "method": "ABM Table R52, adult team; a further 35 paediatric. Source https://rams-back.agence-biomedecine.fr/uploads/TOR_52_2024_e38e0b2600.xlsx"
  },
  "tier": 1,
  "labNote": "The Bordeaux CHU Immunology/Immunogenetics laboratory replaced PCR-SSO with Omixon NanoTYPE Mono on Oxford Nanopore MinION in June 2023 - one of the earliest routine clinical nanopore HLA typing deployments in Europe. Gwendaline Guidicelli, current President of the Societe Francophone d'Histocompatibilite et d'Immunogenetique (SFHI), is associated with Bordeaux. EFI accreditation is inferred from the fact that the LAHN NGS typing act G305 is only payable in EFI-accredited laboratories and Bordeaux performs NGS/nanopore typing; not independently confirmed against the EFI register. Accreditation",
  "note": "A four-organ centre and the most technically adventurous HLA laboratory in France: it is already running clinical HLA typing on Oxford Nanopore. For a company whose platform is nanopore-based this is the single best-matched reference site in the country. Clinical lead for kidney transplantation is Prof Lionel Couzi, who is also Secretaire General Adjoint of the SFT; Prof Pierre Merville is the other senior figure. Procurement via CHU de Bordeaux tenders (the CHU publishes its own hors-nomenclature tariff guide publicly).",
  "source": "france"
 },
 {
  "id": "fra-sorbonne-universite-ap-hp",
  "name": "AP-HP Sorbonne Universite - Hopital Pitie-Salpetriere and Hopital Tenon (merged kidney team)",
  "short": "Sorbonne Universite (AP-HP)",
  "city": "Paris",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 48.8566,
  "lon": 2.3522,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 158,
    "living": 13,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 120,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 80,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 2085,
   "confidence": "verified",
   "method": "ABM Table R52 under the merged Sorbonne Universite name."
  },
  "tier": 1,
  "labNote": "Not verified.",
  "note": "The dominant French heart transplant account and a top-10 kidney and liver centre. For any AlloMap-class heart rejection surveillance product this is the beachhead account in France: 80 heart transplants a year plus the Henri Mondor listed population. Note the AI-CARE dd-cfDNA trial includes AP-HP La Pitie-Salpetriere as a site. Be aware of the ABM naming change - searching for 'Pitie-Salpetriere' in the kidney tables returns nothing because the team is now 'Sorbonne Universite'.",
  "source": "france"
 },
 {
  "id": "swe-sahlgrenska",
  "name": "Sahlgrenska Universitetssjukhuset - Transplantationscentrum",
  "short": "Sahlgrenska",
  "city": "Gothenburg",
  "region": "Vastra Gotaland",
  "iso3": "SWE",
  "lat": 57.7089,
  "lon": 11.9746,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 192,
    "living": 33,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 94,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 23,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 42,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": "Sweden's other major multi-organ centre and internationally known for uterus transplantation. High-volume liver and kidney.",
  "source": "rest_europe"
 },
 {
  "id": "usa-new-york-presbyterian-hospital-weill-c",
  "name": "New York-Presbyterian Hospital/Weill Cornell Medical Center",
  "short": "New York-Presbyterian Hospital/Weill Cornell",
  "city": "New York",
  "region": "NY",
  "iso3": "USA",
  "lat": 40.765,
  "lon": -73.954,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 243,
    "living": 83,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 88,
    "living": 21,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 20,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-nyp-weill-cornell",
  "name": "NewYork-Presbyterian / Weill Cornell Medical Center",
  "short": "NYP Weill Cornell",
  "city": "New York",
  "region": "NY",
  "iso3": "USA",
  "lat": 40.7128,
  "lon": -74.006,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 20,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 243,
    "living": 83,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 4,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 88,
    "living": 21,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-carolinas-medical-center",
  "name": "Carolinas Medical Center",
  "short": "Carolinas Medical Center",
  "city": "Charlotte",
  "region": "NC",
  "iso3": "USA",
  "lat": 35.205,
  "lon": -80.838,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 141,
    "living": 20,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 135,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 77,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-loyola",
  "name": "Loyola University Medical Center",
  "short": "Loyola",
  "city": "Maywood",
  "region": "IL",
  "iso3": "USA",
  "lat": 41.8794,
  "lon": -87.8434,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 10,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 215,
    "living": 56,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 7,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 85,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 34,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-keck-hospital-of-usc",
  "name": "Keck Hospital of USC",
  "short": "Keck Hospital of USC",
  "city": "Los Angeles",
  "region": "CA",
  "iso3": "USA",
  "lat": 34.062,
  "lon": -118.201,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 177,
    "living": 21,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 133,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 19,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 21,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-california-pacific-medical-center",
  "name": "California Pacific Medical Center",
  "short": "California Pacific Medical Center",
  "city": "San Francisco",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.788,
  "lon": -122.434,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 209,
    "living": 35,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 96,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 29,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 13,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-torino-molinette",
  "name": "A.O.U. Citta della Salute e della Scienza di Torino - Presidio Molinette",
  "short": "Torino Molinette",
  "city": "Turin",
  "region": "Piemonte",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 190,
    "living": 20,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 152,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 4000,
   "confidence": "estimated",
   "method": "Estimated as roughly 13x current annual kidney volume and 11x liver, reflecting typical Italian graft half-life; cross-checked against 2,713 cumulative kidney transplants 2000-2022 with attrition. Not a published figure."
  },
  "tier": 1,
  "labNote": "Regional immunogenetics service (Laboratorio di Immunogenetica e Biologia dei Trapianti) supporting the Piemonte CRT. EFI accreditation status asserted as typical for a centre of this size - not individually verified. Accreditation: EFI.",
  "note": "Purchases through the Piemonte regional aggregator SCR Piemonte (Societa di Committenza Regione Piemonte). Highest-volume single account in Italy for both kidney and liver; the natural national reference site for a rejection surveillance study.",
  "source": "italy"
 },
 {
  "id": "esp-hu-la-fe",
  "name": "Hospital Universitari i Politecnic La Fe",
  "short": "HU La Fe",
  "city": "Valencia",
  "region": "Comunitat Valenciana",
  "iso3": "ESP",
  "lat": 39.4699,
  "lon": -0.3763,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 136,
    "living": 7,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 105,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 100,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1240,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": null,
  "note": "Kidney 124 adult + 12 paediatric; liver 97 adult + 8 paediatric; lung 100. ONT named La Fe the hospital with the most liver transplants in Spain in 2025. Full multi-organ including paediatric.",
  "source": "spain"
 },
 {
  "id": "usa-uc-davis",
  "name": "UC Davis Medical Center",
  "short": "UC Davis",
  "city": "Sacramento",
  "region": "CA",
  "iso3": "USA",
  "lat": 38.5816,
  "lon": -121.4944,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 270,
    "living": 75,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 59,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "esp-hru-malaga",
  "name": "Hospital Regional Universitario de Malaga (Carlos Haya)",
  "short": "HRU Malaga",
  "city": "Malaga",
  "region": "Andalucia",
  "iso3": "ESP",
  "lat": 36.7213,
  "lon": -4.4214,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 242,
    "living": 11,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 85,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 2200,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": null,
  "note": "Highest single-centre kidney volume in Spain in 2024 (242). Heart programme also present (not verified at centre level here).",
  "source": "spain"
 },
 {
  "id": "usa-montefiore",
  "name": "Montefiore Medical Center",
  "short": "Montefiore",
  "city": "Bronx",
  "region": "NY",
  "iso3": "USA",
  "lat": 40.8448,
  "lon": -73.8648,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 30,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 220,
    "living": 28,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 46,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 26,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-university-of-utah-medical-center",
  "name": "University of Utah Medical Center",
  "short": "University of Utah Medical Center",
  "city": "Salt Lake City",
  "region": "UT",
  "iso3": "USA",
  "lat": 40.771,
  "lon": -111.838,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 173,
    "living": 58,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 47,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 38,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 50,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 8,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-university-of-illinois-medical-center",
  "name": "University of Illinois Medical Center",
  "short": "University of Illinois Medical Center",
  "city": "Chicago",
  "region": "IL",
  "iso3": "USA",
  "lat": 41.869,
  "lon": -87.672,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 239,
    "living": 62,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 48,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 22,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "bel-uz-leuven",
  "name": "Universitaire Ziekenhuizen Leuven (UZ Leuven)",
  "short": "UZ Leuven",
  "city": "Leuven",
  "region": "Vlaams-Brabant",
  "iso3": "BEL",
  "lat": 50.8798,
  "lon": 4.7005,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 121,
    "living": 21,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 77,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 34,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 75,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "HILA laboratory with strong molecular immunogenetics. Accreditation: EFI.",
  "note": "The most important single account in Belgium and arguably in the whole region for a rejection-surveillance assay. Maarten Naesens's group at KU Leuven leads European work on transplant biopsy phenotyping, rejection nomenclature and the Banff process, and coordinates EU-funded consortia in this exact space. A validation collaboration here is worth more than several countries of early sales.",
  "source": "rest_europe"
 },
 {
  "id": "fra-toulouse-rangueil",
  "name": "CHU de Toulouse - Hopital Rangueil, Departement de Nephrologie et Transplantation d'Organes",
  "short": "Toulouse Rangueil",
  "city": "Toulouse",
  "region": "Occitanie",
  "iso3": "FRA",
  "lat": 43.6047,
  "lon": 1.4442,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 236,
    "living": 55,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 13,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 60,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 2367,
   "confidence": "verified",
   "method": "ABM Table R52: estimated number of patients alive with a functioning kidney graft at 31 Dec 2024 by follow-up team. Second largest followed kidney cohort in France. Source https://rams-back.agence-biomedecine.fr/uploads/TOR_52_2024_e38e0b2600.xlsx"
  },
  "tier": 1,
  "labNote": "HLA support is provided by the Toulouse histocompatibility laboratory; the exact operator (CHU department vs EFS Occitanie) was not verified in this session.",
  "note": "The single highest-priority adult kidney account in France on volume, and unusually strong on living donation (55 living donor grafts, second only to Necker). Departmental lead is Prof Nassim Kamar, who is also Vice-President of the Societe Francophone de Transplantation, making this account both a volume target and a national influence target. Toulouse Rangueil is also one of only nine sites in the AP-HP-sponsored AI-CARE dd-cfDNA randomised trial, so the team already has hands-on dd-cfDNA experience. Procurement runs through CHU de Toulouse tenders and the UniHA/RESAH frameworks.",
  "source": "france"
 },
 {
  "id": "esp-hu-12-de-octubre",
  "name": "Hospital Universitario 12 de Octubre",
  "short": "HU 12 de Octubre",
  "city": "Madrid",
  "region": "Comunidad de Madrid",
  "iso3": "ESP",
  "lat": 40.4168,
  "lon": -3.7038,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 176,
    "living": 40,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 62,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 71,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1600,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": "Servicio de Inmunologia operates the Laboratorios de Histocompatibilidad, Inmunogenetica e Inmunologia Celular. Tenders HLA-transplant, monogenic disease and SNP reagents together with serological typing, crossmatch and cell culture material in a SINGLE expediente - a bundled lot a single-assay vendor cannot bid alone. Accreditation: EFI (not confirmed in this pass).",
  "note": "Largest Madrid transplant centre. Kidney 176 (40 living, joint national second-highest living-donor volume), liver 62, lung 71. Immunology service runs the histocompatibility, immunogenetics and cellular immunology laboratories and tenders HLA/SNP reagents as a single contract.",
  "source": "spain"
 },
 {
  "id": "esp-hu-reina-sofia",
  "name": "Hospital Universitario Reina Sofia",
  "short": "HU Reina Sofia",
  "city": "Cordoba",
  "region": "Andalucia",
  "iso3": "ESP",
  "lat": 37.8882,
  "lon": -4.7794,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 99,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 77,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 131,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 900,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": null,
  "note": "Multi-organ centre. Kidney 98 adult + 1 paediatric; liver 67 adult + 10 paediatric. Lung volume 131 in 2024 made it the highest-volume lung programme in Spain that year. Also a long-standing heart programme (heart centre-level table not retrieved).",
  "source": "spain"
 },
 {
  "id": "usa-hackensack-umc",
  "name": "Hackensack University Medical Center",
  "short": "Hackensack UMC",
  "city": "Hackensack",
  "region": "NJ",
  "iso3": "USA",
  "lat": 40.8859,
  "lon": -74.0435,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 295,
    "living": 57,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 7,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-medical-city-dallas-hospital",
  "name": "Medical City Dallas Hospital",
  "short": "Medical City Dallas Hospital",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 235,
    "living": 85,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 46,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 15,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 7,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-froedtert-memorial-lutheran-hospital",
  "name": "Froedtert Memorial Lutheran Hospital",
  "short": "Froedtert Memorial Lutheran Hospital",
  "city": "Milwaukee",
  "region": "WI",
  "iso3": "USA",
  "lat": 43.045,
  "lon": -88.023,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 174,
    "living": 72,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 64,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 23,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 22,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 14,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-uc-medical-center",
  "name": "University of Cincinnati Medical Center",
  "short": "UC Medical Center",
  "city": "Cincinnati",
  "region": "OH",
  "iso3": "USA",
  "lat": 39.1031,
  "lon": -84.512,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 6,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 122,
    "living": 21,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 14,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 145,
    "living": 5,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-inova-fairfax-hospital",
  "name": "Inova Fairfax Hospital",
  "short": "Inova Fairfax Hospital",
  "city": "Falls Church",
  "region": "VA",
  "iso3": "USA",
  "lat": 38.883,
  "lon": -77.19,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 185,
    "living": 43,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 37,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 59,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-padova",
  "name": "Azienda Ospedale - Universita di Padova",
  "short": "Padova",
  "city": "Padua",
  "region": "Veneto",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 193,
    "living": 50,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 88,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 3150,
   "confidence": "estimated",
   "method": "Estimated from cumulative activity (1,998 deceased + 695 living kidney transplants 2000-2022) with graft attrition."
  },
  "tier": 1,
  "labNote": "Immunotrasfusionale/immunogenetics service for the Veneto CRT. Accreditation asserted, not individually verified. Accreditation: EFI.",
  "note": "Veneto purchasing runs through Azienda Zero (the regional central purchasing body for Veneto), which is one of the most centralised regional procurement bodies in Italy. Padova's very large living-donor and paired-exchange activity makes it the strongest Italian site for pre-transplant risk and HLA epitope-matching products.",
  "source": "italy"
 },
 {
  "id": "usa-unc",
  "name": "UNC Medical Center",
  "short": "UNC",
  "city": "Chapel Hill",
  "region": "NC",
  "iso3": "USA",
  "lat": 35.9132,
  "lon": -79.0558,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 17,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 197,
    "living": 30,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 3,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 50,
    "living": 5,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 12,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-university-of-north-carolina-hospitals",
  "name": "University of North Carolina Hospitals",
  "short": "University of North Carolina Hospitals",
  "city": "Chapel Hill",
  "region": "NC",
  "iso3": "USA",
  "lat": 35.904,
  "lon": -79.052,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 197,
    "living": 30,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 50,
    "living": 5,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 17,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 12,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 3,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-university-of-kansas-hospital",
  "name": "University of Kansas Hospital",
  "short": "University of Kansas Hospital",
  "city": "Kansas City",
  "region": "KS",
  "iso3": "USA",
  "lat": 39.056,
  "lon": -94.608,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 169,
    "living": 38,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 60,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 45,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-chu-a-coruna",
  "name": "Complexo Hospitalario Universitario de A Coruna",
  "short": "CHU A Coruna",
  "city": "A Coruna",
  "region": "Galicia",
  "iso3": "ESP",
  "lat": 43.3623,
  "lon": -8.4115,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 147,
    "living": 17,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 64,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 64,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1340,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": null,
  "note": "Multi-organ centre and the Spanish heart transplant reference in Galicia. Host of the 9th SET national congress, June 2026.",
  "source": "spain"
 },
 {
  "id": "aut-medizinische-universitaet-wien-akh",
  "name": "Medizinische Universitaet Wien / AKH",
  "short": "Medizinische Universitaet Wien / AKH",
  "city": "Vienna",
  "region": "",
  "iso3": "AUT",
  "lat": 48.2082,
  "lon": 16.3738,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 97,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 39,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 37,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 101,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "fra-lille-huriez",
  "name": "CHU de Lille - Hopital Claude Huriez, Service de Nephrologie",
  "short": "Lille Huriez",
  "city": "Lille",
  "region": "Hauts-de-France",
  "iso3": "FRA",
  "lat": 50.6292,
  "lon": 3.0573,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 162,
    "living": 17,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 91,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 20,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1940,
   "confidence": "verified",
   "method": "ABM Table R52, adult team; a further 53 at Lille Jeanne de Flandre (paediatric)."
  },
  "tier": 1,
  "labNote": "BEST-DOCUMENTED FRENCH HLA LABORATORY. CHU Lille UF 9874 Histocompatibilite-HLA, within the Institut d'Immunologie. Head: Prof Myriam Labalette, with Dr Isabelle Top and Dr Vincent Elsermans. EFI-ACCREDITED SINCE 2003 (explicitly stated on the institutional page - one of very few French labs where EFI accreditation is directly confirmed rather than inferred). Staffing: 9 technicians (8.5 FTE). Scope: 24/7 organ donor typing and crossmatch, HSCT typing, France Greffe de Moelle registry work, HLA-disease association testing. Techniques span serology through PCR-SSP/SSO/qPCR to NGS. Source: https",
  "note": "Large three-organ centre and a historic French centre for pancreatic islet transplantation. Its HLA laboratory is the most transparently documented in France and is one of the few with directly confirmed EFI accreditation (since 2003) - which matters because EFI accreditation is a precondition for billing the LAHN NGS typing and chimerism acts. Prof Marc Hazzan, long the senior transplant nephrologist here, has moved to be Dean of the UFR3S faculty at Universite de Lille, so he is now a strategic/academic contact rather than the day-to-day clinical decision maker; the current head of service should be re-confirmed before outreach. For the laboratory sale, Prof Myriam Labalette is the contact.",
  "source": "france"
 },
 {
  "id": "usa-cleveland-clinic-weston",
  "name": "Cleveland Clinic Florida - Weston",
  "short": "Cleveland Clinic Weston",
  "city": "Weston",
  "region": "FL",
  "iso3": "USA",
  "lat": 39.5,
  "lon": -98.0,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 34,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 145,
    "living": 21,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 93,
    "living": 4,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "esp-h-clinic-barcelona",
  "name": "Hospital Clinic de Barcelona",
  "short": "H Clinic Barcelona",
  "city": "Barcelona",
  "region": "Cataluna",
  "iso3": "ESP",
  "lat": 41.3874,
  "lon": 2.1686,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 191,
    "living": 40,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 78,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1740,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": "The Servei d'Immunologia has tendered HLA reagents jointly for the hospital AND for the Banc de Sang i Teixits (BOE-B-2018-15059), so one award can cover a hospital and the Catalan regional blood bank. Largest single HLA prize in Catalonia. Accreditation: EFI (assumed for a reference H&I laboratory; not confirmed in this pass).",
  "note": "Kidney 191 (40 living) and liver 78 in 2024. Historic leader of the national paired kidney exchange programme (72 crossover transplants cumulative, the most of any Spanish centre). Immunology department is the reference HLA laboratory jointly with the Banc de Sang i Teixits.",
  "source": "spain"
 },
 {
  "id": "fra-montpellier-lapeyronie",
  "name": "CHU de Montpellier - Hopital Lapeyronie, Departement de Nephrologie-Transplantation",
  "short": "Montpellier Lapeyronie",
  "city": "Montpellier",
  "region": "Occitanie",
  "iso3": "FRA",
  "lat": 43.6108,
  "lon": 3.8767,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 171,
    "living": 26,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 74,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 19,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 3,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 2102,
   "confidence": "verified",
   "method": "ABM Table R52, adult team; a further 28 at Montpellier Arnaud de Villeneuve (paediatric)."
  },
  "tier": 1,
  "labNote": "Montpellier is historically important in French laboratory pricing: the 'V5 de Montpellier' referential is one of the named tariff referentials used across French histocompatibility laboratories alongside RIHN/LAHN and NABM.",
  "note": "A top-five kidney centre with a very high DCD Maastricht III fraction (40 of 171), which matters commercially because DCD grafts have higher delayed-graft-function and early-injury rates and therefore a stronger clinical rationale for early molecular surveillance. Departmental head is Prof Moglie Le Quintrec (INSERM U1183/IRMB), whose research focus is complement-mediated injury and antibody-mediated rejection. Montpellier is also an AI-CARE dd-cfDNA trial site (CHU Montpellier Saint-Eloi).",
  "source": "france"
 },
 {
  "id": "fra-strasbourg-hopital-civil",
  "name": "Hopitaux Universitaires de Strasbourg - Nouvel Hopital Civil, Service de Nephrologie-Dialyse-Transplantation",
  "short": "Strasbourg Hopital Civil",
  "city": "Strasbourg",
  "region": "Grand Est",
  "iso3": "FRA",
  "lat": 48.5734,
  "lon": 7.7521,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 108,
    "living": 22,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 111,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 16,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 30,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1415,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 1,
  "labNote": "EFS Grand Est is understood to operate the regional histocompatibility laboratory. Not verified.",
  "note": "A genuine four-organ centre with strong balance across kidney, liver, heart and lung - unusual outside Paris and Lyon, and therefore efficient to sell into as one account with four organ-level use cases. Prof Sophie Caillard is the leading transplant nephrologist here with a large publication record in kidney transplant immunology; Prof Bruno Moulin is the other senior figure.",
  "source": "france"
 },
 {
  "id": "pol-uck-gdansk",
  "name": "Uniwersyteckie Centrum Kliniczne w Gdansku",
  "short": "UCK Gdansk",
  "city": "Gdansk",
  "region": "Pomorskie",
  "iso3": "POL",
  "lat": 54.352,
  "lon": 18.6466,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 125,
    "living": 17,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 75,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 16,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 48,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": "Poland's very low living-donor share (82 of about 1,214 kidney transplants, under 7%) is the defining feature of this market and contrasts sharply with the Netherlands (43%) and Turkey (75-80%). It means Polish recipients are overwhelmingly deceased-donor, often extended-criteria, and therefore a higher-risk surveillance population. Financing for the transplant pathway runs partly through the Ministry of Health's national transplantation programme via Poltransplant rather than purely through NFZ, so Poltransplant is the first door.",
  "source": "rest_europe"
 },
 {
  "id": "esp-hu-bellvitge",
  "name": "Hospital Universitari de Bellvitge",
  "short": "HU Bellvitge",
  "city": "L'Hospitalet de Llobregat",
  "region": "Cataluna",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 205,
    "living": 49,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 53,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1870,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": null,
  "note": "ONT named Bellvitge the hospital with the most kidney transplants AND the most living-donor kidney transplants in Spain in 2025. 49 living-donor kidney transplants in 2024 was the national maximum. Part of ICS.",
  "source": "spain"
 },
 {
  "id": "esp-hu-virgen-del-rocio",
  "name": "Hospital Universitario Virgen del Rocio",
  "short": "HU Virgen del Rocio",
  "city": "Sevilla",
  "region": "Andalucia",
  "iso3": "ESP",
  "lat": 37.3891,
  "lon": -5.9845,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 178,
    "living": 20,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 78,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1620,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": null,
  "note": "Kidney 160 adult + 18 paediatric. One of the very few Spanish centres transplanting every solid organ including paediatric heart.",
  "source": "spain"
 },
 {
  "id": "fra-rennes",
  "name": "CHU de Rennes, Service de Nephrologie-Transplantation and Service de Chirurgie Hepatobiliaire",
  "short": "Rennes",
  "city": "Rennes",
  "region": "Bretagne",
  "iso3": "FRA",
  "lat": 48.1173,
  "lon": -1.6778,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 96,
    "living": 10,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 132,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 23,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1234,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 1,
  "labNote": "EFS Bretagne. Virginie Renac, SFHI Treasurer, is understood to be associated with the Rennes/Bretagne immunogenetics laboratory but this was NOT verified.",
  "note": "Second-largest French liver centre and the fastest-growing kidney programme (+45.5%). Growth is a useful sales signal: a programme expanding this fast is usually also re-tooling its follow-up pathways. No current Rennes transplant nephrology lead could be identified in this session - a named gap.",
  "source": "france"
 },
 {
  "id": "usa-temple",
  "name": "Temple University Hospital",
  "short": "Temple",
  "city": "Philadelphia",
  "region": "PA",
  "iso3": "USA",
  "lat": 39.9526,
  "lon": -75.1652,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 6,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 59,
    "living": 22,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 6,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 178,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-ummc",
  "name": "University of Maryland Medical Center",
  "short": "UMMC",
  "city": "Baltimore",
  "region": "MD",
  "iso3": "USA",
  "lat": 39.2904,
  "lon": -76.6122,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 13,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 126,
    "living": 34,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 10,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 84,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 15,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-university-of-maryland-medical-system",
  "name": "University of Maryland Medical System",
  "short": "University of Maryland Medical System",
  "city": "Baltimore",
  "region": "MD",
  "iso3": "USA",
  "lat": 39.288,
  "lon": -76.623,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 126,
    "living": 34,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 84,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 13,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 15,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 10,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "fra-tours-bretonneau",
  "name": "CHU de Tours - Hopital Bretonneau, Service de Nephrologie et Immunologie Clinique",
  "short": "Tours Bretonneau",
  "city": "Tours",
  "region": "Centre-Val de Loire",
  "iso3": "FRA",
  "lat": 47.3941,
  "lon": 0.6848,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 132,
    "living": 16,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 104,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 11,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1587,
   "confidence": "verified",
   "method": "ABM Table R52; a further 19 at Tours Clocheville (paediatric)."
  },
  "tier": 1,
  "labNote": "Not verified.",
  "note": "A mid-size three-organ centre that punches above its weight in clinical trials. Prof Matthias Buchler heads Kidney Transplantation and Clinical Immunology and is an active investigator in multicentre immunosuppression RCTs, which makes Tours a realistic site for a French pivotal or registry study without the political complexity of AP-HP.",
  "source": "france"
 },
 {
  "id": "usa-beth-israel-deaconess-medical-center",
  "name": "Beth Israel Deaconess Medical Center",
  "short": "Beth Israel Deaconess Medical Center",
  "city": "Boston",
  "region": "MA",
  "iso3": "USA",
  "lat": 42.339,
  "lon": -71.106,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 79,
    "living": 23,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 121,
    "living": 10,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 32,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 8,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-ohsu",
  "name": "Oregon Health & Science University Hospital",
  "short": "OHSU",
  "city": "Portland",
  "region": "OR",
  "iso3": "USA",
  "lat": 45.5152,
  "lon": -122.6784,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 13,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 132,
    "living": 28,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 92,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-strong-memorial-hospital-university-of",
  "name": "Strong Memorial Hospital, University of Rochester Medical Center",
  "short": "Strong Memorial Hospital, University of Roch",
  "city": "NY",
  "region": "NY",
  "iso3": "USA",
  "lat": 42.9,
  "lon": -75.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 126,
    "living": 46,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 88,
    "living": 16,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 20,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 3,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-swedish-medical-center",
  "name": "Swedish Medical Center",
  "short": "Swedish Medical Center",
  "city": "Seattle",
  "region": "WA",
  "iso3": "USA",
  "lat": 47.609,
  "lon": -122.321,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 130,
    "living": 18,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 102,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 3,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-hu-cruces",
  "name": "Hospital Universitario de Cruces",
  "short": "HU Cruces",
  "city": "Barakaldo",
  "region": "Pais Vasco",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 161,
    "living": 18,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 73,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1470,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": null,
  "note": "Kidney 153 adult + 8 paediatric, liver 73. The Basque multi-organ reference centre; part of Osakidetza, which procures regionally through contratacion.euskadi.eus.",
  "source": "spain"
 },
 {
  "id": "usa-university-of-kentucky-medical-center",
  "name": "University of Kentucky Medical Center",
  "short": "University of Kentucky Medical Center",
  "city": "Lexington",
  "region": "KY",
  "iso3": "USA",
  "lat": 38.032,
  "lon": -84.509,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 119,
    "living": 38,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 80,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 20,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 14,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-university-of-california-irvine-medica",
  "name": "University of California Irvine Medical Center",
  "short": "University of California Irvine Medical Cent",
  "city": "Orange",
  "region": "CA",
  "iso3": "USA",
  "lat": 33.788,
  "lon": -117.889,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 227,
    "living": 22,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 6,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-methodist-university-hospital",
  "name": "Methodist University Hospital",
  "short": "Methodist University Hospital",
  "city": "Memphis",
  "region": "TN",
  "iso3": "USA",
  "lat": 35.14,
  "lon": -90.027,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 169,
    "living": 16,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 46,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 11,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-integris-baptist-medical-center",
  "name": "Integris Baptist Medical Center",
  "short": "Integris Baptist Medical Center",
  "city": "Oklahoma City",
  "region": "OK",
  "iso3": "USA",
  "lat": 35.517,
  "lon": -97.554,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 91,
    "living": 23,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 89,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 17,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 22,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-methodist-dallas-medical-center",
  "name": "Methodist Dallas Medical Center",
  "short": "Methodist Dallas Medical Center",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 152,
    "living": 22,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 69,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 3,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "fra-marseille-conception",
  "name": "AP-HM Hopital de la Conception - Centre de Nephrologie et Transplantation Renale",
  "short": "Marseille Conception",
  "city": "Marseille",
  "region": "Provence-Alpes-Cote d'Azur",
  "iso3": "FRA",
  "lat": 43.2965,
  "lon": 5.3698,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 145,
    "living": 27,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 78,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1683,
   "confidence": "verified",
   "method": "ABM Table R52, adult team; a further 47 at Marseille La Timone enfants."
  },
  "tier": 1,
  "labNote": "EFS PACA-Corse operates a histocompatibility laboratory publishing a public manuel de prelevement (https://efs-pac.manuelprelevement.fr/). The precise set of transplant centres it serves was not verified.",
  "note": "The highest-DCD centre in France on both kidney (43) and liver (30). That donor mix is the strongest clinical argument in the country for early post-transplant molecular injury monitoring, because DCD grafts carry more ischaemia-reperfusion injury and delayed graft function - which is also the main confounder any dd-cfDNA assay must handle. Marseille is therefore both the best clinical-need story and the toughest analytical test case. Dr Valerie Moal is medical director of the kidney transplant activity; Dr Marion Sallee is an active researcher in the unit. Separately, AP-HM Hopital Nord is France's highest-volume lung transplant site after Foch (45 grafts).",
  "source": "france"
 },
 {
  "id": "deu-transplantationszentrum-munchen-gh",
  "name": "Transplantationszentrum Munchen GH",
  "short": "Munchen GH",
  "city": "Munchen GH",
  "region": "",
  "iso3": "DEU",
  "lat": 48.1351,
  "lon": 11.582,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 57,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 65,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 28,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 68,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "swe-karolinska",
  "name": "Karolinska Universitetssjukhuset - Transplantationscentrum",
  "short": "Karolinska",
  "city": "Stockholm/Huddinge",
  "region": "Stockholm",
  "iso3": "SWE",
  "lat": 59.3293,
  "lon": 18.0686,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 132,
    "living": 32,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 83,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 6,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Accreditation: EFI.",
  "note": "Sweden's largest and most internationally visible transplant centre, part of the first cross-Scandinavian kidney exchange programme (STEP). Gabriel Oniscu, ESOT Past President 2025-2027, is Professor of Transplantation Surgery here. The single best Nordic account for scientific credibility.",
  "source": "rest_europe"
 },
 {
  "id": "swe-karolinska-universitetssjukhuset-huddi",
  "name": "Karolinska Universitetssjukhuset Huddinge",
  "short": "Karolinska Universitetssjukhuset Huddinge",
  "city": "Stockholm",
  "region": "",
  "iso3": "SWE",
  "lat": 59.3293,
  "lon": 18.0686,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 132,
    "living": 32,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 83,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 6,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "prt-uls-sao-jose-hospital-curry-cabral",
  "name": "ULS Sao Jose (Hospital Curry Cabral)",
  "short": "ULS Sao Jose (Hospital Curry Cabral)",
  "city": "Lisbon",
  "region": "",
  "iso3": "PRT",
  "lat": 38.7223,
  "lon": -9.1393,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 89,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 115,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 15,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "fra-nantes-itun",
  "name": "CHU de Nantes - Institut de Transplantation Urologie-Nephrologie (ITUN)",
  "short": "Nantes ITUN",
  "city": "Nantes",
  "region": "Pays de la Loire",
  "iso3": "FRA",
  "lat": 47.2184,
  "lon": -1.5536,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 161,
    "living": 18,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 13,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 28,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 15,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 2284,
   "confidence": "verified",
   "method": "ABM Table R52 (Nantes A+P), plus a further 70 on the separate paediatric line. Third largest followed kidney cohort in France."
  },
  "tier": 1,
  "labNote": "Not verified.",
  "note": "The most research-dense transplant account in France after Paris. ITUN sits alongside CR2TI (Centre de Recherche en Transplantation et Immunologie Translationnelle, INSERM UMR 1064), directed by Prof Regis Josien, with Prof Sophie Brouard (biomarkers and operational tolerance) and Prof Magali Giral co-leading Team 4. Critically, Nantes runs DIVAT, the French multicentre transplant cohort and biobank - the natural French data asset for validating a new surveillance biomarker. Prof Gilles Blancho is the other senior figure. If Scira needs a French clinical-validation partner rather than a first commercial sale, Nantes is the answer.",
  "source": "france"
 },
 {
  "id": "usa-uams",
  "name": "University of Arkansas for Medical Sciences Medical Center",
  "short": "UAMS",
  "city": "Little Rock",
  "region": "AR",
  "iso3": "USA",
  "lat": 34.7465,
  "lon": -92.2896,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 168,
    "living": 18,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 48,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "dnk-rigshospitalet",
  "name": "Rigshospitalet, Copenhagen University Hospital",
  "short": "Rigshospitalet",
  "city": "Copenhagen",
  "region": "Hovedstaden",
  "iso3": "DNK",
  "lat": 55.6761,
  "lon": 12.5683,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 96,
    "living": 31,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 58,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 20,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 40,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Danish national tissue typing sits within Rigshospitalet's Department of Clinical Immunology. Accreditation: EFI.",
  "note": "Denmark's dominant centre and the only Danish heart/lung programme. With Aarhus it accounts for essentially all Danish kidney transplantation. A Behandlingsradet evaluation plus Rigshospitalet endorsement would decide the Danish market in one move. Note Denmark's sharp 2024 expansion of cDCD kidney transplantation (9.0 pmp, up from 2.0 pmp in 2023).",
  "source": "rest_europe"
 },
 {
  "id": "esp-hcu-virgen-de-la-arrixaca",
  "name": "Hospital Clinico Universitario Virgen de la Arrixaca",
  "short": "HCU Virgen de la Arrixaca",
  "city": "El Palmar, Murcia",
  "region": "Region de Murcia",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 135,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 79,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1230,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": "Hosts the Regional Laboratory of Histocompatibility and Transplant Immunology for Murcia, directed by Manuel Muro alongside the hospital Immunology Service. Combines a regional reference laboratory with Spain's highest-donating hospital and a 135-per-year kidney programme. Accreditation: EFI (not confirmed in this pass).",
  "note": "ONT named Arrixaca the hospital with the most organ donors in Spain in 2025. Multi-organ including paediatric heart.",
  "source": "spain"
 },
 {
  "id": "ita-bologna-sant-orsola",
  "name": "IRCCS Azienda Ospedaliero-Universitaria di Bologna, Policlinico di Sant'Orsola",
  "short": "Bologna Sant'Orsola",
  "city": "Bologna",
  "region": "Emilia-Romagna",
  "iso3": "ITA",
  "lat": 44.4949,
  "lon": 11.3426,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 121,
    "living": 39,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 93,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 2500,
   "confidence": "estimated",
   "method": "Estimated from 1,685 cumulative deceased-donor kidney transplants 2000-2022 plus 272 living, with attrition."
  },
  "tier": 1,
  "labNote": "Emilia-Romagna reference immunogenetics laboratory; also historic AIRT headquarters city. Accreditation: EFI.",
  "note": "Emilia-Romagna procures through Intercent-ER, the regional central purchasing body, which runs formal e-tenders with published award criteria. Emilia-Romagna is also one of the most active Italian regions for regional HTA and for adding codes to the regional nomenclatore, so it is a good first region to seek a regional tariff.",
  "source": "italy"
 },
 {
  "id": "usa-memorial-healthcare",
  "name": "Memorial Regional Hospital",
  "short": "Memorial Healthcare",
  "city": "Hollywood",
  "region": "FL",
  "iso3": "USA",
  "lat": 39.5,
  "lon": -98.0,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 29,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 181,
    "living": 42,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-thomas-jefferson-university-hospital",
  "name": "Thomas Jefferson University Hospital",
  "short": "Thomas Jefferson University Hospital",
  "city": "Philadelphia",
  "region": "PA",
  "iso3": "USA",
  "lat": 39.949,
  "lon": -75.158,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 99,
    "living": 20,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 81,
    "living": 7,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 20,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 9,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-wake-forest-baptist-medical-center",
  "name": "Wake Forest Baptist Medical Center",
  "short": "Wake Forest Baptist Medical Center",
  "city": "Winston-Salem",
  "region": "NC",
  "iso3": "USA",
  "lat": 36.093,
  "lon": -80.262,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 169,
    "living": 29,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 29,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 12,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "aut-medizinische-universitaet-innsbruck-lk",
  "name": "Medizinische Universitaet Innsbruck (LKH-Universitaetsklinikum)",
  "short": "Medizinische Universitaet Innsbruck (LKH-Uni",
  "city": "Innsbruck",
  "region": "",
  "iso3": "AUT",
  "lat": 47.2692,
  "lon": 11.4041,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 105,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 68,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 13,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 5,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 11,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-tulane-medical-center",
  "name": "Tulane Medical Center",
  "short": "Tulane Medical Center",
  "city": "New Orleans",
  "region": "LA",
  "iso3": "USA",
  "lat": 29.955,
  "lon": -90.079,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 150,
    "living": 25,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 35,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 11,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-saint-thomas-hospital",
  "name": "Saint Thomas Hospital",
  "short": "Saint Thomas Hospital",
  "city": "Nashville",
  "region": "TN",
  "iso3": "USA",
  "lat": 36.152,
  "lon": -86.806,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 164,
    "living": 16,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 37,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "sau-kfshrc-riyadh",
  "name": "King Faisal Specialist Hospital & Research Centre, Riyadh - Organ Transplant Centre of Excellence",
  "short": "KFSHRC Riyadh",
  "city": "Riyadh",
  "region": "Riyadh Province",
  "iso3": "SAU",
  "lat": 24.7136,
  "lon": 46.6753,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2023,
    "total": 200,
    "living": null,
    "confidence": "estimated"
   }
  ],
  "prevalentGrafts": {
   "value": 3300,
   "confidence": "estimated",
   "method": "Very rough. Derived from >5,000 lifetime kidney transplants at this centre, applying a crude 50% still-functioning-and-followed-here assumption. Not verified. Treat as an order-of-magnitude planning number only."
  },
  "tier": 1,
  "labNote": "KFSHRC holds CAP accreditation alongside JCI, ANCC Magnet and HIMSS Stage 7. Its Department of Pathology and Laboratory Medicine contains an Immunopathology division comprising immunology, HLA, HLA-DNA and cellular immunology, and the hospital describes itself as the leading HLA testing centre in the Kingdom for renal transplant. EFI or ASHI accreditation status was NOT confirmed and should not be assumed. Accreditation: CAP, JCI.",
  "note": "The flagship account for the region. Autonomous of MOH, which historically gave it more direct purchasing latitude than cluster hospitals, though it still uses NUPCO for many categories. Strong research infrastructure (Research Centre) makes it the obvious site for a validation or early-access study. CAP accreditation means US-style assay documentation lands well here.",
  "source": "gulf"
 },
 {
  "id": "ita-pisa",
  "name": "Azienda Ospedaliero-Universitaria Pisana / Ospedale Cisanello",
  "short": "Pisa",
  "city": "Pisa",
  "region": "Toscana",
  "iso3": "ITA",
  "lat": 43.7228,
  "lon": 10.4017,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 55,
    "living": 9,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 142,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 2200,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 1,
  "labNote": "Toscana operates a regional immunogenetics network under the Toscana CRT (Organizzazione Toscana Trapianti). Lab-to-centre mapping asserted, not verified. Accreditation: EFI.",
  "note": "Toscana purchases through ESTAR (Ente di Supporto Tecnico-Amministrativo Regionale), a single region-wide purchasing body that runs all diagnostics tenders for Tuscan hospitals. Winning ESTAR wins the whole region in one award. Pisa is the natural Italian beachhead for a liver-transplant dd-cfDNA application.",
  "source": "italy"
 },
 {
  "id": "usa-university-of-toledo-medical-center",
  "name": "University of Toledo Medical Center",
  "short": "University of Toledo Medical Center",
  "city": "OH",
  "region": "OH",
  "iso3": "USA",
  "lat": 40.3,
  "lon": -82.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 193,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "fra-paris-necker-adult",
  "name": "Hopital Necker-Enfants Malades (AP-HP), Service de Nephrologie-Transplantation renale adultes",
  "short": "Paris Necker (adult)",
  "city": "Paris",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 48.8566,
  "lon": 2.3522,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 193,
    "living": 58,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 2414,
   "confidence": "verified",
   "method": "ABM Table R52. The LARGEST followed kidney graft cohort of any French centre at 31 Dec 2024. Source https://rams-back.agence-biomedecine.fr/uploads/TOR_52_2024_e38e0b2600.xlsx"
  },
  "tier": 1,
  "labNote": "Necker's histocompatibility support sits within the AP-HP Paris network; the Saint-Louis HLA laboratory is the dominant AP-HP immunogenetics facility. Not fully verified.",
  "note": "The most strategically important single account in France, and not because of volume alone. Necker hosts the largest followed kidney cohort in the country (2,414 patients), is the clinical home of the Paris Transplant Group and Alexandre Loupy's INSERM U970 team, is an AI-CARE dd-cfDNA trial site, and was one of the two French recruiting centres for the published head-to-head comparison of CareDx AlloSure (centralised) and AlloSeq cfDNA (decentralised). Current head of service is Prof Dany Anglicheau, who also directs the Necker transplant biobank. Any French dd-cfDNA strategy that does not have a Necker position is a strategy competing against Necker.",
  "source": "france"
 },
 {
  "id": "fra-villejuif-paul-brousse",
  "name": "Hopital Paul Brousse (AP-HP), Centre Hepato-Biliaire",
  "short": "Villejuif Paul Brousse",
  "city": "Villejuif",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 48.7939,
  "lon": 2.3594,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "liver",
    "year": 2024,
    "total": 158,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 31,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Not verified.",
  "note": "The lead French liver account and the lead pancreas account. The Centre Hepato-Biliaire at Paul Brousse is one of the largest liver transplant programmes in Europe. Commercially, liver is the weakest organ for dd-cfDNA (high background hepatocyte turnover, rejection managed clinically and biochemically) but the strongest for chimerism-adjacent and tolerance work, and Paul Brousse has a long-standing operational tolerance research interest.",
  "source": "france"
 },
 {
  "id": "usa-banner-university-medical-center-phoen",
  "name": "Banner-University Medical Center Phoenix",
  "short": "Banner-University Medical Center Phoenix",
  "city": "AZ",
  "region": "AZ",
  "iso3": "USA",
  "lat": 34.2,
  "lon": -111.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 80,
    "living": 19,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 68,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 35,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-rush",
  "name": "Rush University Medical Center",
  "short": "Rush",
  "city": "Chicago",
  "region": "IL",
  "iso3": "USA",
  "lat": 41.8781,
  "lon": -87.6298,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 118,
    "living": 20,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 62,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-university-medical-center-of-southern",
  "name": "University Medical Center of Southern Nevada",
  "short": "University Medical Center of Southern Nevada",
  "city": "Las Vegas",
  "region": "NV",
  "iso3": "USA",
  "lat": 36.159,
  "lon": -115.152,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 179,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 6,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-university-of-mississippi-medical-cent",
  "name": "University of Mississippi Medical Center",
  "short": "University of Mississippi Medical Center",
  "city": "Jackson",
  "region": "MS",
  "iso3": "USA",
  "lat": 32.33,
  "lon": -90.177,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 135,
    "living": 18,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 37,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 8,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "prt-uls-coimbra-chu-coimbra",
  "name": "ULS Coimbra (CHU Coimbra)",
  "short": "ULS Coimbra (CHU Coimbra)",
  "city": "Coimbra",
  "region": "",
  "iso3": "PRT",
  "lat": 40.2033,
  "lon": -8.4103,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 94,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 74,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 15,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-westchester-medical-center",
  "name": "Westchester Medical Center",
  "short": "Westchester Medical Center",
  "city": "Valhalla",
  "region": "NY",
  "iso3": "USA",
  "lat": 41.087,
  "lon": -73.802,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 80,
    "living": 15,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 86,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 17,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-tufts-medical-center",
  "name": "Tufts Medical Center",
  "short": "Tufts Medical Center",
  "city": "Boston",
  "region": "MA",
  "iso3": "USA",
  "lat": 42.35,
  "lon": -71.063,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 68,
    "living": 17,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 47,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 63,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-allegheny-general-hospital",
  "name": "Allegheny General Hospital",
  "short": "Allegheny General Hospital",
  "city": "Pittsburgh",
  "region": "PA",
  "iso3": "USA",
  "lat": 40.456,
  "lon": -80.008,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 95,
    "living": 21,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 63,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 18,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-niguarda",
  "name": "ASST Grande Ospedale Metropolitano Niguarda",
  "short": "Niguarda",
  "city": "Milan",
  "region": "Lombardia",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 82,
    "living": 14,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 94,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 2700,
   "confidence": "estimated",
   "method": "Estimated from cumulative CNT activity with attrition."
  },
  "tier": 1,
  "labNote": "Niguarda has its own transplant immunology laboratory but sits inside the NITp immunogenetics framework coordinated from Policlinico Milano. Accreditation: EFI.",
  "note": "Lombardia purchases through ARIA S.p.A. (Azienda Regionale per l'Innovazione e gli Acquisti), which runs the regional framework agreements almost all Lombard hospitals must use. Niguarda is a multi-organ, high-acuity centre and the strongest single Lombard clinical reference for a rejection-surveillance product.",
  "source": "italy"
 },
 {
  "id": "usa-hartford-hospital",
  "name": "Hartford Hospital",
  "short": "Hartford Hospital",
  "city": "Hartford",
  "region": "CT",
  "iso3": "USA",
  "lat": 41.753,
  "lon": -72.682,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 103,
    "living": 44,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 30,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 41,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-lahey-clinic-medical-center",
  "name": "Lahey Clinic Medical Center",
  "short": "Lahey Clinic Medical Center",
  "city": "Burlington",
  "region": "MA",
  "iso3": "USA",
  "lat": 42.496,
  "lon": -71.205,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 64,
    "living": 16,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 107,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "pol-spsk-im-a-mieleckiego-sum-w-katowicach",
  "name": "SPSK im. A. Mieleckiego SUM w Katowicach",
  "short": "SPSK im. A. Mieleckiego SUM w Katowicach",
  "city": "Katowice",
  "region": "",
  "iso3": "POL",
  "lat": 50.2649,
  "lon": 19.0238,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 120,
    "living": 5,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 50,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-yale-new-haven",
  "name": "Yale New Haven Hospital",
  "short": "Yale New Haven",
  "city": "New Haven",
  "region": "CT",
  "iso3": "USA",
  "lat": 41.3083,
  "lon": -72.9279,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 15,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 114,
    "living": 32,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 40,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-bwh",
  "name": "Brigham and Women's Hospital",
  "short": "BWH",
  "city": "Boston",
  "region": "MA",
  "iso3": "USA",
  "lat": 42.3601,
  "lon": -71.0589,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 40,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 71,
    "living": 32,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 56,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "fra-le-kremlin-bicetre",
  "name": "Hopital Bicetre (AP-HP), Service de Nephrologie-Dialyse-Transplantation",
  "short": "Le Kremlin-Bicetre",
  "city": "Le Kremlin-Bicetre",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 48.8099,
  "lon": 2.3611,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 130,
    "living": 21,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 37,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 963,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 1,
  "labNote": "Not verified.",
  "note": "AP-HP Paris-Saclay transplant hub, an AI-CARE dd-cfDNA trial site, and paired with Paul Brousse for the largest French pancreas programme. Prof Antoine Durrbach (PU-PH, Universite Paris-Saclay) works here on sensitised-patient and combined-organ transplantation - directly relevant to the pre-transplant risk pillar. France's single intestinal transplant in 2024 is likely but NOT verified to have been performed here.",
  "source": "france"
 },
 {
  "id": "usa-lehigh-valley-hospital",
  "name": "Lehigh Valley Hospital",
  "short": "Lehigh Valley Hospital",
  "city": "Allentown",
  "region": "PA",
  "iso3": "USA",
  "lat": 40.599,
  "lon": -75.514,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 139,
    "living": 33,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 23,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "fra-grenoble",
  "name": "CHU Grenoble Alpes, Service de Nephrologie-Hemodialyse-Transplantation",
  "short": "Grenoble",
  "city": "Grenoble",
  "region": "Auvergne-Rhone-Alpes",
  "iso3": "FRA",
  "lat": 45.1885,
  "lon": 5.7245,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 132,
    "living": 28,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 34,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1733,
   "confidence": "verified",
   "method": "ABM Table R52. Note the followed cohort (1,733) is large relative to annual volume, indicating a long-established programme."
  },
  "tier": 1,
  "labNote": "Not verified.",
  "note": "Fast-growing kidney programme and one of only three French centres performing uncontrolled DCD (Maastricht I-II) kidney transplants, alongside Lyon and Saint-Etienne. Marginal grafts of this kind are the clearest use case for early molecular injury monitoring.",
  "source": "france"
 },
 {
  "id": "ita-other-kidney-centres",
  "name": "Other authorised Italian kidney transplant centres (smaller programmes)",
  "short": "Other kidney centres",
  "city": "various",
  "region": "various",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 165,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 2200,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 1,
  "labNote": null,
  "note": "Italy authorises roughly 40 adult kidney transplant centres, of which only about 15 exceed 50 transplants a year. Below that threshold a centre is unlikely to justify an on-site platform and should be served by a hub-and-spoke send-out model.",
  "source": "italy"
 },
 {
  "id": "usa-umass-memorial-medical-center",
  "name": "UMass Memorial Medical Center",
  "short": "UMass Memorial Medical Center",
  "city": "Worcester",
  "region": "MA",
  "iso3": "USA",
  "lat": 42.262,
  "lon": -71.796,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 102,
    "living": 11,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 63,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "prt-uls-santo-antonio-hospital-de-santo-an",
  "name": "ULS Santo Antonio (Hospital de Santo Antonio)",
  "short": "ULS Santo Antonio (Hospital de Santo Antonio",
  "city": "Porto",
  "region": "",
  "iso3": "PRT",
  "lat": 41.1579,
  "lon": -8.6291,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 104,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 49,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "esp-hu-marques-de-valdecilla",
  "name": "Hospital Universitario Marques de Valdecilla",
  "short": "HU Marques de Valdecilla",
  "city": "Santander",
  "region": "Cantabria",
  "iso3": "ESP",
  "lat": 43.4623,
  "lon": -3.81,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 82,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 16,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 54,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 750,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": null,
  "note": "Multi-organ centre in the region with the highest donation rate in the world (Cantabria 103.4 pmp in 2025). ONT named Valdecilla the hospital with the most DCD donors in Spain in 2025.",
  "source": "spain"
 },
 {
  "id": "pol-sp-wojewodzki-szpital-zespolony-w-szcz",
  "name": "SP Wojewodzki Szpital Zespolony w Szczecinie",
  "short": "SP Wojewodzki Szpital Zespolony w Szczecinie",
  "city": "Szczecin",
  "region": "",
  "iso3": "POL",
  "lat": 53.4285,
  "lon": 14.5528,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 70,
    "living": 10,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 78,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-norton-thoracic",
  "name": "St Joseph's Hospital and Medical Center / Norton Thoracic Institute",
  "short": "Norton Thoracic",
  "city": "Phoenix",
  "region": "AZ",
  "iso3": "USA",
  "lat": 33.4484,
  "lon": -112.074,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 49,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 21,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 80,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "deu-heidelberg",
  "name": "Universitatsklinikum Heidelberg - Transplantationszentrum",
  "short": "Heidelberg",
  "city": "Heidelberg",
  "region": "Baden-Wurttemberg",
  "iso3": "DEU",
  "lat": 49.3988,
  "lon": 8.6724,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 150,
    "living": null,
    "confidence": "estimated"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Heidelberg's Institute of Immunology houses a historically very significant transplantation immunology group (the Collaborative Transplant Study, one of the largest international transplant outcome databases, is run from Heidelberg). Accreditation: EFI.",
  "note": "Strategically important beyond its volume because of the Collaborative Transplant Study and a long tradition of HLA matching research. A partnership framed around evidence generation rather than test sales is more likely to land here.",
  "source": "rest_europe"
 },
 {
  "id": "usa-centura-porter-adventist-hospital",
  "name": "Centura Porter Adventist Hospital",
  "short": "Centura Porter Adventist Hospital",
  "city": "Denver",
  "region": "CO",
  "iso3": "USA",
  "lat": 39.679,
  "lon": -104.98,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 120,
    "living": 45,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 29,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "fra-suresnes-foch",
  "name": "Hopital Foch",
  "short": "Suresnes Foch",
  "city": "Suresnes",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 48.8712,
  "lon": 2.2295,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "lung",
    "year": 2024,
    "total": 74,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2024,
    "total": 75,
    "living": 13,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 947,
   "confidence": "verified",
   "method": "ABM Table R52. No equivalent per-centre prevalence table exists for lung, so the followed lung cohort - commercially the more interesting number here - is unknown."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "The obvious beachhead for a LUNG dd-cfDNA product in France and a structurally unusual account: Foch is an ESPIC, a private non-profit, not part of AP-HP or a CHU. That matters commercially in two ways. It is not bound into AP-HP central purchasing, so a direct commercial relationship is possible and decisions are faster; but it also receives MERRI funding on a different basis from a CHU, so the LAHN/MERRI G03 route to paying for an out-of-nomenclature act needs to be checked specifically for Foch rather than assumed. Lung transplantation also has the strongest unmet need for non-invasive rejection surveillance of any organ, because surveillance transbronchial biopsy is invasive, low-yield and poorly tolerated. A specific Foch lung-transplant KOL could not be identified in this session and is a priority gap.",
  "source": "france"
 },
 {
  "id": "ita-verona",
  "name": "Azienda Ospedaliera Universitaria Integrata di Verona",
  "short": "Verona",
  "city": "Verona",
  "region": "Veneto",
  "iso3": "ITA",
  "lat": 45.4384,
  "lon": 10.9916,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 108,
    "living": 20,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 39,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1300,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 1,
  "labNote": "Accreditation: EFI.",
  "note": "Veneto - purchasing via Azienda Zero. Third-largest kidney programme in Italy and a large adult liver and heart programme.",
  "source": "italy"
 },
 {
  "id": "fra-paris-saint-louis",
  "name": "Hopital Saint-Louis (AP-HP), Service de Nephrologie et Transplantation renale",
  "short": "Paris Saint-Louis",
  "city": "Paris",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 48.8566,
  "lon": 2.3522,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 139,
    "living": 15,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 8,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1632,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 1,
  "labNote": "Saint-Louis hosts the HLA laboratory founded by Jean Dausset, now headed by Jean-Luc Taupin (PharmD, PhD). Public sources state it handles tissue compatibility for approximately 25% of French transplant activity - a striking concentration, but this proportion is a claim from a professional biography page and is NOT independently verified against ABM data. EFI accreditation inferred from LAHN performance conditions, not confirmed against the EFI register. Accreditation: EFI.",
  "note": "The most important single HLA laboratory account in France, distinct from its transplant volume. If the Saint-Louis laboratory really does perform a quarter of national transplant histocompatibility work, a single technical win there changes the national picture for an HLA typing product. Jean-Luc Taupin is the person to know. The transplant service is headed by Prof Carmen Lefaucheur, who leads the AI-CARE dd-cfDNA randomised trial as principal investigator, and Prof Denis Glotz is also based here. Saint-Louis is additionally a major allogeneic HSCT centre, which makes it relevant to the chimerism pillar (LAHN acts G179/G180/G225). Saint-Louis was one of the two French recruiting centres in the published AlloSure vs AlloSeq cfDNA comparison.",
  "source": "france"
 },
 {
  "id": "usa-texas-children-s",
  "name": "Texas Children's Hospital",
  "short": "Texas Children's",
  "city": "Houston",
  "region": "TX",
  "iso3": "USA",
  "lat": 29.7604,
  "lon": -95.3698,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 29,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 56,
    "living": 10,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 51,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 7,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-jewish-hospital",
  "name": "Jewish Hospital",
  "short": "Jewish Hospital",
  "city": "Louisville",
  "region": "KY",
  "iso3": "USA",
  "lat": 38.249,
  "lon": -85.754,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 89,
    "living": 15,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 11,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 16,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 21,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-largo-medical-center",
  "name": "Largo Medical Center",
  "short": "Largo Medical Center",
  "city": "Largo",
  "region": "FL",
  "iso3": "USA",
  "lat": 27.916,
  "lon": -82.787,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 64,
    "living": 20,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 55,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 22,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-hu-puerta-de-hierro",
  "name": "Hospital Universitario Puerta de Hierro Majadahonda",
  "short": "HU Puerta de Hierro",
  "city": "Majadahonda",
  "region": "Comunidad de Madrid",
  "iso3": "ESP",
  "lat": 40.4728,
  "lon": -3.8722,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 33,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 27,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 80,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 300,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Small kidney programme but a very large lung programme (80 in 2024, 1,116 cumulative) and a major heart programme. Runs the paediatric lung programme jointly with La Paz Infantil.",
  "source": "spain"
 },
 {
  "id": "esp-hu-virgen-de-las-nieves",
  "name": "Hospital Universitario Virgen de las Nieves",
  "short": "HU Virgen de las Nieves",
  "city": "Granada",
  "region": "Andalucia",
  "iso3": "ESP",
  "lat": 37.1773,
  "lon": -3.5986,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 83,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 57,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 760,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "usa-our-lady-of-lourdes-medical-center",
  "name": "Our Lady of Lourdes Medical Center",
  "short": "Our Lady of Lourdes Medical Center",
  "city": "Camden",
  "region": "NJ",
  "iso3": "USA",
  "lat": 39.926,
  "lon": -75.093,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 100,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 34,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-albert-einstein-medical-center",
  "name": "Albert Einstein Medical Center",
  "short": "Albert Einstein Medical Center",
  "city": "Philadelphia",
  "region": "PA",
  "iso3": "USA",
  "lat": 40.037,
  "lon": -75.144,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 56,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 80,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-hu-ramon-y-cajal",
  "name": "Hospital Universitario Ramon y Cajal",
  "short": "HU Ramon y Cajal",
  "city": "Madrid",
  "region": "Comunidad de Madrid",
  "iso3": "ESP",
  "lat": 40.4168,
  "lon": -3.7038,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 98,
    "living": 16,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 39,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 890,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": "Active tender: expediente A/SUM-022401/2026, 'Suministro de reactivos para el tipaje HLA de alta resolucion', EUR 131,904.00 ex-VAT / EUR 159,603.84 incl. VAT, 24 months, 1 lot, procedimiento abierto simplificado, CPV 33696500-0, bids due 28 July 2026 18:00 via VORTAL, opening 29 July 2026 11:30. ROLECE registration required. Accreditation: EFI (not confirmed in this pass).",
  "note": "Active HLA NGS reagent tender A/SUM-022401/2026, EUR 131,904 ex-VAT over 24 months, closing 28 July 2026.",
  "source": "spain"
 },
 {
  "id": "pol-instytut-transplantologii",
  "name": "Instytut Transplantologii im. Tadeusza Orlowskiego",
  "short": "Instytut Transplantologii",
  "city": "Warsaw",
  "region": "Mazowieckie",
  "iso3": "POL",
  "lat": 52.2297,
  "lon": 21.0122,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 136,
    "living": 22,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Accreditation: EFI.",
  "note": "Poland's very low living-donor share (82 of about 1,214 kidney transplants, under 7%) is the defining feature of this market and contrasts sharply with the Netherlands (43%) and Turkey (75-80%). It means Polish recipients are overwhelmingly deceased-donor, often extended-criteria, and therefore a higher-risk surveillance population. Financing for the transplant pathway runs partly through the Ministry of Health's national transplantation programme via Poltransplant rather than purely through NFZ, so Poltransplant is the first door. Academic and policy centre of Polish transplantation.",
  "source": "rest_europe"
 },
 {
  "id": "pol-szpital-kliniczny-dzieciatka-jezus-uck",
  "name": "Szpital Kliniczny Dzieciatka Jezus UCK WUM (Instytut Transplantologii), Warszawa",
  "short": "Szpital Kliniczny Dzieciatka Jezus UCK WUM (",
  "city": "Warsaw",
  "region": "",
  "iso3": "POL",
  "lat": 52.2297,
  "lon": 21.0122,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 136,
    "living": 22,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-corewell-beaumont",
  "name": "Corewell Health William Beaumont University Hospital",
  "short": "Corewell Beaumont",
  "city": "Royal Oak",
  "region": "MI",
  "iso3": "USA",
  "lat": 39.5,
  "lon": -98.0,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 88,
    "living": 24,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 45,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "usa-baylor-scott-and-white-all-saints-medi",
  "name": "Baylor  Scott and White All Saints Medical Center-Fort Worth",
  "short": "Baylor  Scott and White All Saints Medical C",
  "city": "Temple",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.09,
  "lon": -97.356,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 73,
    "living": 18,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 55,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "fra-creteil-henri-mondor",
  "name": "Hopital Henri Mondor (AP-HP), Service de Nephrologie et Transplantation",
  "short": "Creteil Henri Mondor",
  "city": "Creteil",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 48.7904,
  "lon": 2.4556,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 123,
    "living": 21,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 8,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1299,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Solid AP-HP kidney account. Its liver programme was consolidated into Paul Brousse in December 2018 and its heart transplants are physically done at Pitie-Salpetriere, so the addressable surgical activity here is kidney only - a useful correction, since older market models often still credit Henri Mondor with three organs.",
  "source": "france"
 },
 {
  "id": "usa-iowa",
  "name": "University of Iowa Hospitals & Clinics",
  "short": "Iowa",
  "city": "Iowa City",
  "region": "IA",
  "iso3": "USA",
  "lat": 41.6611,
  "lon": -91.5302,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 16,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 79,
    "living": 28,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 14,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 19,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "fra-nice",
  "name": "CHU de Nice - Hopital Pasteur",
  "short": "Nice",
  "city": "Nice",
  "region": "Provence-Alpes-Cote d'Azur",
  "iso3": "FRA",
  "lat": 43.7102,
  "lon": 7.262,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 87,
    "living": 19,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 41,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 925,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Liver activity more than tripled in 2024. Programmes in rapid expansion buy new infrastructure; worth an early call.",
  "source": "france"
 },
 {
  "id": "esp-hu-la-paz",
  "name": "Hospital Universitario La Paz",
  "short": "HU La Paz",
  "city": "Madrid",
  "region": "Comunidad de Madrid",
  "iso3": "ESP",
  "lat": 40.4168,
  "lon": -3.7038,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 87,
    "living": 18,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 39,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 790,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Kidney 68 adult + 19 paediatric; the paediatric liver programme (39, including 6 living-donor and 8 split) is the national paediatric liver reference. Paediatric lung run jointly with Puerta de Hierro. SET president Constantino Fondevila heads General and Digestive Surgery here.",
  "source": "spain"
 },
 {
  "id": "esp-hu-puerta-del-mar",
  "name": "Hospital Universitario Puerta del Mar",
  "short": "HU Puerta del Mar",
  "city": "Cadiz",
  "region": "Andalucia",
  "iso3": "ESP",
  "lat": 36.5271,
  "lon": -6.2886,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 126,
    "living": 7,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1150,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "esp-hu-de-canarias",
  "name": "Hospital Universitario de Canarias",
  "short": "HU de Canarias",
  "city": "San Cristobal de La Laguna",
  "region": "Canarias",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 126,
    "living": 12,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1150,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Kidney centre for Tenerife.",
  "source": "spain"
 },
 {
  "id": "usa-st-luke-s-hospital-of-kansas-city",
  "name": "St Luke's Hospital of Kansas City",
  "short": "St Luke's Hospital of Kansas City",
  "city": "MO",
  "region": "MO",
  "iso3": "USA",
  "lat": 38.4,
  "lon": -92.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 70,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 24,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 32,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-mhh-hannover",
  "name": "Medizinische Hochschule Hannover",
  "short": "MHH Hannover",
  "city": "Hannover",
  "region": "Niedersachsen",
  "iso3": "DEU",
  "lat": 52.3759,
  "lon": 9.732,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 125,
    "living": 34,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": "Large integrated transplant immunology and HLA service. Accreditation: EFI.",
  "note": "The best multi-organ account in Germany: largest European lung programme plus substantial kidney, liver and heart. A multi-organ dd-cfDNA proposition (kidney plus heart plus lung) is more compelling here than anywhere else in the region. Also the most transparent German centre about its own numbers, which makes it a good reference site.",
  "source": "rest_europe"
 },
 {
  "id": "are-dubai-health",
  "name": "Dubai Health (Rashid Hospital and Dubai Hospital) transplant programme",
  "short": "Dubai Health",
  "city": "Dubai",
  "region": "Dubai",
  "iso3": "ARE",
  "lat": 25.2048,
  "lon": 55.2708,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 73,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2024,
    "total": 50,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 300,
   "confidence": "estimated",
   "method": "Rough: a growing programme averaging perhaps 40/yr over the last decade with good survival. Unverified."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Rashid Hospital is described as the leading organ donation centre in the UAE. Dubai Health is both provider and (through DHA) regulator/payer, so a single institutional decision can cover clinical adoption and payment. It also runs a paediatric kidney transplant programme with published outcomes. Fastest-growing programme in the country by percentage.",
  "source": "gulf"
 },
 {
  "id": "usa-sharp-memorial-hospital",
  "name": "Sharp Memorial Hospital",
  "short": "Sharp Memorial Hospital",
  "city": "San Diego",
  "region": "CA",
  "iso3": "USA",
  "lat": 32.797,
  "lon": -117.155,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 110,
    "living": 36,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 11,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 2,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-modena",
  "name": "Azienda Ospedaliero-Universitaria di Modena, Policlinico",
  "short": "Modena",
  "city": "Modena",
  "region": "Emilia-Romagna",
  "iso3": "ITA",
  "lat": 44.6471,
  "lon": 10.9252,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 42,
    "living": 9,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 77,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1150,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Emilia-Romagna / Intercent-ER procurement. Liver-heavy case mix.",
  "source": "italy"
 },
 {
  "id": "usa-ssm-health-saint-louis-university-hosp",
  "name": "SSM Health Saint Louis University Hospital",
  "short": "SSM Health Saint Louis University Hospital",
  "city": "St. Louis",
  "region": "MO",
  "iso3": "USA",
  "lat": 38.628,
  "lon": -90.235,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 82,
    "living": 26,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 37,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-sentara-norfolk-general-hospital",
  "name": "Sentara Norfolk General Hospital",
  "short": "Sentara Norfolk General Hospital",
  "city": "Norfolk",
  "region": "VA",
  "iso3": "USA",
  "lat": 36.862,
  "lon": -76.304,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 95,
    "living": 24,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 18,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-erie-county-medical-center",
  "name": "Erie County Medical Center",
  "short": "Erie County Medical Center",
  "city": "Buffalo",
  "region": "NY",
  "iso3": "USA",
  "lat": 42.906,
  "lon": -78.846,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 111,
    "living": 9,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-fundacio-puigvert",
  "name": "Fundacio Puigvert",
  "short": "Fundacio Puigvert",
  "city": "Barcelona",
  "region": "Cataluna",
  "iso3": "ESP",
  "lat": 41.3874,
  "lon": 2.1686,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 116,
    "living": 25,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1060,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Independent urology/nephrology foundation contracted by CatSalut; kidney-only, high living-donor share (25 of 116 in 2024). Buys its own reagents, so a separate procurement route from ICS.",
  "source": "spain"
 },
 {
  "id": "kwt-hamed-al-essa",
  "name": "Hamed Al-Essa Organ Transplant Center, Ibn Sina Hospital",
  "short": "Hamed Al-Essa",
  "city": "Kuwait City",
  "region": "Kuwait",
  "iso3": "KWT",
  "lat": 29.3759,
  "lon": 47.9774,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 0,
    "total": 100,
    "living": null,
    "confidence": "estimated"
   },
   {
    "organ": "liver",
    "year": 0,
    "total": 16,
    "living": null,
    "confidence": "estimated"
   }
  ],
  "prevalentGrafts": {
   "value": 800,
   "confidence": "derived",
   "method": "Derived: 1,247 lifetime kidney transplants since 1993 with an assumed ~65% still functioning and followed. Arithmetic: 1247 x 0.65 = 810, rounded to 800."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "The single national transplant centre for Kuwait, operating since 1979 and serving Kuwaitis and resident non-Kuwaitis alike. MOH Kuwait central tender. At ~100 kidney transplants a year it is a bigger single-site kidney account than anything in Qatar, Oman or Bahrain, and comparable to SKMC Abu Dhabi.",
  "source": "gulf"
 },
 {
  "id": "ita-ismett",
  "name": "IRCCS Istituto Mediterraneo per i Trapianti e Terapie ad Alta Specializzazione",
  "short": "ISMETT",
  "city": "Palermo",
  "region": "Sicilia",
  "iso3": "ITA",
  "lat": 38.1157,
  "lon": 13.3615,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 62,
    "living": 21,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 54,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1400,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 1,
  "labNote": "As a UPMC joint venture ISMETT has historically operated to US laboratory standards; CAP accreditation is plausible but was NOT verified - treat as estimated. Accreditation: EFI, CAP.",
  "note": "The most commercially unusual account in Italy. UPMC affiliation means US-style adoption behaviour, English-speaking clinical leadership, an active clinical research infrastructure and a private-law procurement route that is faster than the public regional tender. Strongest candidate in Italy for an early-adopter paid pilot of dd-cfDNA surveillance.",
  "source": "italy"
 },
 {
  "id": "usa-the-queen-s-medical-center",
  "name": "The Queen's Medical Center",
  "short": "Queen's Medical Center",
  "city": "Honolulu",
  "region": "HI",
  "iso3": "USA",
  "lat": 21.307,
  "lon": -157.856,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 86,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 30,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-chu-santiago",
  "name": "Complexo Hospitalario Universitario de Santiago",
  "short": "CHU Santiago",
  "city": "Santiago de Compostela",
  "region": "Galicia",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 61,
    "living": 7,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 54,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 560,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "usa-robert-wood-johnson-university-hospita",
  "name": "Robert Wood Johnson University Hospital",
  "short": "Robert Wood Johnson University Hospital",
  "city": "New Brunswick",
  "region": "NJ",
  "iso3": "USA",
  "lat": 40.493,
  "lon": -74.447,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 85,
    "living": 14,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 14,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 16,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "are-skmc",
  "name": "Sheikh Khalifa Medical City",
  "short": "SKMC",
  "city": "Abu Dhabi",
  "region": "Abu Dhabi",
  "iso3": "ARE",
  "lat": 24.4539,
  "lon": 54.3773,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 114,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 700,
   "confidence": "estimated",
   "method": "Estimated from a sustained ~100/yr run rate over roughly a decade with high graft survival. Unverified."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "By volume this is probably the single largest kidney transplant account in the UAE, and it is bigger than CCAD for kidney specifically even though CCAD has the multi-organ prestige. Sits inside SEHA, which is now part of PureHealth, so procurement is group-level and covers a large hospital network. Dr Ali Abdul Kareem Al Obaidli, Chairman of the UAE National Transplant Committee, is a transplant physician here, which makes SKMC the intersection of the biggest volume and the strongest national policy influence in the country.",
  "source": "gulf"
 },
 {
  "id": "esp-h-del-mar",
  "name": "Hospital del Mar",
  "short": "H del Mar",
  "city": "Barcelona",
  "region": "Cataluna",
  "iso3": "ESP",
  "lat": 41.3874,
  "lon": 2.1686,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 113,
    "living": 19,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1030,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Part of Parc de Salut Mar.",
  "source": "spain"
 },
 {
  "id": "ita-ancona",
  "name": "Azienda Ospedaliero-Universitaria delle Marche (Ospedali Riuniti Torrette - Umberto I)",
  "short": "Ancona",
  "city": "Ancona",
  "region": "Marche",
  "iso3": "ITA",
  "lat": 43.6158,
  "lon": 13.5189,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 60,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 52,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1050,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Marche is a NITp member region - reachable through the NITp technical route. Marche also hosts the shared AIRT/OCST informational secretariat pages at ato.marche.it.",
  "source": "italy"
 },
 {
  "id": "che-curt-lausanne-chuv",
  "name": "CURT Lausanne (CHUV)",
  "short": "CURT Lausanne (CHUV)",
  "city": "Lausanne",
  "region": "",
  "iso3": "CHE",
  "lat": 46.5197,
  "lon": 6.6323,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 68,
    "living": 18,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 17,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 26,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "esp-hu-son-espases",
  "name": "Hospital Universitario Son Espases",
  "short": "HU Son Espases",
  "city": "Palma de Mallorca",
  "region": "Illes Balears",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 89,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 22,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 810,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 1,
  "labNote": "Laboratorio de Histocompatibilidad of the Servicio de Inmunologia holds European Federation for Immunogenetics accreditation for histocompatibility testing for both solid organ and haematopoietic progenitor cell transplantation. One of the few Spanish EFI accreditations confirmed from a primary institutional source in this pass. Accreditation: EFI.",
  "note": null,
  "source": "spain"
 },
 {
  "id": "pol-usk-im-jana-mikulicza-radeckiego-we-wr",
  "name": "USK im. Jana Mikulicza-Radeckiego we Wroclawiu",
  "short": "USK im. Jana Mikulicza-Radeckiego we Wroclaw",
  "city": "Wroclaw",
  "region": "",
  "iso3": "POL",
  "lat": 51.1079,
  "lon": 17.0385,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 60,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 49,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "swe-uppsala",
  "name": "Akademiska sjukhuset Uppsala",
  "short": "Uppsala",
  "city": "Uppsala",
  "region": "Uppsala",
  "iso3": "SWE",
  "lat": 59.8586,
  "lon": 17.6389,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 107,
    "living": 28,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Fourth Swedish centre.",
  "source": "rest_europe"
 },
 {
  "id": "fra-rouen",
  "name": "CHU de Rouen - Hopital Charles Nicolle",
  "short": "Rouen",
  "city": "Rouen",
  "region": "Normandie",
  "iso3": "FRA",
  "lat": 49.4432,
  "lon": 1.0993,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 95,
    "living": 27,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 14,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1155,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "One of the highest living-donor fractions in France (27 of 95). Living-donor programmes are the best fit for pre-transplant risk scoring and for HLA eplet-level matching products because the donor is known and testable in advance.",
  "source": "france"
 },
 {
  "id": "esp-hgu-gregorio-maranon",
  "name": "Hospital General Universitario Gregorio Maranon",
  "short": "HGU Gregorio Maranon",
  "city": "Madrid",
  "region": "Comunidad de Madrid",
  "iso3": "ESP",
  "lat": 40.4168,
  "lon": -3.7038,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 62,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 47,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 560,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Paediatric kidney programme wound down (1 in 2023, 0 in 2024). Major paediatric and adult heart programme.",
  "source": "spain"
 },
 {
  "id": "usa-mercy-health-saint-mary-s",
  "name": "Mercy Health Saint Mary?s",
  "short": "Mercy Health Saint Mary?s",
  "city": "Grand Rapids",
  "region": "MI",
  "iso3": "USA",
  "lat": 42.96,
  "lon": -85.669,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 109,
    "living": 41,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "pol-sccs-zabrze",
  "name": "Slaskie Centrum Chorob Serca w Zabrzu",
  "short": "SCCS Zabrze",
  "city": "Zabrze",
  "region": "Slaskie",
  "iso3": "POL",
  "lat": 50.3249,
  "lon": 18.7857,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "heart",
    "year": 2024,
    "total": 48,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 60,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Poland's dominant heart and lung transplant centre and one of the largest thoracic transplant programmes in central Europe. The natural Polish account for a heart or lung dd-cfDNA product.",
  "source": "rest_europe"
 },
 {
  "id": "usa-aurora-st-luke-s-medical-center",
  "name": "Aurora St. Luke's Medical Center",
  "short": "Aurora St. Luke's Medical Center",
  "city": "WI",
  "region": "WI",
  "iso3": "USA",
  "lat": 44.6,
  "lon": -89.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 73,
    "living": 24,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 7,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 24,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "prt-chu-sao-joao",
  "name": "Centro Hospitalar Universitario de Sao Joao",
  "short": "CHU Sao Joao",
  "city": "Porto",
  "region": "Porto",
  "iso3": "PRT",
  "lat": 41.1579,
  "lon": -8.6291,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 92,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 14,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": "Principal northern Portuguese transplant centre.",
  "source": "rest_europe"
 },
 {
  "id": "prt-uls-sao-joao-chu-sao-joao",
  "name": "ULS Sao Joao (CHU Sao Joao)",
  "short": "ULS Sao Joao (CHU Sao Joao)",
  "city": "Porto",
  "region": "",
  "iso3": "PRT",
  "lat": 41.1579,
  "lon": -8.6291,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 92,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 14,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-vidant-medical-center",
  "name": "Vidant Medical Center",
  "short": "Vidant Medical Center",
  "city": "Greenville",
  "region": "NC",
  "iso3": "USA",
  "lat": 35.607,
  "lon": -77.372,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 98,
    "living": 20,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 7,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "fra-clermont-ferrand",
  "name": "CHU de Clermont-Ferrand - Hopital Gabriel Montpied",
  "short": "Clermont-Ferrand",
  "city": "Clermont-Ferrand",
  "region": "Auvergne-Rhone-Alpes",
  "iso3": "FRA",
  "lat": 45.7772,
  "lon": 3.087,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 67,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 24,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 13,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 714,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "CHU Clermont-Ferrand ran a tender (published 3 Feb 2025, deadline 3 Mar 2025) for rental of an automated analyser with captive reagent supply for URGENT HLA typing in its Histocompatibility/Immunogenetics department, estimated at EUR 271,488 ex-VAT. Paul Olivier Rouzaire, President of the SFHI Scientific Council, is understood to be associated with Clermont-Ferrand immunology but this was NOT verified.",
  "note": "Notable as one of the very few French HLA laboratory tenders with a published value: EUR 271,488 ex-VAT for an urgent-typing analyser with captive reagents. That is a useful benchmark for sizing a French mid-size HLA laboratory contract.",
  "source": "france"
 },
 {
  "id": "ita-policlinico-milano",
  "name": "Fondazione IRCCS Ca' Granda Ospedale Maggiore Policlinico",
  "short": "Policlinico Milano",
  "city": "Milan",
  "region": "Lombardia",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 64,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 40,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1550,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 1,
  "labNote": "Home of the NITp coordinating centre and its reference immunogenetics laboratory. This is the single most strategically important HLA laboratory in Italy because its technical policy propagates across six regions. Accreditation: EFI.",
  "note": "Purchasing via ARIA S.p.A. (Lombardia). Beyond its own transplant volume, this site is the entry point to the NITp network - a technical evaluation done here is effectively a six-region reference.",
  "source": "italy"
 },
 {
  "id": "esp-hgu-dr-balmis",
  "name": "Hospital General Universitario Dr Balmis",
  "short": "HGU Dr Balmis",
  "city": "Alicante",
  "region": "Comunitat Valenciana",
  "iso3": "ESP",
  "lat": 38.3452,
  "lon": -0.481,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 69,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 35,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 630,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Formerly Hospital General Universitario de Alicante.",
  "source": "spain"
 },
 {
  "id": "usa-spectrum-health",
  "name": "Spectrum Health",
  "short": "Spectrum Health",
  "city": "Grand Rapids",
  "region": "MI",
  "iso3": "USA",
  "lat": 42.969,
  "lon": -85.672,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 42,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 62,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-chu-badajoz",
  "name": "Complejo Hospitalario Universitario de Badajoz",
  "short": "CHU Badajoz",
  "city": "Badajoz",
  "region": "Extremadura",
  "iso3": "ESP",
  "lat": 38.8794,
  "lon": -6.9707,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 69,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 34,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 630,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "fra-clichy-beaujon",
  "name": "Hopital Beaujon (AP-HP), Service d'Hepatologie et Transplantation hepatique",
  "short": "Clichy Beaujon",
  "city": "Clichy",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 46.6,
  "lon": 2.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "liver",
    "year": 2024,
    "total": 103,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Third-largest French liver centre. Worth flagging because it does not appear in most transplant market models built from kidney data - Beaujon has no kidney programme at all.",
  "source": "france"
 },
 {
  "id": "deu-transplantationszentrum-jena",
  "name": "Transplantationszentrum Jena",
  "short": "Jena",
  "city": "Jena",
  "region": "",
  "iso3": "DEU",
  "lat": 50.9271,
  "lon": 11.5892,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 42,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 43,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 4,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 14,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-auxilio-mutuo-hospital",
  "name": "Auxilio Mutuo Hospital",
  "short": "Auxilio Mutuo Hospital",
  "city": "San Juan",
  "region": "PR",
  "iso3": "USA",
  "lat": 18.402,
  "lon": -66.064,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 47,
    "living": 7,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 40,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 14,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-doctor-s-hospital-at-renaissance",
  "name": "Doctor's Hospital at Renaissance",
  "short": "Doctor's Hospital at Renaissance",
  "city": "Edinburg",
  "region": "TX",
  "iso3": "USA",
  "lat": 26.29,
  "lon": -98.16,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 101,
    "living": 11,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "pol-sp-zoz-szpital-uniwersytecki-w-krakowi",
  "name": "SP ZOZ Szpital Uniwersytecki w Krakowie",
  "short": "SP ZOZ Szpital Uniwersytecki w Krakowie",
  "city": "Krakow",
  "region": "",
  "iso3": "POL",
  "lat": 50.0647,
  "lon": 19.945,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 101,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-scott-and-white-memorial-hospital",
  "name": "Scott and White Memorial Hospital",
  "short": "Scott and White Memorial Hospital",
  "city": "Temple",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.09,
  "lon": -97.356,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 69,
    "living": 16,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 25,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 7,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "pol-su-krakow",
  "name": "Szpital Uniwersytecki w Krakowie",
  "short": "SU Krakow",
  "city": "Krakow",
  "region": "Malopolskie",
  "iso3": "POL",
  "lat": 50.0647,
  "lon": 19.945,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 101,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Poland's very low living-donor share (82 of about 1,214 kidney transplants, under 7%) is the defining feature of this market and contrasts sharply with the Netherlands (43%) and Turkey (75-80%). It means Polish recipients are overwhelmingly deceased-donor, often extended-criteria, and therefore a higher-risk surveillance population. Financing for the transplant pathway runs partly through the Ministry of Health's national transplantation programme via Poltransplant rather than purely through NFZ, so Poltransplant is the first door.",
  "source": "rest_europe"
 },
 {
  "id": "deu-transplantationszentrum-dusseldorf",
  "name": "Transplantationszentrum Dusseldorf",
  "short": "Dusseldorf",
  "city": "Dusseldorf",
  "region": "",
  "iso3": "DEU",
  "lat": 51.2277,
  "lon": 6.7735,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 57,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 44,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-virginia-mason-medical-center",
  "name": "Virginia Mason Medical Center",
  "short": "Virginia Mason Medical Center",
  "city": "Seattle",
  "region": "WA",
  "iso3": "USA",
  "lat": 47.608,
  "lon": -122.326,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 100,
    "living": 23,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-bari",
  "name": "Azienda Ospedaliero Universitaria Policlinico di Bari",
  "short": "Bari",
  "city": "Bari",
  "region": "Puglia",
  "iso3": "ITA",
  "lat": 41.1187,
  "lon": 16.8719,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 80,
    "living": 21,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 20,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 900,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 1,
  "labNote": "Accreditation: EFI.",
  "note": "Puglia procures through InnovaPuglia S.p.A. (soggetto aggregatore). Puglia's donation rate rose sharply in 2025 (+19.8 transplants pmp), making it the fastest-growing southern market.",
  "source": "italy"
 },
 {
  "id": "usa-medical-city-fort-worth",
  "name": "Medical City Fort Worth",
  "short": "Medical City Fort Worth",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 96,
    "living": 15,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "nld-umc-utrecht",
  "name": "UMC Utrecht - Transplantatie Centrum Utrecht",
  "short": "UMC Utrecht",
  "city": "Utrecht",
  "region": "Utrecht",
  "iso3": "NLD",
  "lat": 52.0907,
  "lon": 5.1214,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 0,
    "total": 100,
    "living": null,
    "confidence": "estimated"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Growing programme; the 100-a-year milestone suggests active expansion and therefore budget attention.",
  "source": "rest_europe"
 },
 {
  "id": "esp-huca",
  "name": "Hospital Universitario Central de Asturias",
  "short": "HUCA",
  "city": "Oviedo",
  "region": "Asturias",
  "iso3": "ESP",
  "lat": 43.3603,
  "lon": -5.8448,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 74,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 25,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 670,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "ONT named HUCA the hospital with the most brain-death donors in Spain in 2025.",
  "source": "spain"
 },
 {
  "id": "usa-st-vincent-hospital-and-health-care-ce",
  "name": "St Vincent Hospital and Health Care Center",
  "short": "St Vincent Hospital and Health Care Center",
  "city": "Indianapolis",
  "region": "IN",
  "iso3": "USA",
  "lat": 39.908,
  "lon": -86.162,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 69,
    "living": 14,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 30,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-cau-salamanca",
  "name": "Complejo Asistencial Universitario de Salamanca",
  "short": "CAU Salamanca",
  "city": "Salamanca",
  "region": "Castilla y Leon",
  "iso3": "ESP",
  "lat": 40.9701,
  "lon": -5.6635,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 98,
    "living": 11,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 890,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "fra-nancy",
  "name": "CHU de Nancy - Hopitaux de Brabois",
  "short": "Nancy",
  "city": "Nancy (Vandoeuvre-les-Nancy)",
  "region": "Grand Est",
  "iso3": "FRA",
  "lat": 48.6921,
  "lon": 6.1844,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 90,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 7,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1250,
   "confidence": "verified",
   "method": "ABM Table R52 (adult 1,250 plus 17 paediatric)."
  },
  "tier": 2,
  "labNote": "EFS Grand Est. Not verified.",
  "note": "Mid-size Grand Est centre with a followed cohort (1,250) far larger than its annual volume implies, which is the profile that favours a surveillance product over a peri-transplant one.",
  "source": "france"
 },
 {
  "id": "usa-geisinger-medical-center",
  "name": "Geisinger Medical Center",
  "short": "Geisinger Medical Center",
  "city": "Danville",
  "region": "PA",
  "iso3": "USA",
  "lat": 40.964,
  "lon": -76.612,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 69,
    "living": 20,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 28,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "dnk-ouh-odense",
  "name": "Odense Universitetshospital",
  "short": "OUH Odense",
  "city": "Odense",
  "region": "Syddanmark",
  "iso3": "DNK",
  "lat": 55.4038,
  "lon": 10.4024,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 97,
    "living": 28,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Small kidney programme.",
  "source": "rest_europe"
 },
 {
  "id": "esp-hu-germans-trias-i-pujol",
  "name": "Hospital Universitari Germans Trias i Pujol",
  "short": "HU Germans Trias i Pujol",
  "city": "Badalona",
  "region": "Cataluna",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 96,
    "living": 10,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 870,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Part of ICS.",
  "source": "spain"
 },
 {
  "id": "usa-legacy-good-samaritan-hospital-and-med",
  "name": "Legacy Good Samaritan Hospital and Medical Center",
  "short": "Legacy Good Samaritan Hospital and Medical C",
  "city": "Portland",
  "region": "OR",
  "iso3": "USA",
  "lat": 45.53,
  "lon": -122.697,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 96,
    "living": 22,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "che-curt-geneve-hug",
  "name": "CURT Geneve (HUG)",
  "short": "CURT Geneve (HUG)",
  "city": "Geneva",
  "region": "",
  "iso3": "CHE",
  "lat": 46.2044,
  "lon": 6.1432,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 38,
    "living": 7,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 50,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 6,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-presbyterian-st-luke-s-medical-center",
  "name": "Presbyterian/St Luke's Medical Center",
  "short": "Presbyterian/St Luke's Medical Center",
  "city": "CO",
  "region": "CO",
  "iso3": "USA",
  "lat": 39.0,
  "lon": -105.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 56,
    "living": 12,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 38,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-university-of-texas-medical-branch-at",
  "name": "University of Texas Medical Branch at Galveston",
  "short": "University of Texas Medical Branch at Galves",
  "city": "Galveston",
  "region": "TX",
  "iso3": "USA",
  "lat": 29.309,
  "lon": -94.777,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 90,
    "living": 28,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "cze-fn-motol",
  "name": "Fakultni nemocnice v Motole",
  "short": "FN Motol",
  "city": "Prague",
  "region": "Praha",
  "iso3": "CZE",
  "lat": 50.0755,
  "lon": 14.4378,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 11,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 10,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 72,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "National paediatric transplant centre and the Czech lung transplant programme.",
  "source": "rest_europe"
 },
 {
  "id": "usa-willis-knighton-medical-center",
  "name": "Willis-Knighton Medical Center",
  "short": "Willis-Knighton Medical Center",
  "city": "LA",
  "region": "LA",
  "iso3": "USA",
  "lat": 31.1,
  "lon": -92.0,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 71,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 12,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 9,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-providence-sacred-heart-medical-center",
  "name": "Providence Sacred Heart Medical Center & Children's Hospital",
  "short": "Providence Sacred Heart Medical Center & Chi",
  "city": "WA",
  "region": "WA",
  "iso3": "USA",
  "lat": 47.4,
  "lon": -120.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 85,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 6,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-mainz",
  "name": "Transplantationszentrum Mainz",
  "short": "Mainz",
  "city": "Mainz",
  "region": "",
  "iso3": "DEU",
  "lat": 49.9929,
  "lon": 8.2473,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 37,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 54,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "sau-kfsh-d",
  "name": "King Fahad Specialist Hospital Dammam - Multiorgan Transplant Center of Excellence",
  "short": "KFSH-D",
  "city": "Dammam",
  "region": "Eastern Province",
  "iso3": "SAU",
  "lat": 26.4207,
  "lon": 50.0888,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 90,
    "living": null,
    "confidence": "derived"
   }
  ],
  "prevalentGrafts": {
   "value": 900,
   "confidence": "estimated",
   "method": "Crude: >1,500 lifetime transplants, majority kidney, assume ~60-70% functioning and followed locally."
  },
  "tier": 1,
  "labNote": "HLA laboratory arrangements not verified.",
  "note": "The clearest example of the Health Cluster model in action: KFSH-D sits inside the Eastern Health Cluster and is designated its Multiorgan Transplant Center of Excellence. That means the clinical champion is at the hospital but the budget conversation is at the cluster, and the contract is at NUPCO. Also serves the Eastern Province oil-sector population, which is comparatively well insured.",
  "source": "gulf"
 },
 {
  "id": "fra-dijon",
  "name": "CHU de Dijon Bourgogne",
  "short": "Dijon",
  "city": "Dijon",
  "region": "Bourgogne-Franche-Comte",
  "iso3": "FRA",
  "lat": 47.322,
  "lon": 5.0415,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 76,
    "living": 7,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 13,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 540,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "EFS Bourgogne-Franche-Comte. Not verified.",
  "note": "Mid-size two-organ CHU.",
  "source": "france"
 },
 {
  "id": "pol-szpital-uniwersytecki-nr-1-im-a-jurasz",
  "name": "Szpital Uniwersytecki nr 1 im. A. Jurasza w Bydgoszczy",
  "short": "Szpital Uniwersytecki nr 1 im. A. Jurasza w ",
  "city": "Bydgoszcz",
  "region": "",
  "iso3": "POL",
  "lat": 53.1235,
  "lon": 18.0084,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 50,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 39,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "fra-la-reunion",
  "name": "CHU de La Reunion",
  "short": "La Reunion",
  "city": "Saint-Denis / Saint-Pierre",
  "region": "La Reunion (DOM)",
  "iso3": "FRA",
  "lat": 46.6,
  "lon": 2.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 81,
    "living": 5,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 7,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 591,
   "confidence": "verified",
   "method": "ABM Table R52 (adult 591 plus 34 paediatric)."
  },
  "tier": 2,
  "labNote": "Not verified. Overseas departments face real logistical constraints on sample shipment to mainland HLA laboratories.",
  "note": "Strategically interesting despite modest size. La Reunion has an exceptionally high burden of diabetic and hypertensive kidney failure and a geographically isolated population, so sample logistics to mainland France are slow and expensive. That is the strongest argument in the French territory for a DECENTRALISED, on-site assay format rather than a send-away central laboratory model. Same argument applies to Pointe-a-Pitre (Guadeloupe).",
  "source": "france"
 },
 {
  "id": "esp-hu-miguel-servet",
  "name": "Hospital Universitario Miguel Servet",
  "short": "HU Miguel Servet",
  "city": "Zaragoza",
  "region": "Aragon",
  "iso3": "ESP",
  "lat": 41.6488,
  "lon": -0.8891,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 88,
    "living": 6,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 800,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "pol-szpital-wojewodzki-w-poznaniu",
  "name": "Szpital Wojewodzki w Poznaniu",
  "short": "Szpital Wojewodzki w Poznaniu",
  "city": "Poznan",
  "region": "",
  "iso3": "POL",
  "lat": 52.4064,
  "lon": 16.9252,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 88,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "fra-saint-etienne",
  "name": "CHU de Saint-Etienne - Hopital Nord, Service de Nephrologie-Dialyse-Transplantation renale",
  "short": "Saint-Etienne",
  "city": "Saint-Etienne",
  "region": "Auvergne-Rhone-Alpes",
  "iso3": "FRA",
  "lat": 45.4397,
  "lon": 4.3872,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 86,
    "living": 21,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1001,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Prof Christophe Mariat is head of service and Vice-President of the SFNDT, and also chairs the CHU's clinical research and innovation directorate (DRCI) - an unusually favourable combination for getting a study or an early-access agreement approved locally.",
  "source": "france"
 },
 {
  "id": "usa-saint-joseph-hospital",
  "name": "Saint Joseph Hospital",
  "short": "Saint Joseph Hospital",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 82,
    "living": 13,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 3,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-bad-oeynhausen",
  "name": "Transplantationszentrum Bad Oeynhausen",
  "short": "Bad Oeynhausen",
  "city": "Bad Oeynhausen",
  "region": "",
  "iso3": "DEU",
  "lat": 52.2,
  "lon": 8.8,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2024,
    "total": 78,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 7,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "che-usb-basel",
  "name": "Universitatsspital Basel",
  "short": "USB Basel",
  "city": "Basel",
  "region": "Basel-Stadt",
  "iso3": "CHE",
  "lat": 47.5596,
  "lon": 7.5886,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 85,
    "living": 33,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 1,
  "labNote": null,
  "note": "Six centres nationally, all enrolled in the Swiss Transplant Cohort Study, which prospectively captures essentially every Swiss solid organ recipient. Combined with the Analysenliste (a single national listing decision, manufacturer may apply directly) this makes Switzerland the highest reimbursement-probability-per-unit-of-effort market in the region despite its size. Basel has published significant work on ABO-incompatible kidney transplantation and DSA within the Swiss Transplant Cohort Study.",
  "source": "rest_europe"
 },
 {
  "id": "usa-pinnacle-health-system-at-harrisburg-h",
  "name": "Pinnacle Health System at Harrisburg Hospital",
  "short": "Pinnacle Health System at Harrisburg Hospita",
  "city": "PA",
  "region": "PA",
  "iso3": "USA",
  "lat": 40.9,
  "lon": -77.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 84,
    "living": 44,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-bergamo",
  "name": "ASST Papa Giovanni XXIII",
  "short": "Bergamo",
  "city": "Bergamo",
  "region": "Lombardia",
  "iso3": "ITA",
  "lat": 45.6983,
  "lon": 9.6773,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 39,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 44,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 1400,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 1,
  "labNote": "Accreditation: EFI.",
  "note": "Scientifically the most important transplant nephrology account in Italy because of its integration with the Mario Negri Institute's Centro di Ricerche Cliniche per le Malattie Rare 'Aldo e Cele Dacco' at Ranica. Volumes are moderate but publication influence is very high; this is the site to run a European validation study through if the goal is credibility rather than revenue.",
  "source": "italy"
 },
 {
  "id": "usa-charleston-area-medical-center",
  "name": "Charleston Area Medical Center",
  "short": "Charleston Area Medical Center",
  "city": "WV",
  "region": "WV",
  "iso3": "USA",
  "lat": 38.6,
  "lon": -80.6,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 82,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-udine",
  "name": "Azienda Sanitaria Universitaria Friuli Centrale, Ospedale Santa Maria della Misericordia",
  "short": "Udine",
  "city": "Udine",
  "region": "Friuli-Venezia Giulia",
  "iso3": "ITA",
  "lat": 46.0711,
  "lon": 13.2346,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 55,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 26,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 600,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "NITp member region with a small population but high per-capita transplant activity. FVG has an unusually autonomous health system (special statute region).",
  "source": "italy"
 },
 {
  "id": "esp-hu-insular-de-gran-canaria",
  "name": "Hospital Universitario Insular de Gran Canaria",
  "short": "HU Insular de Gran Canaria",
  "city": "Las Palmas de Gran Canaria",
  "region": "Canarias",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 81,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 740,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "fra-besancon",
  "name": "CHU de Besancon - Hopital Jean Minjoz",
  "short": "Besancon",
  "city": "Besancon",
  "region": "Bourgogne-Franche-Comte",
  "iso3": "FRA",
  "lat": 47.2378,
  "lon": 6.0241,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 47,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 33,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 661,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "EFS Bourgogne-Franche-Comte. Not verified.",
  "note": "Smaller two-organ CHU.",
  "source": "france"
 },
 {
  "id": "usa-the-christ-hospital",
  "name": "The Christ Hospital",
  "short": "Christ Hospital",
  "city": "OH",
  "region": "OH",
  "iso3": "USA",
  "lat": 40.3,
  "lon": -82.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 61,
    "living": 25,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 17,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-ou-medical-center",
  "name": "OU Medical Center",
  "short": "OU Medical Center",
  "city": "OK",
  "region": "OK",
  "iso3": "USA",
  "lat": 35.6,
  "lon": -97.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 47,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 30,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-research-medical-center",
  "name": "Research Medical Center",
  "short": "Research Medical Center",
  "city": "MO",
  "region": "MO",
  "iso3": "USA",
  "lat": 38.4,
  "lon": -92.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 75,
    "living": 10,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-george-washington-university-hospital",
  "name": "George Washington University Hospital",
  "short": "George Washington University Hospital",
  "city": "DC",
  "region": "DC",
  "iso3": "USA",
  "lat": 38.9,
  "lon": -77.0,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 52,
    "living": 11,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 23,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-freiburg",
  "name": "Transplantationszentrum Freiburg",
  "short": "Freiburg",
  "city": "Freiburg",
  "region": "",
  "iso3": "DEU",
  "lat": 47.999,
  "lon": 7.8421,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 47,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 16,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 9,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "ita-roma-san-camillo",
  "name": "Azienda Ospedaliera San Camillo-Forlanini",
  "short": "Roma San Camillo",
  "city": "Rome",
  "region": "Lazio",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 39,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 34,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 850,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": "Lazio regional immunogenetics is coordinated through the CRT Lazio; individual lab arrangements not verified.",
  "note": "The POIT structure means Lazio's transplant activity is administratively pooled - selling into POIT reaches several Rome hospitals at once.",
  "source": "italy"
 },
 {
  "id": "qat-qcot",
  "name": "Qatar Center for Organ Transplantation, Hamad Medical Corporation",
  "short": "QCOT",
  "city": "Doha",
  "region": "Doha",
  "iso3": "QAT",
  "lat": 25.2854,
  "lon": 51.531,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 60,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 12,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 600,
   "confidence": "estimated",
   "method": "Rough: sustained ~50-60/yr with high survival over roughly 15 years, minus losses. Unverified."
  },
  "tier": 2,
  "labNote": "Not verified. HMC operates a large central laboratory service.",
  "note": "One centre, one buyer, one country. Qatar has the best-documented annual volumes in the whole region, which is ironic given how small it is. High per-capita spending and a strong prestige-technology appetite. HMC central procurement.",
  "source": "gulf"
 },
 {
  "id": "deu-transplantationszentrum-kiel",
  "name": "Transplantationszentrum Kiel",
  "short": "Kiel",
  "city": "Kiel",
  "region": "",
  "iso3": "DEU",
  "lat": 54.3233,
  "lon": 10.1228,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 28,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 34,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 11,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "prt-uls-santa-maria",
  "name": "ULS Santa Maria",
  "short": "ULS Santa Maria",
  "city": "Lisbon",
  "region": "",
  "iso3": "PRT",
  "lat": 38.7223,
  "lon": -9.1393,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 73,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-university-of-tennessee-medical-center",
  "name": "University of Tennessee Medical Center at Knoxville",
  "short": "University of Tennessee Medical Center at Kn",
  "city": "TN",
  "region": "TN",
  "iso3": "USA",
  "lat": 35.8,
  "lon": -86.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 73,
    "living": 19,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-cu-navarra",
  "name": "Clinica Universidad de Navarra",
  "short": "CU Navarra",
  "city": "Pamplona",
  "region": "Navarra",
  "iso3": "ESP",
  "lat": 42.8125,
  "lon": -1.6458,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 56,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 16,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 510,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Listed by ONT as 'C.U. de Navarra'. Private academic hospital (University of Navarra) that holds the Navarra transplant programme; ONT separately names Hospital Universitario de Navarra as the highest-donating NON-transplanting hospital in Spain in 2025, which supports the reading that the transplant programme sits at the Clinica. Procurement is private, not Osasunbidea tender - unusual and commercially attractive.",
  "source": "spain"
 },
 {
  "id": "esp-hcu-valladolid",
  "name": "Hospital Clinico Universitario de Valladolid",
  "short": "HCU Valladolid",
  "city": "Valladolid",
  "region": "Castilla y Leon",
  "iso3": "ESP",
  "lat": 41.6523,
  "lon": -4.7245,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 72,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 660,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "pol-instytut-pomnik-centrum-zdrowia-dzieck",
  "name": "Instytut Pomnik - Centrum Zdrowia Dziecka, Warszawa",
  "short": "Instytut Pomnik - Centrum Zdrowia Dziecka, W",
  "city": "Warsaw",
  "region": "",
  "iso3": "POL",
  "lat": 52.2297,
  "lon": 21.0122,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 54,
    "living": 14,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 18,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "pol-panstwowy-instytut-medyczny-mswia-wars",
  "name": "Panstwowy Instytut Medyczny MSWiA, Warszawa",
  "short": "Panstwowy Instytut Medyczny MSWiA, Warszawa",
  "city": "Warsaw",
  "region": "",
  "iso3": "POL",
  "lat": 52.2297,
  "lon": 21.0122,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 55,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 17,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "fra-amiens",
  "name": "CHU Amiens-Picardie",
  "short": "Amiens",
  "city": "Amiens",
  "region": "Hauts-de-France",
  "iso3": "FRA",
  "lat": 49.8941,
  "lon": 2.2958,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 71,
    "living": 7,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 923,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Kidney-only centre with a high DCD Maastricht III fraction.",
  "source": "france"
 },
 {
  "id": "usa-children-s-hospital-medical-center",
  "name": "Children's Hospital Medical Center",
  "short": "Children's Hospital Medical Center",
  "city": "OH",
  "region": "OH",
  "iso3": "USA",
  "lat": 40.3,
  "lon": -82.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 32,
    "living": 12,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 21,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 11,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2025,
    "total": 3,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-texas-health-harris-methodist-fort-wor",
  "name": "Texas Health Harris Methodist Fort Worth Hospital",
  "short": "Texas Health Harris Methodist Fort Worth Hos",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 71,
    "living": 22,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-bochum",
  "name": "Transplantationszentrum Bochum",
  "short": "Bochum",
  "city": "Bochum",
  "region": "",
  "iso3": "DEU",
  "lat": 51.4818,
  "lon": 7.2162,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 47,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 23,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "deu-transplantationszentrum-erlangen-nurnb",
  "name": "Transplantationszentrum Erlangen-Nurnberg",
  "short": "Erlangen-Nurnberg",
  "city": "Erlangen-Nurnberg",
  "region": "",
  "iso3": "DEU",
  "lat": 49.5897,
  "lon": 11.012,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 62,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 8,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-upmc-children-s-hospital-of-pittsburgh",
  "name": "UPMC Children's Hospital of Pittsburgh",
  "short": "UPMC Children's Hospital of Pittsburgh",
  "city": "PA",
  "region": "PA",
  "iso3": "USA",
  "lat": 40.9,
  "lon": -77.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 15,
    "living": 11,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 29,
    "living": 7,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 18,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2025,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-cincinnati-children-s",
  "name": "Cincinnati Children's Hospital Medical Center",
  "short": "Cincinnati Children's",
  "city": "Cincinnati",
  "region": "OH",
  "iso3": "USA",
  "lat": 39.1031,
  "lon": -84.512,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 11,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 32,
    "living": 12,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 21,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-ann-robert-h-lurie-children-s-hospital",
  "name": "Ann & Robert H. Lurie Children's Hospital of Chicago",
  "short": "Ann & Robert H. Lurie Children's Hospital of",
  "city": "IL",
  "region": "IL",
  "iso3": "USA",
  "lat": 40.0,
  "lon": -89.2,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 33,
    "living": 12,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 19,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 15,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-parma",
  "name": "Azienda Ospedaliero-Universitaria di Parma, Ospedale Maggiore",
  "short": "Parma",
  "city": "Parma",
  "region": "Emilia-Romagna",
  "iso3": "ITA",
  "lat": 44.8015,
  "lon": 10.3279,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 67,
    "living": 12,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 850,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Emilia-Romagna / Intercent-ER. Kidney-only programme with a large waiting list (298 at end 2022).",
  "source": "italy"
 },
 {
  "id": "fra-reims",
  "name": "CHU de Reims - Hopital Maison Blanche",
  "short": "Reims",
  "city": "Reims",
  "region": "Grand Est",
  "iso3": "FRA",
  "lat": 49.2583,
  "lon": 4.0317,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 67,
    "living": 8,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 802,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Gregory Gatouillat, SFHI Deputy General Secretary, is understood to be associated with Reims immunology; NOT verified.",
  "note": "Kidney-only CHU.",
  "source": "france"
 },
 {
  "id": "ita-roma-gemelli",
  "name": "Fondazione Policlinico Universitario Agostino Gemelli IRCCS",
  "short": "Roma Gemelli",
  "city": "Rome",
  "region": "Lazio",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 47,
    "living": 27,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 20,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 700,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 1,
  "labNote": "Accreditation: EFI.",
  "note": "Living-donor-heavy case mix makes Gemelli the best Rome site for pre-transplant immunological risk stratification and HLA epitope matching. Private foundation governance, faster than a public azienda.",
  "source": "italy"
 },
 {
  "id": "usa-lucile-salter-packard-children-s-hospi",
  "name": "Lucile Salter Packard Children's Hospital at Stanford",
  "short": "Lucile Salter Packard Children's Hospital at",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 26,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 17,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 14,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 7,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "intestine",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-roma-tor-vergata",
  "name": "Policlinico Tor Vergata",
  "short": "Roma Tor Vergata",
  "city": "Rome",
  "region": "Lazio",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 50,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 17,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 600,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Now the highest-volume adult kidney programme in Rome. Part of POIT Lazio.",
  "source": "italy"
 },
 {
  "id": "usa-va-portland-health-care-system",
  "name": "VA Portland Health Care System",
  "short": "VA Portland Health Care System",
  "city": "OR",
  "region": "OR",
  "iso3": "USA",
  "lat": 43.9,
  "lon": -120.6,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 47,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 18,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "fra-angers",
  "name": "CHU d'Angers",
  "short": "Angers",
  "city": "Angers",
  "region": "Pays de la Loire",
  "iso3": "FRA",
  "lat": 47.4784,
  "lon": -0.5632,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 64,
    "living": 9,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 747,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Kidney-only CHU in the Pays de la Loire, likely served by the same regional immunogenetics infrastructure as Nantes.",
  "source": "france"
 },
 {
  "id": "esp-hu-dr-peset",
  "name": "Hospital Universitario Doctor Peset",
  "short": "HU Dr Peset",
  "city": "Valencia",
  "region": "Comunitat Valenciana",
  "iso3": "ESP",
  "lat": 39.4699,
  "lon": -0.3763,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 64,
    "living": 4,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 580,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "prt-uls-lisboa-ocidental-hospital-de-santa",
  "name": "ULS Lisboa Ocidental (Hospital de Santa Cruz)",
  "short": "ULS Lisboa Ocidental (Hospital de Santa Cruz",
  "city": "Lisbon",
  "region": "",
  "iso3": "PRT",
  "lat": 38.7223,
  "lon": -9.1393,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 64,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "esp-hcu-san-carlos",
  "name": "Hospital Clinico Universitario San Carlos",
  "short": "HCU San Carlos",
  "city": "Madrid",
  "region": "Comunidad de Madrid",
  "iso3": "ESP",
  "lat": 40.4168,
  "lon": -3.7038,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 63,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 570,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "ita-cagliari-brotzu",
  "name": "Azienda Ospedaliera G. Brotzu",
  "short": "Cagliari Brotzu",
  "city": "Cagliari",
  "region": "Sardegna",
  "iso3": "ITA",
  "lat": 39.2238,
  "lon": 9.1217,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 35,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 27,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 500,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 1,
  "labNote": "Sardinia has an unusual population genetics profile (high thalassaemia and autoimmune disease prevalence) and a distinct HLA haplotype distribution, which is scientifically relevant for HLA reference panels.",
  "note": "Sardegna is an island region with its own procurement. Clinically important out of proportion to volume because of the Sardinian founder population.",
  "source": "italy"
 },
 {
  "id": "fra-paris-bichat",
  "name": "Hopital Bichat-Claude Bernard (AP-HP)",
  "short": "Paris Bichat",
  "city": "Paris",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 48.8566,
  "lon": 2.3522,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2024,
    "total": 24,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 37,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not verified.",
  "note": "AP-HP thoracic transplant centre, second-largest French lung programme after Foch, and an AI-CARE dd-cfDNA trial site. No kidney programme.",
  "source": "france"
 },
 {
  "id": "fra-le-plessis-robinson-marie-lannelongue",
  "name": "Hopital Marie-Lannelongue (Groupe Hospitalier Paris Saint-Joseph)",
  "short": "Le Plessis-Robinson Marie-Lannelongue",
  "city": "Le Plessis-Robinson",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 46.6,
  "lon": 2.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "lung",
    "year": 2024,
    "total": 37,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 18,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "heart_lung",
    "year": 2024,
    "total": 6,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Specialist cardiothoracic transplant centre and, like Foch, a private non-profit rather than a CHU - so faster decision-making and direct commercial access, but a different funding basis for out-of-nomenclature acts. Dominant French centre for combined heart-lung.",
  "source": "france"
 },
 {
  "id": "ita-genova-san-martino",
  "name": "IRCCS Ospedale Policlinico San Martino",
  "short": "Genova San Martino",
  "city": "Genoa",
  "region": "Liguria",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 37,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 24,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 900,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 1,
  "labNote": "Genoa is also the home of IBMDR (at Ospedale Galliera), making the city a national hub for HSC donor HLA typing. Accreditation: EFI.",
  "note": "Liguria is a NITp member. Genoa's combination of a solid organ programme, a very large HSCT programme and the national marrow registry makes it the best single Italian city for a combined HLA typing plus chimerism proposition.",
  "source": "italy"
 },
 {
  "id": "usa-au-medical-center-inc",
  "name": "AU Medical Center, Inc.",
  "short": "AU Medical Center, Inc.",
  "city": "GA",
  "region": "GA",
  "iso3": "USA",
  "lat": 32.6,
  "lon": -83.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 58,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-children-s-medical-center-of-dallas",
  "name": "Children's Medical Center of Dallas",
  "short": "Children's Medical Center of Dallas",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 14,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 20,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 26,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-wurzburg",
  "name": "Transplantationszentrum Wurzburg",
  "short": "Wurzburg",
  "city": "Wurzburg",
  "region": "",
  "iso3": "DEU",
  "lat": 49.7913,
  "lon": 9.9534,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 36,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 24,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "fra-caen",
  "name": "CHU de Caen Normandie",
  "short": "Caen",
  "city": "Caen",
  "region": "Normandie",
  "iso3": "FRA",
  "lat": 49.1829,
  "lon": -0.3707,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 59,
    "living": 5,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 926,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "CHRU Caen awarded a contract on 20 Jan 2025 for 'produits d'histocompatibilite avec ou sans mise a disposition (MAD)' to Werfen. 'Mise a disposition' is the French reagent-rental model: the vendor provides the analyser and locks in reagent supply.",
  "note": "One of the few French histocompatibility contract awards with a confirmed date and winner: Werfen, 20 January 2025, on a reagent-rental (MAD) basis. Assume Werfen is incumbent here for the framework term.",
  "source": "france"
 },
 {
  "id": "ita-san-raffaele",
  "name": "IRCCS Ospedale San Raffaele",
  "short": "San Raffaele",
  "city": "Milan",
  "region": "Lombardia",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 59,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 800,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": "Accreditation: EFI.",
  "note": "Privately owned but SSN-accredited, so it can move faster than a public azienda on research collaborations while still being paid by the region. Home of Italy's leading islet transplantation and diabetes immunology programme and a very large allogeneic HSCT programme - relevant to chimerism monitoring.",
  "source": "italy"
 },
 {
  "id": "usa-osf-saint-francis-medical-center",
  "name": "OSF Saint Francis Medical Center",
  "short": "OSF Saint Francis Medical Center",
  "city": "IL",
  "region": "IL",
  "iso3": "USA",
  "lat": 40.0,
  "lon": -89.2,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 52,
    "living": 15,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 6,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-advocate-christ-medical-center",
  "name": "Advocate Christ Medical Center",
  "short": "Advocate Christ Medical Center",
  "city": "IL",
  "region": "IL",
  "iso3": "USA",
  "lat": 40.0,
  "lon": -89.2,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 34,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 23,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-banner-university-medical-center-tucso",
  "name": "Banner University Medical Center-Tucson",
  "short": "Banner University Medical Center-Tucson",
  "city": "AZ",
  "region": "AZ",
  "iso3": "USA",
  "lat": 34.2,
  "lon": -111.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 54,
    "living": 7,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "fra-poitiers",
  "name": "CHU de Poitiers",
  "short": "Poitiers",
  "city": "Poitiers",
  "region": "Nouvelle-Aquitaine",
  "iso3": "FRA",
  "lat": 46.5802,
  "lon": 0.3404,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 57,
    "living": 6,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 947,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Modest volume but disproportionate influence: Prof Antoine Thierry, head of nephrology at CHU Poitiers, is the current President of the Societe Francophone de Transplantation. Access to the SFT presidency matters more than 57 grafts a year.",
  "source": "france"
 },
 {
  "id": "usa-children-s-healthcare-of-atlanta-at-eg",
  "name": "Children's Healthcare of Atlanta at Egleston",
  "short": "Children's Healthcare of Atlanta at Egleston",
  "city": "GA",
  "region": "GA",
  "iso3": "USA",
  "lat": 32.6,
  "lon": -83.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 25,
    "living": 11,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 22,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 10,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-scripps-green-hospital",
  "name": "Scripps Green Hospital",
  "short": "Scripps Green Hospital",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 44,
    "living": 17,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 12,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-brescia",
  "name": "ASST degli Spedali Civili di Brescia",
  "short": "Brescia",
  "city": "Brescia",
  "region": "Lombardia",
  "iso3": "ITA",
  "lat": 45.5416,
  "lon": 10.2118,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 56,
    "living": 6,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 800,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Lombardia / ARIA. Very large paediatric haematology-oncology and HSCT programme.",
  "source": "italy"
 },
 {
  "id": "fra-brest",
  "name": "CHU de Brest - Hopital de la Cavale Blanche",
  "short": "Brest",
  "city": "Brest",
  "region": "Bretagne",
  "iso3": "FRA",
  "lat": 48.3904,
  "lon": -4.4861,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 56,
    "living": 6,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 547,
   "confidence": "verified",
   "method": "ABM Table R52. NOTE a data-quality caveat visible in the source: Brest reported 747 patients with no known graft failure but only 365 with follow-up within 12 months, giving an estimated 547. Brest has the weakest follow-up completeness of any French centre in this table, so treat its followed-cohort figure as softer than others."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Prof Yannick Le Meur (INSERM UMR1227) is the senior transplant nephrologist. The poor follow-up data completeness is itself a commercial opening: a surveillance product that also improves structured follow-up capture has an argument here that it does not have at Necker.",
  "source": "france"
 },
 {
  "id": "usa-childrens-hospital-los-angeles",
  "name": "Childrens Hospital Los Angeles",
  "short": "Childrens Hospital Los Angeles",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 20,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 29,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 7,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-koln",
  "name": "Transplantationszentrum Koln",
  "short": "Koln",
  "city": "Koln",
  "region": "",
  "iso3": "DEU",
  "lat": 50.9375,
  "lon": 6.9603,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 52,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "pancreas",
    "year": 2024,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-boston-children-s-hospital",
  "name": "Boston Children's Hospital",
  "short": "Boston Children's Hospital",
  "city": "MA",
  "region": "MA",
  "iso3": "USA",
  "lat": 42.3,
  "lon": -71.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 25,
    "living": 10,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 14,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 14,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "aut-ordensklinikum-linz-elisabethinen",
  "name": "Ordensklinikum Linz Elisabethinen",
  "short": "Ordensklinikum Linz Elisabethinen",
  "city": "Linz",
  "region": "",
  "iso3": "AUT",
  "lat": 48.3069,
  "lon": 14.2858,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 55,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-st-louis-children-s-hospital",
  "name": "St. Louis Children's Hospital",
  "short": "St. Louis Children's Hospital",
  "city": "MO",
  "region": "MO",
  "iso3": "USA",
  "lat": 38.4,
  "lon": -92.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 9,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 23,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 18,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-christiana-care-health-services",
  "name": "Christiana Care Health Services",
  "short": "Christiana Care Health Services",
  "city": "Newark",
  "region": "DE",
  "iso3": "USA",
  "lat": 39.687,
  "lon": -75.668,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 53,
    "living": 7,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-chu-toledo",
  "name": "Complejo Hospitalario Universitario de Toledo",
  "short": "CHU Toledo",
  "city": "Toledo",
  "region": "Castilla-La Mancha",
  "iso3": "ESP",
  "lat": 39.8628,
  "lon": -4.0273,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 53,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 480,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "deu-transplantationszentrum-aachen",
  "name": "Transplantationszentrum Aachen",
  "short": "Aachen",
  "city": "Aachen",
  "region": "",
  "iso3": "DEU",
  "lat": 50.7753,
  "lon": 6.0839,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 26,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 27,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-harbor-ucla-medical-center",
  "name": "Harbor UCLA Medical Center",
  "short": "Harbor UCLA Medical Center",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 52,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-hgu-castellon",
  "name": "Hospital General Universitario de Castellon",
  "short": "HGU Castellon",
  "city": "Castello de la Plana",
  "region": "Comunitat Valenciana",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 52,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 470,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "New kidney programme: first full year 2023 (26), 52 in 2024.",
  "source": "spain"
 },
 {
  "id": "usa-las-palmas-medical-center",
  "name": "Las Palmas Medical Center",
  "short": "Las Palmas Medical Center",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 52,
    "living": 11,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-memorial-hermann-hospital-university-o",
  "name": "Memorial Hermann Hospital, University of Texas at Houston",
  "short": "Memorial Hermann Hospital, University of Tex",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 11,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 23,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 14,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-memorial-hermann-tmc",
  "name": "Memorial Hermann-Texas Medical Center",
  "short": "Memorial Hermann TMC",
  "city": "Houston",
  "region": "TX",
  "iso3": "USA",
  "lat": 29.7604,
  "lon": -95.3698,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 23,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 11,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 4,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 14,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-michael-e-debakey-va-medical-center",
  "name": "Michael E. DeBakey VA Medical Center",
  "short": "Michael E. DeBakey VA Medical Center",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 34,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 14,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-seattle-children-s-hospital",
  "name": "Seattle Children's Hospital",
  "short": "Seattle Children's Hospital",
  "city": "WA",
  "region": "WA",
  "iso3": "USA",
  "lat": 47.4,
  "lon": -120.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 25,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 14,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 13,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-primary-children-s-hospital",
  "name": "Primary Children's Hospital",
  "short": "Primary Children's Hospital",
  "city": "UT",
  "region": "UT",
  "iso3": "USA",
  "lat": 39.3,
  "lon": -111.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 12,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 21,
    "living": 10,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 18,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "pol-uniwersytecki-szpital-kliniczny-w-pozn",
  "name": "Uniwersytecki Szpital Kliniczny w Poznaniu",
  "short": "Uniwersytecki Szpital Kliniczny w Poznaniu",
  "city": "Poznan",
  "region": "",
  "iso3": "POL",
  "lat": 52.4064,
  "lon": 16.9252,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 43,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 8,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "ita-firenze-careggi",
  "name": "Azienda Ospedaliero-Universitaria Careggi",
  "short": "Firenze Careggi",
  "city": "Florence",
  "region": "Toscana",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 50,
    "living": 8,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 700,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": "Careggi hosts the Toscana regional immunogenetics reference activity alongside Pisa. Accreditation: EFI.",
  "note": "Toscana / ESTAR procurement. Toscana consistently has the highest donor rate in Italy (104.3 pmp reported donors in 2024), so it is the densest demand region per head of population.",
  "source": "italy"
 },
 {
  "id": "usa-chop",
  "name": "Children's Hospital of Philadelphia",
  "short": "CHOP",
  "city": "Philadelphia",
  "region": "PA",
  "iso3": "USA",
  "lat": 39.9526,
  "lon": -75.1652,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 12,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 23,
    "living": 9,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 13,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-hennepin-county-medical-center",
  "name": "Hennepin County Medical Center",
  "short": "Hennepin County Medical Center",
  "city": "MN",
  "region": "MN",
  "iso3": "USA",
  "lat": 46.3,
  "lon": -94.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 49,
    "living": 11,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "fra-paris-necker-enfants-malades-paediatri",
  "name": "Hopital Necker-Enfants Malades (AP-HP), Nephrologie pediatrique / transplantation pediatrique",
  "short": "Paris Necker-Enfants Malades (paediatric)",
  "city": "Paris",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 48.8566,
  "lon": 2.3522,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 15,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 20,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 9,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 5,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 156,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "The only French centre performing paediatric transplantation across all four major organs. Dr Marina Charbit (paediatric nephrology, Necker) is Treasurer of the SFT. Combined with the adult service, Necker is a single site covering the widest range of French transplant use cases.",
  "source": "france"
 },
 {
  "id": "usa-rhode-island-hospital",
  "name": "Rhode Island Hospital",
  "short": "Rhode Island Hospital",
  "city": "Providence",
  "region": "RI",
  "iso3": "USA",
  "lat": 41.821,
  "lon": -71.409,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 49,
    "living": 19,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-st-john-medical-center",
  "name": "St John Medical Center",
  "short": "St John Medical Center",
  "city": "OK",
  "region": "OK",
  "iso3": "USA",
  "lat": 35.6,
  "lon": -97.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 49,
    "living": 15,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-iowa-methodist-medical-center",
  "name": "Iowa Methodist Medical Center",
  "short": "Iowa Methodist Medical Center",
  "city": "IA",
  "region": "IA",
  "iso3": "USA",
  "lat": 42.0,
  "lon": -93.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 47,
    "living": 11,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-hu-rio-hortega",
  "name": "Hospital Universitario Rio Hortega",
  "short": "HU Rio Hortega",
  "city": "Valladolid",
  "region": "Castilla y Leon",
  "iso3": "ESP",
  "lat": 41.6523,
  "lon": -4.7245,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "liver",
    "year": 2024,
    "total": 46,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Liver programme; one hepato-renal transplant recorded in 2023.",
  "source": "spain"
 },
 {
  "id": "swe-skanes-universitetssjukhus-lund",
  "name": "Skanes Universitetssjukhus (Lund)",
  "short": "Skanes Universitetssjukhus (Lund)",
  "city": "Lund",
  "region": "",
  "iso3": "SWE",
  "lat": 55.7047,
  "lon": 13.191,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2024,
    "total": 30,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 16,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "deu-transplantationszentrum-frankfurt-main",
  "name": "Transplantationszentrum Frankfurt/Main",
  "short": "Frankfurt/Main",
  "city": "Frankfurt/Main",
  "region": "",
  "iso3": "DEU",
  "lat": 50.1109,
  "lon": 8.6821,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 29,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 17,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "fra-marseille-nord",
  "name": "AP-HM Hopital Nord, Service de Chirurgie Thoracique et Transplantation pulmonaire",
  "short": "Marseille Nord",
  "city": "Marseille",
  "region": "Provence-Alpes-Cote d'Azur",
  "iso3": "FRA",
  "lat": 43.2965,
  "lon": 5.3698,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "lung",
    "year": 2024,
    "total": 45,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Second lung account in France and a high DCD user. Note this is a different AP-HM site from Hopital de la Conception (kidney/liver) and Hopital de la Timone (heart) - AP-HM splits its transplant activity across three hospitals, so 'Marseille' is three separate selling conversations.",
  "source": "france"
 },
 {
  "id": "ita-novara",
  "name": "Azienda Ospedaliero-Universitaria Maggiore della Carita",
  "short": "Novara",
  "city": "Novara",
  "region": "Piemonte",
  "iso3": "ITA",
  "lat": 45.4469,
  "lon": 8.6222,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 45,
    "living": 11,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 800,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Piemonte / SCR Piemonte.",
  "source": "italy"
 },
 {
  "id": "cze-fn-hradec-kralove",
  "name": "FN Hradec Kralove",
  "short": "FN Hradec Kralove",
  "city": "Hradec Kralove",
  "region": "",
  "iso3": "CZE",
  "lat": 50.2092,
  "lon": 15.8328,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 44,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "pol-4-wojskowy-szpital-kliniczny-z-polikli",
  "name": "4 Wojskowy Szpital Kliniczny z Poliklinika SPZOZ we Wroclawiu",
  "short": "4 Wojskowy Szpital Kliniczny z Poliklinika S",
  "city": "Wroclaw",
  "region": "",
  "iso3": "POL",
  "lat": 51.1079,
  "lon": 17.0385,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 36,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 6,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-children-s-hospital-colorado",
  "name": "Children's Hospital Colorado",
  "short": "Children's Hospital Colorado",
  "city": "CO",
  "region": "CO",
  "iso3": "USA",
  "lat": 39.0,
  "lon": -105.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 11,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 15,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 16,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-hcu-valencia",
  "name": "Hospital Clinico Universitario de Valencia",
  "short": "HCU Valencia",
  "city": "Valencia",
  "region": "Comunitat Valenciana",
  "iso3": "ESP",
  "lat": 39.4699,
  "lon": -0.3763,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 41,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 370,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Kidney programme restarted 2022 (16), 20 in 2023, 41 in 2024 - fastest-growing new kidney programme in Spain.",
  "source": "spain"
 },
 {
  "id": "deu-transplantationszentrum-dresden",
  "name": "Transplantationszentrum Dresden",
  "short": "Dresden",
  "city": "Dresden",
  "region": "",
  "iso3": "DEU",
  "lat": 51.0504,
  "lon": 13.7373,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 41,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "esp-chu-albacete",
  "name": "Complejo Hospitalario Universitario de Albacete",
  "short": "CHU Albacete",
  "city": "Albacete",
  "region": "Castilla-La Mancha",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 40,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 360,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "cze-fn-ostrava",
  "name": "FN Ostrava",
  "short": "FN Ostrava",
  "city": "Ostrava",
  "region": "",
  "iso3": "CZE",
  "lat": 49.8209,
  "lon": 18.2625,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 40,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "esp-hgu-elche",
  "name": "Hospital General Universitario de Elche",
  "short": "HGU Elche",
  "city": "Elche",
  "region": "Comunitat Valenciana",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 40,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 360,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "spain"
 },
 {
  "id": "deu-transplantationszentrum-homburg-saar",
  "name": "Transplantationszentrum Homburg/Saar",
  "short": "Homburg/Saar",
  "city": "Homburg/Saar",
  "region": "",
  "iso3": "DEU",
  "lat": 49.3167,
  "lon": 7.3333,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 18,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 22,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-albany-medical-center-hospital",
  "name": "Albany Medical Center Hospital",
  "short": "Albany Medical Center Hospital",
  "city": "NY",
  "region": "NY",
  "iso3": "USA",
  "lat": 42.9,
  "lon": -75.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 39,
    "living": 9,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-napoli-federico-ii",
  "name": "Azienda Ospedaliero-Universitaria Federico II",
  "short": "Napoli Federico II",
  "city": "Naples",
  "region": "Campania",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 39,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 600,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Campania procures through So.Re.Sa. S.p.A., the regional soggetto aggregatore. Campania is a large-population, low-donation region, so the prevalent dialysis and pre-transplant population is large but transplant throughput is not.",
  "source": "italy"
 },
 {
  "id": "fra-limoges",
  "name": "CHU de Limoges - Hopital Dupuytren",
  "short": "Limoges",
  "city": "Limoges",
  "region": "Nouvelle-Aquitaine",
  "iso3": "FRA",
  "lat": 45.8336,
  "lon": 1.2611,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 39,
    "living": 4,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 571,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Smallest mainland French adult kidney programme by annual volume, though it still follows 571 grafted patients.",
  "source": "france"
 },
 {
  "id": "usa-newark-beth-israel",
  "name": "Newark Beth Israel Medical Center",
  "short": "Newark Beth Israel",
  "city": "Newark",
  "region": "NJ",
  "iso3": "USA",
  "lat": 40.7357,
  "lon": -74.1724,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 18,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "kidney",
    "year": 2025,
    "total": 2,
    "living": 0,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2025,
    "total": 19,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-university-hospital",
  "name": "University Hospital",
  "short": "University Hospital",
  "city": "NJ",
  "region": "NJ",
  "iso3": "USA",
  "lat": 40.2,
  "lon": -74.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "liver",
    "year": 2025,
    "total": 38,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-varese",
  "name": "ASST Sette Laghi - Ospedale di Circolo e Fondazione Macchi",
  "short": "Varese",
  "city": "Varese",
  "region": "Lombardia",
  "iso3": "ITA",
  "lat": 45.8206,
  "lon": 8.8251,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 37,
    "living": 8,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 650,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Lombardia / ARIA.",
  "source": "italy"
 },
 {
  "id": "esp-fundacion-jimenez-diaz",
  "name": "Fundacion Jimenez Diaz",
  "short": "Fundacion Jimenez Diaz",
  "city": "Madrid",
  "region": "Comunidad de Madrid",
  "iso3": "ESP",
  "lat": 40.4168,
  "lon": -3.7038,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 37,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 340,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Quiron Salud-managed but publicly funded under a SERMAS concession (listed by ONT as 'Fundacion Jimenez Diaz-UTE'). Procurement runs through Quiron Salud group purchasing, not SERMAS - a genuinely different commercial route inside Madrid.",
  "source": "spain"
 },
 {
  "id": "usa-henrico-doctors-hospital",
  "name": "Henrico Doctors' Hospital",
  "short": "Henrico Doctors' Hospital",
  "city": "VA",
  "region": "VA",
  "iso3": "USA",
  "lat": 37.5,
  "lon": -78.9,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 37,
    "living": 14,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-presbyterian-hospital",
  "name": "Presbyterian Hospital",
  "short": "Presbyterian Hospital",
  "city": "NM",
  "region": "NM",
  "iso3": "USA",
  "lat": 34.4,
  "lon": -106.1,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 33,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 3,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-lubeck",
  "name": "Transplantationszentrum Lubeck",
  "short": "Lubeck",
  "city": "Lubeck",
  "region": "",
  "iso3": "DEU",
  "lat": 53.8655,
  "lon": 10.6866,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 36,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "pol-uniwersytecki-szpital-kliniczny-nr-4-w",
  "name": "Uniwersytecki Szpital Kliniczny nr 4 w Lublinie",
  "short": "Uniwersytecki Szpital Kliniczny nr 4 w Lubli",
  "city": "Lublin",
  "region": "",
  "iso3": "POL",
  "lat": 51.2465,
  "lon": 22.5684,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 36,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "ita-roma-umberto-i",
  "name": "Azienda Ospedaliero-Universitaria Policlinico Umberto I / Sapienza",
  "short": "Roma Umberto I",
  "city": "Rome",
  "region": "Lazio",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 20,
    "living": 5,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2020,
    "total": 15,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 700,
   "confidence": "estimated",
   "method": "Large prevalent follow-up cohort relative to current activity because of historically higher throughput."
  },
  "tier": 2,
  "labNote": "Accreditation: EFI.",
  "note": "Lazio purchases via the regional soggetto aggregatore (Direzione Centrale Acquisti, Regione Lazio). Umberto I's declining transplant volume but large prevalent cohort makes it a better target for surveillance-of-existing-grafts than for peri-transplant products.",
  "source": "italy"
 },
 {
  "id": "cze-fn-olomouc",
  "name": "FN Olomouc",
  "short": "FN Olomouc",
  "city": "Olomouc",
  "region": "",
  "iso3": "CZE",
  "lat": 49.5938,
  "lon": 17.2509,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 35,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "pol-narodowy-instytut-kardiologii-warszawa",
  "name": "Narodowy Instytut Kardiologii, Warszawa",
  "short": "Narodowy Instytut Kardiologii, Warszawa",
  "city": "Warsaw",
  "region": "",
  "iso3": "POL",
  "lat": 52.2297,
  "lon": 21.0122,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2024,
    "total": 35,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-sanford-medical-center-fargo",
  "name": "Sanford Medical Center Fargo",
  "short": "Sanford Medical Center Fargo",
  "city": "ND",
  "region": "ND",
  "iso3": "USA",
  "lat": 47.4,
  "lon": -100.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 35,
    "living": 4,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-stuttgart",
  "name": "Transplantationszentrum Stuttgart",
  "short": "Stuttgart",
  "city": "Stuttgart",
  "region": "",
  "iso3": "DEU",
  "lat": 48.7758,
  "lon": 9.1829,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 35,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-maine-medical-center",
  "name": "Maine Medical Center",
  "short": "Maine Medical Center",
  "city": "Portland",
  "region": "ME",
  "iso3": "USA",
  "lat": 43.652,
  "lon": -70.276,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 34,
    "living": 14,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-north-austin-medical-center",
  "name": "North Austin Medical Center",
  "short": "North Austin Medical Center",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 34,
    "living": 18,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-parkland",
  "name": "Parkland Health",
  "short": "Parkland",
  "city": "Dallas",
  "region": "TX",
  "iso3": "USA",
  "lat": 32.7767,
  "lon": -96.797,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 34,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system.",
  "source": "usa"
 },
 {
  "id": "usa-parkland-health-and-hospital-system",
  "name": "Parkland Health and Hospital System",
  "short": "Parkland Health and Hospital System",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 34,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-berlin-dhz",
  "name": "Transplantationszentrum Berlin DHZ",
  "short": "Berlin DHZ",
  "city": "Berlin DHZ",
  "region": "",
  "iso3": "DEU",
  "lat": 52.52,
  "lon": 13.405,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2024,
    "total": 34,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "pol-uniwersytecki-szpital-kliniczny-w-bial",
  "name": "Uniwersytecki Szpital Kliniczny w Bialymstoku",
  "short": "Uniwersytecki Szpital Kliniczny w Bialymstok",
  "city": "Bialystok",
  "region": "",
  "iso3": "POL",
  "lat": 53.1325,
  "lon": 23.1688,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 34,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-baystate",
  "name": "Baystate Medical Center",
  "short": "Baystate",
  "city": "Springfield",
  "region": "MA",
  "iso3": "USA",
  "lat": 39.7817,
  "lon": -89.6501,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 33,
    "living": 5,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Reported by the centre as an in-house histocompatibility laboratory. ASHI and/or CAP accreditation assumed from the fact that CMS requires an ASHI- or CAP-accredited HLA laboratory to support an OPTN-approved transplant programme; not individually verified against the ASHI accredited-laboratory directory in this run. Verify at https://www.ashi-hla.org before commercial use. Accreditation: ASHI, CAP.",
  "note": "US transplant centres do not tender for send-out molecular surveillance. Adoption is driven by the transplant nephrologist/surgeon ordering the test, with the laboratory billing the payer directly. Entry therefore requires (a) MolDX coverage, (b) a field sales/medical-science-liaison motion at programme level, (c) EHR order-set integration (Epic) at the health system. Top-20 US kidney volume centre: a priority account for any surveillance assay, and almost certainly already an AlloSure or Prospera account.",
  "source": "usa"
 },
 {
  "id": "fra-pointe-a-pitre",
  "name": "CHU de la Guadeloupe - Hopital Ricou, Pointe-a-Pitre/Abymes",
  "short": "Pointe-a-Pitre",
  "city": "Les Abymes (Guadeloupe)",
  "region": "Guadeloupe (DOM)",
  "iso3": "FRA",
  "lat": 46.6,
  "lon": 2.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 33,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 302,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Not verified. Caribbean overseas department; sample logistics to mainland laboratories are a material constraint.",
  "note": "Small but strategically relevant for the same reason as La Reunion: an isolated, high-CKD-burden population where centralised send-away testing is slow. A decentralised assay format has a logistics argument here that it does not have in Paris. Note also the high prevalence of APOL1 risk variants in Afro-Caribbean populations, which is directly relevant to a pre-transplant risk product.",
  "source": "france"
 },
 {
  "id": "usa-phoenix-children-s-hospital",
  "name": "Phoenix Children's Hospital",
  "short": "Phoenix Children's Hospital",
  "city": "AZ",
  "region": "AZ",
  "iso3": "USA",
  "lat": 34.2,
  "lon": -111.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 17,
    "living": 8,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 12,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-sacred-heart-hospital-pensacola",
  "name": "Sacred Heart Hospital Pensacola",
  "short": "Sacred Heart Hospital Pensacola",
  "city": "FL",
  "region": "FL",
  "iso3": "USA",
  "lat": 28.6,
  "lon": -82.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 33,
    "living": 6,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "omn-royal-hospital",
  "name": "The Royal Hospital, Muscat",
  "short": "Royal Hospital",
  "city": "Muscat",
  "region": "Muscat",
  "iso3": "OMN",
  "lat": 23.588,
  "lon": 58.3829,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 33,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 210,
   "confidence": "derived",
   "method": "Derived: 323 lifetime transplants x ~65% assumed still functioning = 210."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Sole national programme. Kidney since 1988, liver since 2017. Small but growing sharply. MOH Oman procurement.",
  "source": "gulf"
 },
 {
  "id": "deu-transplantationszentrum-augsburg",
  "name": "Transplantationszentrum Augsburg",
  "short": "Augsburg",
  "city": "Augsburg",
  "region": "",
  "iso3": "DEU",
  "lat": 48.3705,
  "lon": 10.8978,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 33,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "deu-transplantationszentrum-bonn",
  "name": "Transplantationszentrum Bonn",
  "short": "Bonn",
  "city": "Bonn",
  "region": "",
  "iso3": "DEU",
  "lat": 50.7374,
  "lon": 7.0982,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 13,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 20,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "pol-uniwersytecki-szpital-kliniczny-nr-2-p",
  "name": "Uniwersytecki Szpital Kliniczny nr 2 PUM w Szczecinie",
  "short": "Uniwersytecki Szpital Kliniczny nr 2 PUM w S",
  "city": "Szczecin",
  "region": "",
  "iso3": "POL",
  "lat": 53.4285,
  "lon": 14.5528,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 33,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "ita-vicenza",
  "name": "Ospedale San Bortolo di Vicenza (AULSS 8 Berica)",
  "short": "Vicenza",
  "city": "Vicenza",
  "region": "Veneto",
  "iso3": "ITA",
  "lat": 45.5455,
  "lon": 11.5354,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 32,
    "living": 9,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 450,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Veneto / Azienda Zero. Internationally known nephrology department (IRRIV - International Renal Research Institute Vicenza).",
  "source": "italy"
 },
 {
  "id": "pol-wojewodzki-szpital-specjalistyczny-w-o",
  "name": "Wojewodzki Szpital Specjalistyczny w Olsztynie",
  "short": "Wojewodzki Szpital Specjalistyczny w Olsztyn",
  "city": "Olsztyn",
  "region": "",
  "iso3": "POL",
  "lat": 53.7784,
  "lon": 20.4801,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 32,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "ita-napoli-cardarelli",
  "name": "A.O.R.N. Antonio Cardarelli",
  "short": "Napoli Cardarelli",
  "city": "Naples",
  "region": "Campania",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "liver",
    "year": 2020,
    "total": 31,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 350,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Campania / So.Re.Sa. The main liver programme in southern mainland Italy.",
  "source": "italy"
 },
 {
  "id": "ita-siena",
  "name": "Azienda Ospedaliero-Universitaria Senese, Policlinico Le Scotte",
  "short": "Siena",
  "city": "Siena",
  "region": "Toscana",
  "iso3": "ITA",
  "lat": 43.3188,
  "lon": 11.3308,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 31,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 650,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Toscana / ESTAR.",
  "source": "italy"
 },
 {
  "id": "deu-transplantationszentrum-hann-munden",
  "name": "Transplantationszentrum Hann. Munden",
  "short": "Hann. Munden",
  "city": "Hann. Munden",
  "region": "",
  "iso3": "DEU",
  "lat": 51.4167,
  "lon": 9.65,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 31,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "fra-lyon-hfme",
  "name": "Hospices Civils de Lyon - Hopital Femme Mere Enfant",
  "short": "Lyon HFME",
  "city": "Bron",
  "region": "Auvergne-Rhone-Alpes",
  "iso3": "FRA",
  "lat": 45.7333,
  "lon": 4.9114,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 19,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 11,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 164,
   "confidence": "verified",
   "method": "ABM Table R52 - the largest followed paediatric kidney cohort in France."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Largest followed paediatric kidney cohort in France (164).",
  "source": "france"
 },
 {
  "id": "usa-walter-reed-national-military-medical",
  "name": "Walter Reed National Military Medical Center at Bethesda",
  "short": "Walter Reed National Military Medical Center",
  "city": "DC",
  "region": "DC",
  "iso3": "USA",
  "lat": 38.9,
  "lon": -77.0,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 30,
    "living": 11,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-boston-medical-center",
  "name": "Boston Medical Center",
  "short": "Boston Medical Center",
  "city": "MA",
  "region": "MA",
  "iso3": "USA",
  "lat": 42.3,
  "lon": -71.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 29,
    "living": 8,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-erlanger-medical-center",
  "name": "Erlanger Medical Center",
  "short": "Erlanger Medical Center",
  "city": "TN",
  "region": "TN",
  "iso3": "USA",
  "lat": 35.8,
  "lon": -86.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 29,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-int-milano",
  "name": "Fondazione IRCCS Istituto Nazionale dei Tumori",
  "short": "INT Milano",
  "city": "Milan",
  "region": "Lombardia",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "liver",
    "year": 2020,
    "total": 29,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 400,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "The world reference centre for transplant oncology criteria. Relevant to a cfDNA product because tumour-derived cfDNA and donor-derived cfDNA share a technology base - a combined recurrence-plus-rejection surveillance proposition would land well here.",
  "source": "italy"
 },
 {
  "id": "ita-pavia-san-matteo",
  "name": "Fondazione IRCCS Policlinico San Matteo",
  "short": "Pavia San Matteo",
  "city": "Pavia",
  "region": "Lombardia",
  "iso3": "ITA",
  "lat": 45.1847,
  "lon": 9.1582,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 29,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 400,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": "San Matteo's Immunogenetics/Immunohaematology service is one of the strongest academic HLA laboratories in Italy and a very large allogeneic HSCT centre. Accreditation: EFI.",
  "note": "Lombardia / ARIA. A priority account for chimerism monitoring and HLA typing rather than solid-organ volume.",
  "source": "italy"
 },
 {
  "id": "fra-paris-hegp",
  "name": "Hopital Europeen Georges-Pompidou (AP-HP)",
  "short": "Paris HEGP",
  "city": "Paris",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 48.8566,
  "lon": 2.3522,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2024,
    "total": 29,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 6,
   "confidence": "verified",
   "method": "ABM Table R52 lists 'Paris Georges Pompidou (AP-HP)' with 6 followed kidney graft patients and marks it with an asterisk meaning 'equipe de suivi sans autorisation d'activite de greffe renale' - a follow-up team with no kidney transplant authorisation. HEGP does NOT perform kidney transplants."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Explicit correction to a common assumption: HEGP is a significant HEART transplant centre but has no kidney transplant programme, despite frequently being listed as a major AP-HP transplant site. Prof Philippe Menasche, the cardiac surgeon who chairs the Agence de la biomedecine's Comite medical et scientifique transplantation college, is based at HEGP - which makes this a low-volume but high-influence account.",
  "source": "france"
 },
 {
  "id": "usa-st-john-hospital-and-medical-center",
  "name": "St John Hospital and Medical Center",
  "short": "St John Hospital and Medical Center",
  "city": "MI",
  "region": "MI",
  "iso3": "USA",
  "lat": 44.3,
  "lon": -85.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 29,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "pol-usk-nr-1-im-n-barlickiego-w-lodzi",
  "name": "USK nr 1 im. N. Barlickiego w Lodzi",
  "short": "USK nr 1 im. N. Barlickiego w Lodzi",
  "city": "Lodz",
  "region": "",
  "iso3": "POL",
  "lat": 51.7592,
  "lon": 19.456,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 29,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-university-hospital-university-of-new",
  "name": "University Hospital, University of New Mexico Health Sciences Center",
  "short": "University Hospital, University of New Mexic",
  "city": "NM",
  "region": "NM",
  "iso3": "USA",
  "lat": 34.4,
  "lon": -106.1,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 29,
    "living": 4,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-abbott-northwestern-hospital",
  "name": "Abbott Northwestern Hospital",
  "short": "Abbott Northwestern Hospital",
  "city": "MN",
  "region": "MN",
  "iso3": "USA",
  "lat": 46.3,
  "lon": -94.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 12,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 16,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-giessen",
  "name": "Transplantationszentrum Giessen",
  "short": "Giessen",
  "city": "Giessen",
  "region": "",
  "iso3": "DEU",
  "lat": 50.5841,
  "lon": 8.6784,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 16,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 4,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 8,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-ucsf-medical-center-at-mission-bay",
  "name": "UCSF Medical Center at Mission Bay",
  "short": "UCSF Medical Center at Mission Bay",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 13,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 10,
    "living": 5,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-children-s-of-alabama",
  "name": "Children's of Alabama",
  "short": "Children's of Alabama",
  "city": "AL",
  "region": "AL",
  "iso3": "USA",
  "lat": 32.8,
  "lon": -86.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 17,
    "living": 3,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 8,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "che-kssg-st-gallen",
  "name": "Kantonsspital St. Gallen",
  "short": "KSSG St Gallen",
  "city": "St Gallen",
  "region": "St Gallen",
  "iso3": "CHE",
  "lat": 47.4245,
  "lon": 9.3767,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 27,
    "living": 5,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Six centres nationally, all enrolled in the Swiss Transplant Cohort Study, which prospectively captures essentially every Swiss solid organ recipient. Combined with the Analysenliste (a single national listing decision, manufacturer may apply directly) this makes Switzerland the highest reimbursement-probability-per-unit-of-effort market in the region despite its size. The only non-university Swiss transplant centre; kidney only.",
  "source": "rest_europe"
 },
 {
  "id": "usa-mary-hitchcock-memorial-hospital",
  "name": "Mary Hitchcock Memorial Hospital",
  "short": "Mary Hitchcock Memorial Hospital",
  "city": "NH",
  "region": "NH",
  "iso3": "USA",
  "lat": 43.7,
  "lon": -71.6,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 26,
    "living": 12,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-halle",
  "name": "Transplantationszentrum Halle",
  "short": "Halle",
  "city": "Halle",
  "region": "",
  "iso3": "DEU",
  "lat": 51.4825,
  "lon": 11.9705,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 26,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-avera-mckennan-hospital",
  "name": "Avera McKennan Hospital",
  "short": "Avera McKennan Hospital",
  "city": "SD",
  "region": "SD",
  "iso3": "USA",
  "lat": 44.4,
  "lon": -100.2,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 24,
    "living": 5,
    "confidence": "verified"
   },
   {
    "organ": "kidney_pancreas",
    "year": 2025,
    "total": 1,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "cze-fn-plzen",
  "name": "FN Plzen",
  "short": "FN Plzen",
  "city": "Plzen",
  "region": "",
  "iso3": "CZE",
  "lat": 49.7384,
  "lon": 13.3736,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 25,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "ita-treviso",
  "name": "Ospedale Ca' Foncello, Treviso (AULSS 2 Marca Trevigiana)",
  "short": "Treviso",
  "city": "Treviso",
  "region": "Veneto",
  "iso3": "ITA",
  "lat": 45.6669,
  "lon": 12.243,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 25,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 500,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Veneto / Azienda Zero.",
  "source": "italy"
 },
 {
  "id": "usa-sanford-health-usd-medical-center",
  "name": "Sanford Health/USD Medical Center",
  "short": "Sanford Health/USD Medical Center",
  "city": "SD",
  "region": "SD",
  "iso3": "USA",
  "lat": 44.4,
  "lon": -100.2,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 25,
    "living": 6,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-bambino-gesu",
  "name": "IRCCS Ospedale Pediatrico Bambino Gesu",
  "short": "Bambino Gesu",
  "city": "Rome",
  "region": "Lazio",
  "iso3": "ITA",
  "lat": 42.8,
  "lon": 12.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 24,
    "living": 6,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 350,
   "confidence": "estimated",
   "method": "Paediatric grafts have long survival, so the prevalent followed cohort is large relative to annual volume."
  },
  "tier": 2,
  "labNote": "Very large paediatric allogeneic HSCT programme including haploidentical TCR-alpha/beta depleted transplants - a major chimerism monitoring account. Accreditation: EFI.",
  "note": "Paediatric transplantation is where non-invasive rejection surveillance has the strongest clinical argument (biopsy under general anaesthetic). Bambino Gesu is the obvious Italian paediatric reference site and has a strong record of adopting novel molecular diagnostics.",
  "source": "italy"
 },
 {
  "id": "deu-transplantationszentrum-munchen-rdi",
  "name": "Transplantationszentrum Munchen rdI",
  "short": "Munchen rdI",
  "city": "Munchen rdI",
  "region": "",
  "iso3": "DEU",
  "lat": 48.1372,
  "lon": 11.6009,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 24,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "fra-paris-robert-debre",
  "name": "Hopital Robert Debre (AP-HP), Service de Nephrologie pediatrique",
  "short": "Paris Robert Debre",
  "city": "Paris",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 48.8566,
  "lon": 2.3522,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 23,
    "living": 7,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 121,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "The largest French paediatric kidney programme. Paediatric transplantation is the strongest clinical case for non-invasive surveillance anywhere in transplant medicine, because protocol biopsy in children requires general anaesthesia. Small numbers, but the clinical argument writes itself and paediatric nephrologists are influential guideline authors. Note ABM pools Robert Debre's living-donor FAG funding with Saint-Louis.",
  "source": "france"
 },
 {
  "id": "deu-transplantationszentrum-magdeburg",
  "name": "Transplantationszentrum Magdeburg",
  "short": "Magdeburg",
  "city": "Magdeburg",
  "region": "",
  "iso3": "DEU",
  "lat": 52.1205,
  "lon": 11.6276,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "liver",
    "year": 2024,
    "total": 23,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-children-s-mercy-hospital",
  "name": "Children's Mercy Hospital",
  "short": "Children's Mercy Hospital",
  "city": "MO",
  "region": "MO",
  "iso3": "USA",
  "lat": 38.4,
  "lon": -92.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 7,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 9,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 6,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "prt-hospital-garcia-de-orta",
  "name": "Hospital Garcia de Orta",
  "short": "Hospital Garcia de Orta",
  "city": "Almada",
  "region": "",
  "iso3": "PRT",
  "lat": 38.679,
  "lon": -9.1569,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 22,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-rady-children-s-hospital-and-health-ce",
  "name": "Rady Children's Hospital and Health Center",
  "short": "Rady Children's Hospital and Health Center",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 11,
    "living": 4,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 7,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-mannheim",
  "name": "Transplantationszentrum Mannheim",
  "short": "Mannheim",
  "city": "Mannheim",
  "region": "",
  "iso3": "DEU",
  "lat": 49.4875,
  "lon": 8.466,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 22,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "esp-hu-ns-de-candelaria",
  "name": "Hospital Universitario Nuestra Senora de Candelaria",
  "short": "HU NS de Candelaria",
  "city": "Santa Cruz de Tenerife",
  "region": "Canarias",
  "iso3": "ESP",
  "lat": 28.4636,
  "lon": -16.2518,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "liver",
    "year": 2024,
    "total": 21,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Liver programme.",
  "source": "spain"
 },
 {
  "id": "usa-memorial-medical-center",
  "name": "Memorial Medical Center",
  "short": "Memorial Medical Center",
  "city": "IL",
  "region": "IL",
  "iso3": "USA",
  "lat": 40.0,
  "lon": -89.2,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 21,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-west-virginia-university-hospital",
  "name": "West Virginia University Hospital",
  "short": "West Virginia University Hospital",
  "city": "Morgantown",
  "region": "WV",
  "iso3": "USA",
  "lat": 39.656,
  "lon": -79.956,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 13,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 8,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "pol-wojewodzki-szpital-zespolony-w-kielcac",
  "name": "Wojewodzki Szpital Zespolony w Kielcach",
  "short": "Wojewodzki Szpital Zespolony w Kielcach",
  "city": "Kielce",
  "region": "",
  "iso3": "POL",
  "lat": 50.8661,
  "lon": 20.6286,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 21,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "deu-transplantationszentrum-gottingen",
  "name": "Transplantationszentrum Gottingen",
  "short": "Gottingen",
  "city": "Gottingen",
  "region": "",
  "iso3": "DEU",
  "lat": 51.5413,
  "lon": 9.9158,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 15,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2024,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "esp-hcu-lozano-blesa",
  "name": "Hospital Clinico Universitario Lozano Blesa",
  "short": "HCU Lozano Blesa",
  "city": "Zaragoza",
  "region": "Aragon",
  "iso3": "ESP",
  "lat": 41.6488,
  "lon": -0.8891,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "liver",
    "year": 2024,
    "total": 19,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Liver-only transplant centre; kidney transplantation in Aragon is at Miguel Servet.",
  "source": "spain"
 },
 {
  "id": "esp-hu-san-pedro",
  "name": "Hospital Universitario San Pedro",
  "short": "HU San Pedro",
  "city": "Logrono",
  "region": "La Rioja",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 19,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 170,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Smallest kidney programme in Spain (19 in 2024).",
  "source": "spain"
 },
 {
  "id": "usa-children-s-hospital-of-wisconsin",
  "name": "Children's Hospital of Wisconsin",
  "short": "Children's Hospital of Wisconsin",
  "city": "WI",
  "region": "WI",
  "iso3": "USA",
  "lat": 44.6,
  "lon": -89.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 7,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 7,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-children-s-national-medical-center",
  "name": "Children's National Medical Center",
  "short": "Children's National Medical Center",
  "city": "DC",
  "region": "DC",
  "iso3": "USA",
  "lat": 38.9,
  "lon": -77.0,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 9,
    "living": 7,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 9,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-le-bonheur-children-s-medical-center",
  "name": "Le Bonheur Children's Medical Center",
  "short": "Le Bonheur Children's Medical Center",
  "city": "TN",
  "region": "TN",
  "iso3": "USA",
  "lat": 35.8,
  "lon": -86.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 9,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-marburg",
  "name": "Transplantationszentrum Marburg",
  "short": "Marburg",
  "city": "Marburg",
  "region": "",
  "iso3": "DEU",
  "lat": 50.8021,
  "lon": 8.7667,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 18,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "esp-hu-dr-negrin",
  "name": "Hospital Universitario de Gran Canaria Doctor Negrin",
  "short": "HU Dr Negrin",
  "city": "Las Palmas de Gran Canaria",
  "region": "Canarias",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "lung",
    "year": 2024,
    "total": 17,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Newest lung programme in Spain; first transplants 2023 (6), 17 in 2024.",
  "source": "spain"
 },
 {
  "id": "usa-long-island-jewish-medical-center-cohe",
  "name": "Long Island Jewish Medical Center-Cohen Children's Medical Center",
  "short": "Long Island Jewish Medical Center-Cohen Chil",
  "city": "NY",
  "region": "NY",
  "iso3": "USA",
  "lat": 42.9,
  "lon": -75.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 15,
    "living": 6,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "prt-hospital-de-santa-marta",
  "name": "Hospital de Santa Marta",
  "short": "Hospital de Santa Marta",
  "city": "Lisbon",
  "region": "",
  "iso3": "PRT",
  "lat": 38.7223,
  "lon": -9.1393,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2024,
    "total": 16,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-james-j-peters-va-medical-center",
  "name": "James J. Peters VA Medical Center",
  "short": "James J. Peters VA Medical Center",
  "city": "NY",
  "region": "NY",
  "iso3": "USA",
  "lat": 42.9,
  "lon": -75.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 16,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "pol-krakowski-szpital-specjalistyczny-im-s",
  "name": "Krakowski Szpital Specjalistyczny im. sw. Jana Pawla II",
  "short": "Krakowski Szpital Specjalistyczny im. sw. Ja",
  "city": "Krakow",
  "region": "",
  "iso3": "POL",
  "lat": 50.0647,
  "lon": 19.945,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2024,
    "total": 14,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "lung",
    "year": 2024,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "deu-transplantationszentrum-bremen",
  "name": "Transplantationszentrum Bremen",
  "short": "Bremen",
  "city": "Bremen",
  "region": "",
  "iso3": "DEU",
  "lat": 53.0793,
  "lon": 8.8017,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 16,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-university-of-missouri-hospital-and-cl",
  "name": "University of Missouri Hospital and Clinics",
  "short": "University of Missouri Hospital and Clinics",
  "city": "MO",
  "region": "MO",
  "iso3": "USA",
  "lat": 38.4,
  "lon": -92.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 15,
    "living": 3,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-children-s-hospital-of-michigan",
  "name": "Children's Hospital of Michigan",
  "short": "Children's Hospital of Michigan",
  "city": "MI",
  "region": "MI",
  "iso3": "USA",
  "lat": 44.3,
  "lon": -85.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 6,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 6,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-musc-children-s-hospital",
  "name": "MUSC Children's Hospital",
  "short": "MUSC Children's Hospital",
  "city": "SC",
  "region": "SC",
  "iso3": "USA",
  "lat": 33.9,
  "lon": -80.9,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 3,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 10,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-kaiserslautern",
  "name": "Transplantationszentrum Kaiserslautern",
  "short": "Kaiserslautern",
  "city": "Kaiserslautern",
  "region": "",
  "iso3": "DEU",
  "lat": 49.4401,
  "lon": 7.7491,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 14,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-penn-state-milton-s-hershey-medical-ce",
  "name": "Penn State Milton S Hershey Medical Center",
  "short": "Penn State Milton S Hershey Medical Center",
  "city": "PA",
  "region": "PA",
  "iso3": "USA",
  "lat": 40.9,
  "lon": -77.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 13,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-st-vincent-hospital-and-medical-center",
  "name": "St Vincent Hospital and Medical Center",
  "short": "St Vincent Hospital and Medical Center",
  "city": "OR",
  "region": "OR",
  "iso3": "USA",
  "lat": 43.9,
  "lon": -120.6,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 13,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-sutter-meidcal-center-sacramento",
  "name": "Sutter Meidcal Center Sacramento",
  "short": "Sutter Meidcal Center Sacramento",
  "city": "CA",
  "region": "CA",
  "iso3": "USA",
  "lat": 37.2,
  "lon": -119.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 13,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-koln-lindentha",
  "name": "Transplantationszentrum Koln-Lindenthal",
  "short": "Koln-Lindenthal",
  "city": "Koln-Lindenthal",
  "region": "",
  "iso3": "DEU",
  "lat": 50.9375,
  "lon": 6.9603,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "liver",
    "year": 2024,
    "total": 13,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-children-s-hospital",
  "name": "Children's Hospital",
  "short": "Children's Hospital",
  "city": "LA",
  "region": "LA",
  "iso3": "USA",
  "lat": 31.1,
  "lon": -92.0,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 12,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-norton-children-s-hospital",
  "name": "Norton Children's Hospital",
  "short": "Norton Children's Hospital",
  "city": "KY",
  "region": "KY",
  "iso3": "USA",
  "lat": 37.5,
  "lon": -85.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 6,
    "living": 2,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 6,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "ita-catania",
  "name": "Azienda Ospedaliera Universitaria Policlinico Rodolico - San Marco / Catania",
  "short": "Catania",
  "city": "Catania",
  "region": "Sicilia",
  "iso3": "ITA",
  "lat": 37.5079,
  "lon": 15.083,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2022,
    "total": 11,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 350,
   "confidence": "estimated",
   "method": "Derived by the research pass."
  },
  "tier": 2,
  "labNote": null,
  "note": "Low priority on volume; the long waiting list (144 at end 2022) with a 61-month mean wait, the longest in Italy, makes it a candidate for pre-transplant risk products rather than post-transplant surveillance.",
  "source": "italy"
 },
 {
  "id": "usa-upmc-hamot",
  "name": "UPMC Hamot",
  "short": "UPMC Hamot",
  "city": "PA",
  "region": "PA",
  "iso3": "USA",
  "lat": 40.9,
  "lon": -77.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 11,
    "living": 5,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "fra-toulouse-purpan-paediatric",
  "name": "CHU de Toulouse - Hopital des Enfants (Purpan)",
  "short": "Toulouse Purpan (paediatric)",
  "city": "Toulouse",
  "region": "Occitanie",
  "iso3": "FRA",
  "lat": 43.6047,
  "lon": 1.4442,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 10,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 30,
   "confidence": "verified",
   "method": "ABM Table R52."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Paediatric arm of the largest French adult kidney centre; FAG living-donor funding is pooled with Toulouse Rangueil.",
  "source": "france"
 },
 {
  "id": "bhr-smc",
  "name": "Salmaniya Medical Complex",
  "short": "SMC",
  "city": "Manama",
  "region": "Capital Governorate",
  "iso3": "BHR",
  "lat": 26.2285,
  "lon": 50.586,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 0,
    "total": 10,
    "living": null,
    "confidence": "estimated"
   }
  ],
  "prevalentGrafts": {
   "value": 150,
   "confidence": "estimated",
   "method": "Very rough, based on a long-running low-volume programme. Unverified."
  },
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Too small to be a standalone commercial target. Relevant only as a bolt-on to a GCC-wide distributor agreement.",
  "source": "gulf"
 },
 {
  "id": "usa-sanford-bismarck-medical-center",
  "name": "Sanford Bismarck Medical Center",
  "short": "Sanford Bismarck Medical Center",
  "city": "ND",
  "region": "ND",
  "iso3": "USA",
  "lat": 47.4,
  "lon": -100.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 10,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "deu-transplantationszentrum-rostock",
  "name": "Transplantationszentrum Rostock",
  "short": "Rostock",
  "city": "Rostock",
  "region": "",
  "iso3": "DEU",
  "lat": 54.0924,
  "lon": 12.0991,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 4,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2024,
    "total": 6,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-baptist-medical-center",
  "name": "Baptist Medical Center",
  "short": "Baptist Medical Center",
  "city": "AR",
  "region": "AR",
  "iso3": "USA",
  "lat": 34.9,
  "lon": -92.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 9,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-baptist-memorial-hospital",
  "name": "Baptist Memorial Hospital",
  "short": "Baptist Memorial Hospital",
  "city": "TN",
  "region": "TN",
  "iso3": "USA",
  "lat": 35.8,
  "lon": -86.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 9,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-cardinal-glennon-children-s-hospital",
  "name": "Cardinal Glennon Children's Hospital",
  "short": "Cardinal Glennon Children's Hospital",
  "city": "MO",
  "region": "MO",
  "iso3": "USA",
  "lat": 38.4,
  "lon": -92.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 7,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-covenant-medical-center",
  "name": "Covenant Medical Center",
  "short": "Covenant Medical Center",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 9,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-halifax-medical-center",
  "name": "Halifax Medical Center",
  "short": "Halifax Medical Center",
  "city": "FL",
  "region": "FL",
  "iso3": "USA",
  "lat": 28.6,
  "lon": -82.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 9,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-alfred-i-dupont-hospital-for-children",
  "name": "Alfred I DuPont Hospital for Children",
  "short": "Alfred I DuPont Hospital for Children",
  "city": "DE",
  "region": "DE",
  "iso3": "USA",
  "lat": 39.0,
  "lon": -75.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 3,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "liver",
    "year": 2025,
    "total": 3,
    "living": null,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-arkansas-children-s-hospital",
  "name": "Arkansas Children's Hospital",
  "short": "Arkansas Children's Hospital",
  "city": "AR",
  "region": "AR",
  "iso3": "USA",
  "lat": 34.9,
  "lon": -92.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 3,
    "living": 1,
    "confidence": "verified"
   },
   {
    "organ": "heart",
    "year": 2025,
    "total": 4,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-helen-devos-children-s-hospital",
  "name": "Helen DeVos Children's Hospital",
  "short": "Helen DeVos Children's Hospital",
  "city": "MI",
  "region": "MI",
  "iso3": "USA",
  "lat": 44.3,
  "lon": -85.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 7,
    "living": 4,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "esp-h-sant-joan-de-deu",
  "name": "Hospital Sant Joan de Deu",
  "short": "H Sant Joan de Deu",
  "city": "Esplugues de Llobregat",
  "region": "Cataluna",
  "iso3": "ESP",
  "lat": 40.2,
  "lon": -3.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2024,
    "total": 7,
    "living": 0,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": {
   "value": 60,
   "confidence": "estimated",
   "method": "Modelled, not published. Spain has roughly 37,000 prevalent functioning kidney grafts nationally against 4,049 kidney transplants in 2024, a ratio of about 9.1 prevalent grafts per annual transplant. That national ratio is applied to this centre's 2024 kidney volume and rounded to the nearest 10. It will over-state centres whose volume grew sharply in the last three years (HCU Valencia, HGU Castel"
  },
  "tier": 2,
  "labNote": null,
  "note": "Paediatric-only kidney programme (7 in 2024) and 8.8 percent of national paediatric kidney waiting list.",
  "source": "spain"
 },
 {
  "id": "usa-memorial-regional-hospital-joe-dimaggi",
  "name": "Memorial Regional Hospital/Joe DiMaggio Children's Hospital",
  "short": "Memorial Regional Hospital/Joe DiMaggio Chil",
  "city": "Hollywood",
  "region": "FL",
  "iso3": "USA",
  "lat": 26.011,
  "lon": -80.162,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 7,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-seton-medical-center-austin",
  "name": "Seton Medical Center Austin",
  "short": "Seton Medical Center Austin",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 7,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "pol-wielkopolskie-centrum-pulmonologii-i-t",
  "name": "Wielkopolskie Centrum Pulmonologii i Torakochirurgii, Poznan",
  "short": "Wielkopolskie Centrum Pulmonologii i Torakoc",
  "city": "Poznan",
  "region": "",
  "iso3": "POL",
  "lat": 52.4064,
  "lon": 16.9252,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "lung",
    "year": 2024,
    "total": 7,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "national_registry"
 },
 {
  "id": "usa-cook-children-s-medical-center",
  "name": "Cook Children's Medical Center",
  "short": "Cook Children's Medical Center",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 6,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-driscoll-children-s-hospital",
  "name": "Driscoll Children's Hospital",
  "short": "Driscoll Children's Hospital",
  "city": "TX",
  "region": "TX",
  "iso3": "USA",
  "lat": 31.5,
  "lon": -99.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 6,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-the-iowa-city-va-health-care-system",
  "name": "The Iowa City VA Health Care System",
  "short": "Iowa City VA Health Care System",
  "city": "IA",
  "region": "IA",
  "iso3": "USA",
  "lat": 42.0,
  "lon": -93.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 5,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-children-s-hospital-of-the-king-s-daug",
  "name": "Children's Hospital of the King's Daughters",
  "short": "Children's Hospital of the King's Daughters",
  "city": "VA",
  "region": "VA",
  "iso3": "USA",
  "lat": 37.5,
  "lon": -78.9,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 3,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-birmingham-va-medical-center",
  "name": "Birmingham VA Medical Center",
  "short": "Birmingham VA Medical Center",
  "city": "AL",
  "region": "AL",
  "iso3": "USA",
  "lat": 32.8,
  "lon": -86.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-cardiovascular-center-of-puerto-rico-a",
  "name": "Cardiovascular Center of Puerto Rico and the Caribbean",
  "short": "Cardiovascular Center of Puerto Rico and the",
  "city": "PR",
  "region": "PR",
  "iso3": "USA",
  "lat": 18.2,
  "lon": -66.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-children-s-hospital-of-oklahoma",
  "name": "Children's Hospital of Oklahoma",
  "short": "Children's Hospital of Oklahoma",
  "city": "OK",
  "region": "OK",
  "iso3": "USA",
  "lat": 35.6,
  "lon": -97.5,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-johns-hopkins-all-children-s-hospital",
  "name": "Johns Hopkins All Children's Hospital",
  "short": "Johns Hopkins All Children's Hospital",
  "city": "FL",
  "region": "FL",
  "iso3": "USA",
  "lat": 28.6,
  "lon": -82.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 2,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-st-christopher-s-hospital-for-children",
  "name": "St. Christopher's Hospital for Children",
  "short": "St. Christopher's Hospital for Children",
  "city": "PA",
  "region": "PA",
  "iso3": "USA",
  "lat": 40.9,
  "lon": -77.8,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 2,
    "living": 1,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-the-university-of-vermont-medical-cent",
  "name": "The University of Vermont Medical Center",
  "short": "University of Vermont Medical Center",
  "city": "VT",
  "region": "VT",
  "iso3": "USA",
  "lat": 44.1,
  "lon": -72.7,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "kidney",
    "year": 2025,
    "total": 2,
    "living": 2,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "usa-children-s-minnesota",
  "name": "Children's Minnesota",
  "short": "Children's Minnesota",
  "city": "MN",
  "region": "MN",
  "iso3": "USA",
  "lat": 46.3,
  "lon": -94.3,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [
   {
    "organ": "heart",
    "year": 2025,
    "total": 1,
    "living": null,
    "confidence": "verified"
   }
  ],
  "prevalentGrafts": null,
  "tier": 3,
  "labNote": null,
  "note": null,
  "source": "srtr"
 },
 {
  "id": "dnk-aarhus-uh",
  "name": "Aarhus University Hospital, Skejby",
  "short": "Aarhus UH",
  "city": "Aarhus",
  "region": "Midtjylland",
  "iso3": "DNK",
  "lat": 56.1629,
  "lon": 10.2039,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Second Danish centre. The Scandiatransplant office is physically located at Aarhus University Hospital, Skejby, which makes Aarhus unusually well connected to Nordic allocation policy.",
  "source": "rest_europe"
 },
 {
  "id": "tur-akdeniz-university",
  "name": "Akdeniz Universitesi Hastanesi - Organ Nakli Merkezi",
  "short": "Akdeniz University",
  "city": "Antalya",
  "region": "Antalya",
  "iso3": "TUR",
  "lat": 36.8969,
  "lon": 30.7133,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Turkey is structurally the most attractive VOLUME market in this region for pre-transplant risk assessment and post-transplant surveillance because of the enormous living-donor programme, and simultaneously the least attractive PRICE market because of SUT lira tariffs. The resolution is to sell into the private and health-tourism channel at international prices while using the public programme to generate evidence cheaply. Akdeniz is one of the three highest-volume Turkish living-donor kidney centres and one of the pioneers of paired kidney exchange in Turkey; it is also internationally known for composite tissue (face/limb) transplantation.",
  "source": "rest_europe"
 },
 {
  "id": "are-al-qassimi",
  "name": "Al Qassimi Hospital Organ Transplant Centre",
  "short": "Al Qassimi",
  "city": "Sharjah",
  "region": "Sharjah",
  "iso3": "ARE",
  "lat": 25.3463,
  "lon": 55.4209,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Falls under MOHAP/Emirates Health Services rather than DoH or DHA, a third UAE procurement route. Too new to be a target but worth tracking.",
  "source": "gulf"
 },
 {
  "id": "are-ahd",
  "name": "American Hospital Dubai",
  "short": "AHD",
  "city": "Dubai",
  "region": "Dubai",
  "iso3": "ARE",
  "lat": 25.2048,
  "lon": 55.2708,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "American Hospital Dubai is widely described as CAP-accredited and was among the first JCI-accredited hospitals in the Middle East, but this was not verified from a CAP or JCI source in this run. Accreditation: CAP, JCI.",
  "note": "If it operates a reference laboratory with CAP accreditation, its greater value to Scira may be as a regional send-out laboratory partner rather than as a transplant centre. Verify.",
  "source": "gulf"
 },
 {
  "id": "nld-amsterdam-umc",
  "name": "Amsterdam UMC",
  "short": "Amsterdam UMC",
  "city": "Amsterdam",
  "region": "Noord-Holland",
  "iso3": "NLD",
  "lat": 52.3676,
  "lon": 4.9041,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Large urban programme; Ziekenhuischeck publishes some quality indicators for Dutch hospitals and is a usable open source for partial volume data.",
  "source": "rest_europe"
 },
 {
  "id": "tur-ankara-university",
  "name": "Ankara Universitesi Tip Fakultesi - Ibn-i Sina Hastanesi",
  "short": "Ankara University",
  "city": "Ankara",
  "region": "Ankara",
  "iso3": "TUR",
  "lat": 39.9334,
  "lon": 32.8597,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Turkey is structurally the most attractive VOLUME market in this region for pre-transplant risk assessment and post-transplant surveillance because of the enormous living-donor programme, and simultaneously the least attractive PRICE market because of SUT lira tariffs. The resolution is to sell into the private and health-tourism channel at international prices while using the public programme to generate evidence cheaply.",
  "source": "rest_europe"
 },
 {
  "id": "esp-bst",
  "name": "Banc de Sang i Teixits",
  "short": "BST",
  "city": "Barcelona",
  "region": "Cataluna",
  "iso3": "ESP",
  "lat": 41.3874,
  "lon": 2.1686,
  "geo": "city",
  "kinds": [
   "reference_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Catalonia's regional blood and tissue bank. Hospital Clinic de Barcelona has tendered HLA reagents jointly for its own Immunology Service and for the BST, indicating a shared or coordinated histocompatibility function for the region. Accreditation: EFI (not confirmed in this pass).",
  "note": "A regional-level buyer, not a hospital. Winning here covers Catalan volume in one award. Procurement via contractaciopublica.gencat.cat.",
  "source": "spain"
 },
 {
  "id": "tur-baskent-university",
  "name": "Baskent Universitesi Hastanesi",
  "short": "Baskent University",
  "city": "Ankara",
  "region": "Ankara",
  "iso3": "TUR",
  "lat": 39.9334,
  "lon": 32.8597,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Turkey is structurally the most attractive VOLUME market in this region for pre-transplant risk assessment and post-transplant surveillance because of the enormous living-donor programme, and simultaneously the least attractive PRICE market because of SUT lira tariffs. The resolution is to sell into the private and health-tourism channel at international prices while using the public programme to generate evidence cheaply. Founded by Mehmet Haberal, who performed Turkey's first kidney transplant; Baskent has one of the longest-running and largest Turkish transplant series and a strong academic output. The most credible Turkish academic partner.",
  "source": "rest_europe"
 },
 {
  "id": "are-burjeel",
  "name": "Burjeel Medical City",
  "short": "Burjeel",
  "city": "Abu Dhabi",
  "region": "Abu Dhabi",
  "iso3": "ARE",
  "lat": 24.4539,
  "lon": 54.3773,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Private, listed, and therefore commercially motivated in a way state providers are not. Private groups can adopt a new test as a differentiator and bill it to Enhanced insurance or self-pay without waiting for a tariff code, which makes them the fastest possible route to first revenue even though the volume is small.",
  "source": "gulf"
 },
 {
  "id": "fra-chu-grenoble-h-i",
  "name": "CHU Grenoble Alpes - Laboratoire d'Immunologie / Immunogenetique HLA",
  "short": "CHU Grenoble H&I",
  "city": "Grenoble",
  "region": "",
  "iso3": "FRA",
  "lat": 45.1885,
  "lon": 5.7245,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "CHU Grenoble Alpes hosts a Laboratoire d'Immunologie with an HLA immunogenetics activity, publicly associated with Dr Martine Pernollet. Detail is thin; treat the lab-to-centre mapping as plausible rather than verified. Accreditation: ISO 15189.",
  "note": null,
  "source": "france"
 },
 {
  "id": "fra-chu-clermont-ferrand-hla",
  "name": "CHU de Clermont-Ferrand - service HLA",
  "short": "CHU Clermont-Ferrand HLA",
  "city": "Clermont-Ferrand",
  "region": "",
  "iso3": "FRA",
  "lat": 45.7772,
  "lon": 3.087,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "CHU de Clermont-Ferrand operates a dedicated HLA service listed among its clinical services. Relevant because Paul-Olivier Rouzaire, President of the Scientific Council of the Societe Francophone d'Histocompatibilite et d'Immunogenetique (SFHI), is associated with Clermont-Ferrand immunology - a small laboratory with outsized influence on French H&I professional standards. Accreditation inferred, not confirmed against the EFI register. Accreditation: EFI.",
  "note": null,
  "source": "france"
 },
 {
  "id": "fra-chu-lille-h-i",
  "name": "CHU de Lille - Institut d'Immunologie, UF 9874 Histocompatibilite - HLA",
  "short": "CHU Lille H&I",
  "city": "Lille",
  "region": "",
  "iso3": "FRA",
  "lat": 50.6292,
  "lon": 3.0573,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "CHU-internal (not EFS) histocompatibility laboratory, identified as unite fonctionnelle 9874 within the CHU de Lille Institut d'Immunologie. Scope covers organ transplantation, haematopoietic stem cell transplantation, HLA-disease association and transfusion. Whether it serves Amiens and Reims as well as Lille could not be confirmed and is flagged as unverified. Accreditation: EFI, ISO 15189.",
  "note": null,
  "source": "france"
 },
 {
  "id": "fra-chu-montpellier-h-i",
  "name": "CHU de Montpellier - Departement d'Immunologie, Hopital Saint-Eloi",
  "short": "CHU Montpellier H&I",
  "city": "Montpellier",
  "region": "",
  "iso3": "FRA",
  "lat": 43.6108,
  "lon": 3.8767,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "CHU-internal immunology department at Hopital Saint-Eloi, 80 avenue Augustin Fliche, historically led by Pr Jean-Francois Eliaou. The CHU de Montpellier LBM holds a COFRAC accreditation record. HLA/histocompatibility activity is attributed to this department but the specific EFI accreditation and the precise scope could not be confirmed; treat as partially verified. Montpellier matters strategically because CHU Montpellier Saint-Eloi is one of the nine AI-CARE dd-cfDNA trial sites and because Moglie Le Quintrec heads nephrology-transplantation there. Accreditation: ISO 15189 (COFRAC-accredited",
  "note": null,
  "source": "france"
 },
 {
  "id": "fra-chu-toulouse-h-i",
  "name": "CHU de Toulouse - Laboratoire d'Immunologie, secteur Histocompatibilite, Institut Federatif de Biologie",
  "short": "CHU Toulouse H&I",
  "city": "Toulouse",
  "region": "",
  "iso3": "FRA",
  "lat": 43.6047,
  "lon": 1.4442,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "One of only a handful of French HLA laboratories that is INSIDE the CHU rather than inside EFS, which matters commercially because the purchasing route is the hospital's own (UniHA/RESAH) rather than EFS national tendering. Located at the Institut Federatif de Biologie, Avenue Jean Dausset, 31300 Toulouse. Head of the immunology service is Pr Yves Renaudineau. Publicly stated technique stack is unusually explicit and unusually modern: HLA typing by NGS on BOTH Illumina and Nanopore, plus PCR-SSO and qPCR, pre- and post-graft alloimmunisation monitoring by Luminex, and pre-graft crossmatch. Alo",
  "note": null,
  "source": "france"
 },
 {
  "id": "che-chuv-lausanne",
  "name": "Centre Hospitalier Universitaire Vaudois",
  "short": "CHUV Lausanne",
  "city": "Lausanne",
  "region": "Vaud",
  "iso3": "CHE",
  "lat": 46.5197,
  "lon": 6.6323,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Six centres nationally, all enrolled in the Swiss Transplant Cohort Study, which prospectively captures essentially every Swiss solid organ recipient. Combined with the Analysenliste (a single national listing decision, manufacturer may apply directly) this makes Switzerland the highest reimbursement-probability-per-unit-of-effort market in the region despite its size.",
  "source": "rest_europe"
 },
 {
  "id": "bel-chu-liege",
  "name": "Centre Hospitalier Universitaire de Liege",
  "short": "CHU Liege",
  "city": "Liege",
  "region": "Liege",
  "iso3": "BEL",
  "lat": 50.6326,
  "lon": 5.5797,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Principal Walloon centre.",
  "source": "rest_europe"
 },
 {
  "id": "prt-chuc-coimbra",
  "name": "Centro Hospitalar e Universitario de Coimbra",
  "short": "CHUC Coimbra",
  "city": "Coimbra",
  "region": "Coimbra",
  "iso3": "PRT",
  "lat": 40.2033,
  "lon": -8.4103,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Historically Portugal's leading transplant centre, particularly for kidney and heart.",
  "source": "rest_europe"
 },
 {
  "id": "esp-ctcv",
  "name": "Centro de Transfusion de la Comunidad Valenciana",
  "short": "CTCV",
  "city": "Valencia",
  "region": "Comunitat Valenciana",
  "iso3": "ESP",
  "lat": 39.4699,
  "lon": -0.3763,
  "geo": "city",
  "kinds": [
   "reference_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Runs the regional histocompatibility laboratory for the Comunitat Valenciana. Its published award splits HLA work into lots including an explicit eleven-locus NGS typing lot, confirming that full high-resolution eleven-locus typing is routine public-sector practice in Spain. Accreditation: EFI (not confirmed in this pass).",
  "note": "Regional buyer covering six Valencian kidney programmes plus La Fe liver and lung. Lot-based awards mean a single-assay vendor CAN bid here, unlike the bundled Madrid contracts.",
  "source": "spain"
 },
 {
  "id": "deu-charite-berlin",
  "name": "Charite - Universitatsmedizin Berlin, Campus Virchow-Klinikum",
  "short": "Charite Berlin",
  "city": "Berlin",
  "region": "Berlin",
  "iso3": "DEU",
  "lat": 52.52,
  "lon": 13.405,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Charite HLA laboratory (Institut fur Transfusionsmedizin, HLA-Labor) is one of the larger German tissue typing centres. Accreditation: EFI.",
  "note": "THE priority German account. Largest kidney programme in the country, strong clinical trials infrastructure (Klemens Budde's group has run dd-cfDNA studies), and a track record of leading German expert consensus work on HLA delisting and desensitisation. If Scira wins one German account first, this is the one. Procurement runs through Charite central purchasing but a NUB application is a clinical-department-led act, not a purchasing act - which is why the clinician relationship comes first.",
  "source": "rest_europe"
 },
 {
  "id": "are-ccad",
  "name": "Cleveland Clinic Abu Dhabi",
  "short": "CCAD",
  "city": "Abu Dhabi",
  "region": "Abu Dhabi",
  "iso3": "ARE",
  "lat": 24.4539,
  "lon": 54.3773,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": {
   "value": 650,
   "confidence": "estimated",
   "method": "Crude split of ~900 lifetime transplants with high survival given the recent start date (2017), so most grafts are still functioning. Organ split is an assumption, not evidenced."
  },
  "tier": 2,
  "labNote": "CAP accreditation is stated at the Cleveland Clinic Abu Dhabi laboratory level in general hospital materials but was not independently confirmed from a CAP source in this run; treat as likely but unverified. Accreditation: JCI, CAP.",
  "note": "DoH Abu Dhabi has formally designated CCAD as Centre of Excellence for Adult Multi-Organ Transplants, which is the single strongest institutional endorsement available in the UAE. US clinical governance means US-style evidence packages (CLIA/CAP validation, US CPT/PLA precedent, CareDx/Natera comparators) translate directly. Purchasing sits within M42/PureHealth group procurement, which is a large centralised buyer covering multiple UAE assets.",
  "source": "gulf"
 },
 {
  "id": "bel-saint-luc-brussels",
  "name": "Cliniques universitaires Saint-Luc (UCLouvain)",
  "short": "Saint-Luc Brussels",
  "city": "Brussels",
  "region": "Brussels-Capital",
  "iso3": "BEL",
  "lat": 50.8503,
  "lon": 4.3517,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Major francophone multi-organ centre with a strong paediatric liver programme.",
  "source": "rest_europe"
 },
 {
  "id": "deu-dkms-lsl",
  "name": "DKMS Life Science Lab",
  "short": "DKMS LSL",
  "city": "Dresden",
  "region": "Sachsen",
  "iso3": "DEU",
  "lat": 51.0504,
  "lon": 13.7373,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "The largest HLA typing operation in the world. Up to about 7,000 cheek swab samples arrive daily; more than 100,000 donor samples can be analysed per month; more than 15,000 donors can be sequenced within 48 hours. Introduction of NGS took annual typing capacity from around 100,000 to around 800,000 donors and the lab now types over a million potential stem cell donors a year. It was the first HLA typing laboratory in the world to establish NGS for high-throughput typing and published the landmark '2.7 million samples genotyped for HLA by NGS' paper in BMC Genomics. Accreditation: EFI, ASHI.",
  "note": "Not a customer for a clinical transplant surveillance assay, but arguably the most important HLA account in the region for three reasons. First, it is the global benchmark for HLA typing cost per sample, and any Scira HLA claim will be measured against it. Second, it holds one of the world's largest HLA reference datasets, which makes it a uniquely valuable validation and imputation partner. Third, its throughput economics define what 'cheap' means in European HLA. Approach as a technology partner or reference-data collaborator, not as a sales target.",
  "source": "rest_europe"
 },
 {
  "id": "fra-efs-ile-de-france-hla",
  "name": "EFS Ile-de-France - Laboratoire HLA multisite",
  "short": "EFS Ile-de-France HLA",
  "city": "Ile-de-France (multisite)",
  "region": "",
  "iso3": "FRA",
  "lat": 46.6,
  "lon": 2.5,
  "geo": "approx",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "EFS Ile-de-France operates a MULTISITE HLA laboratory and a leuco-platelet immunology laboratory, referenced as a specialist referral destination by private laboratory networks (Eurofins-Biomnis routes HLA work to it). Ile-de-France therefore has TWO large H&I providers - the AP-HP Saint-Louis regional platform and the EFS multisite laboratory - which is unusual and means an Ile-de-France strategy needs both conversations. The exact site list could not be confirmed; a historic Assemblee Nationale question concerned closure of the EFS Rungis biology laboratory, so any site-level assumption shou",
  "note": null,
  "source": "france"
 },
 {
  "id": "fra-efs-normandie-h-i",
  "name": "EFS Normandie - Laboratoire d'Histocompatibilite et d'Immunogenetique, site de Bois-Guillaume (Rouen)",
  "short": "EFS Normandie H&I",
  "city": "Bois-Guillaume (Rouen)",
  "region": "",
  "iso3": "FRA",
  "lat": 46.6,
  "lon": 2.5,
  "geo": "approx",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "EFS Hauts-de-France Normandie's prelevement manual states that histocompatibility (HLA) and immunogenetics examinations are carried out at the Bois-Guillaume site north of Rouen, covering organ transplantation, haematopoietic stem cell transplantation and transfusion management. Coverage of Caen is inferred from geography, not documented. Accreditation: EFI, ISO 15189.",
  "note": null,
  "source": "france"
 },
 {
  "id": "fra-efs-pays-de-la-loire-h-i",
  "name": "EFS Pays de la Loire - Laboratoire d'Histocompatibilite et d'Immunogenetique (sites de Nantes et d'Angers)",
  "short": "EFS Pays de la Loire H&I",
  "city": "Nantes / Angers",
  "region": "",
  "iso3": "FRA",
  "lat": 47.2184,
  "lon": -1.5536,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "EFS Pays de la Loire's own prelevement manual states that the histocompatibility laboratories on the NANTES and ANGERS sites perform the examinations used to select organ donors (kidney, pancreas, heart, lung) for patients on the waiting list, and post-transplant monitoring. This is a clean, documented lab-to-centre mapping and the model for how the rest of the French network is organised: the transplanting CHU does the clinical work, the EFS regional laboratory does the histocompatibility. Commercially important because Nantes ITUN is one of the highest-value research accounts in France (CR2T",
  "note": null,
  "source": "france"
 },
 {
  "id": "fra-efs-paca-corse-h-i",
  "name": "EFS Provence-Alpes-Cote d'Azur et Corse - Laboratoire d'Histocompatibilite et d'Immunogenetique",
  "short": "EFS PACA-Corse H&I",
  "city": "Marseille",
  "region": "",
  "iso3": "FRA",
  "lat": 43.2965,
  "lon": 5.3698,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "The EFS PACA-Corse laboratory publishes its own prelevement manual covering histocompatibility. Dr Pascal Pedini of EFS PACA-Corse is the author of a widely circulated national teaching set on organ transplantation compatibility rules, which is good evidence that this laboratory carries the regional solid-organ histocompatibility function. Coverage of Nice as well as the two Marseille AP-HM programmes is inferred from the EFS regional footprint, not documented per centre. Accreditation: EFI, ISO 15189.",
  "note": null,
  "source": "france"
 },
 {
  "id": "tur-ege-university",
  "name": "Ege Universitesi Tip Fakultesi Hastanesi",
  "short": "Ege University",
  "city": "Izmir",
  "region": "Izmir",
  "iso3": "TUR",
  "lat": 38.4237,
  "lon": 27.1428,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Turkey is structurally the most attractive VOLUME market in this region for pre-transplant risk assessment and post-transplant surveillance because of the enormous living-donor programme, and simultaneously the least attractive PRICE market because of SUT lira tariffs. The resolution is to sell into the private and health-tourism channel at international prices while using the public programme to generate evidence cheaply.",
  "source": "rest_europe"
 },
 {
  "id": "fra-efs-lhi-network",
  "name": "Etablissement Francais du Sang - reseau des laboratoires d'histocompatibilite et d'immunogenetique",
  "short": "EFS LHI network",
  "city": "multiple (regional)",
  "region": "national",
  "iso3": "FRA",
  "lat": 46.6,
  "lon": 2.5,
  "geo": "approx",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "EFS operates histocompatibility and immunogenetics laboratories (LHI) organised on its regional establishment structure (Ile-de-France, Auvergne-Rhone-Alpes, Grand Est, Nouvelle-Aquitaine, Occitanie, Hauts-de-France Normandie, Bretagne, Pays de la Loire, Bourgogne-Franche-Comte, PACA-Corse). Two 2025 EFS tenders confirm the platform estate: reagents for HIGH-RESOLUTION HLA TYPING explicitly specified for MiSeq and Nanopore platforms (published 13 Oct 2025, awarded to Werfen) and reagents for Luminex single-antigen anti-HLA antibody identification (published 25 Jul 2025, awarded to Werfen). EFS",
  "note": "Treat EFS as one national account, not a set of regional ones. It tenders centrally, and both recent HLA tenders identified went to Werfen, so Werfen/Immucor should be assumed incumbent across much of the EFS estate. The fact that EFS explicitly tendered for reagents on Oxford Nanopore platforms in October 2025 is the most important single data point in this file for a nanopore-based product: EFS has already qualified nanopore as an acceptable clinical HLA typing platform. That removes the hardest objection a nanopore vendor normally faces in a conservative European laboratory market.",
  "source": "france"
 },
 {
  "id": "nld-et-reference-lab",
  "name": "Eurotransplant Reference Laboratory",
  "short": "ET Reference Lab",
  "city": "Leiden",
  "region": "Zuid-Holland",
  "iso3": "NLD",
  "lat": 52.1601,
  "lon": 4.497,
  "geo": "city",
  "kinds": [
   "reference_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Runs external quality assessment, reference typing and the serum bank underpinning the Acceptable Mismatch programme for highly sensitised patients. Sets the de facto technical standard for HLA typing and antibody definition across eight countries. Accreditation: EFI.",
  "note": "Standards-setting body, not a purchaser. But if the ET Reference Laboratory endorses a typing or antibody method, adoption across the whole Eurotransplant region becomes far easier. High-value, low-revenue relationship - invest in it early.",
  "source": "rest_europe"
 },
 {
  "id": "cze-fn-brno-cktch",
  "name": "Fakultni nemocnice Brno / Centrum kardiovaskularni a transplantacni chirurgie",
  "short": "FN Brno / CKTCH",
  "city": "Brno",
  "region": "Jihomoravsky",
  "iso3": "CZE",
  "lat": 49.1951,
  "lon": 16.6068,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Second Czech centre; CKTCH is the Brno cardiovascular and transplant surgery centre.",
  "source": "rest_europe"
 },
 {
  "id": "fin-hus-helsinki",
  "name": "HUS Helsinki University Hospital",
  "short": "HUS Helsinki",
  "city": "Helsinki",
  "region": "Uusimaa",
  "iso3": "FIN",
  "lat": 60.1699,
  "lon": 24.9384,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Accreditation: EFI.",
  "note": "ALL Finnish solid organ transplantation happens here, and Estonian deceased-donor heart transplants are performed here too (Scandiatransplant 2024 report). Laboratory counterparty is HUS Diagnostic Center / HUSLAB. Finland had the highest utilised deceased donor rate in the Nordic region in 2024 at 27.7 pmp and transplanted 48.1 deceased-donor kidneys pmp - the highest kidney transplant rate in the region.",
  "source": "rest_europe"
 },
 {
  "id": "bel-erasme-hub",
  "name": "Hopital Erasme / Hopital Universitaire de Bruxelles (HUB)",
  "short": "Erasme / HUB",
  "city": "Brussels",
  "region": "Brussels-Capital",
  "iso3": "BEL",
  "lat": 50.8503,
  "lon": 4.3517,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "The other major Brussels academic centre; historically strong in islet transplantation and diabetes.",
  "source": "rest_europe"
 },
 {
  "id": "che-hug-geneva",
  "name": "Hopitaux Universitaires de Geneve",
  "short": "HUG Geneva",
  "city": "Geneva",
  "region": "Geneva",
  "iso3": "CHE",
  "lat": 46.2044,
  "lon": 6.1432,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Six centres nationally, all enrolled in the Swiss Transplant Cohort Study, which prospectively captures essentially every Swiss solid organ recipient. Combined with the Analysenliste (a single national listing decision, manufacturer may apply directly) this makes Switzerland the highest reimbursement-probability-per-unit-of-effort market in the region despite its size. Geneva hosts a significant islet transplantation and cell therapy programme; Ekaterine Berishvili (ESOT Secretary 2025-2029) is based at the University of Geneva.",
  "source": "rest_europe"
 },
 {
  "id": "fra-strasbourg-h-i",
  "name": "Hopitaux Universitaires de Strasbourg - Laboratoire d'Immunologie, Hopital de Hautepierre; with EFS Grand Est histocompatibility laboratory on the Strasbourg site",
  "short": "Strasbourg H&I",
  "city": "Strasbourg",
  "region": "",
  "iso3": "FRA",
  "lat": 48.5734,
  "lon": 7.7521,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Two structures coexist in Strasbourg and it matters which one you sell to. (1) The Hopitaux Universitaires de Strasbourg Laboratoire d'Immunologie at Hopital de Hautepierre, publicly associated with Dr Mirjana Radosavljevic. (2) The EFS Alsace-Lorraine-Champagne-Ardenne (now EFS Grand Est) histocompatibility laboratory, located on the Strasbourg site. The Grand Est regional coverage claim (Nancy, Reims, Besancon) follows from the EFS regional structure and is NOT independently verified per centre. Accreditation: EFI, ISO 15189.",
  "note": null,
  "source": "france"
 },
 {
  "id": "esp-hu-donostia",
  "name": "Hospital Universitario Donostia",
  "short": "HU Donostia",
  "city": "San Sebastian",
  "region": "Pais Vasco",
  "iso3": "ESP",
  "lat": 43.3183,
  "lon": -1.9812,
  "geo": "city",
  "kinds": [
   "reference_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not a solid-organ transplant centre (Basque transplantation is at HU Cruces) but holds a high-resolution NGS HLA typing capability procured through Osakidetza's contracting platform.",
  "note": "Osakidetza procures through contratacion.euskadi.eus. The Basque Country funds ahead of national consensus and is a good second region after Catalonia.",
  "source": "spain"
 },
 {
  "id": "che-inselspital-bern",
  "name": "Inselspital, Universitatsspital Bern",
  "short": "Inselspital Bern",
  "city": "Bern",
  "region": "Bern",
  "iso3": "CHE",
  "lat": 46.948,
  "lon": 7.4474,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Six centres nationally, all enrolled in the Swiss Transplant Cohort Study, which prospectively captures essentially every Swiss solid organ recipient. Combined with the Analysenliste (a single national listing decision, manufacturer may apply directly) this makes Switzerland the highest reimbursement-probability-per-unit-of-effort market in the region despite its size.",
  "source": "rest_europe"
 },
 {
  "id": "prt-ipst",
  "name": "Instituto Portugues do Sangue e da Transplantacao",
  "short": "IPST",
  "city": "Lisbon/Porto/Coimbra",
  "region": "national",
  "iso3": "PRT",
  "lat": 38.7223,
  "lon": -9.1393,
  "geo": "city",
  "kinds": [
   "reference_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "IPST operates the national histocompatibility laboratories in Lisbon, Porto and Coimbra and coordinates national transplant activity. Accreditation: EFI.",
  "note": "The single national account for anything HLA-related in Portugal. One contract covers the country.",
  "source": "rest_europe"
 },
 {
  "id": "tur-medical-park-goztepe",
  "name": "Istanbul Goztepe Medical Park Hastanesi",
  "short": "Medical Park Goztepe",
  "city": "Istanbul",
  "region": "Istanbul",
  "iso3": "TUR",
  "lat": 41.0082,
  "lon": 28.9784,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Turkey is structurally the most attractive VOLUME market in this region for pre-transplant risk assessment and post-transplant surveillance because of the enormous living-donor programme, and simultaneously the least attractive PRICE market because of SUT lira tariffs. The resolution is to sell into the private and health-tourism channel at international prices while using the public programme to generate evidence cheaply. Reported among the top three Turkish centres for kidney exchange volume.",
  "source": "rest_europe"
 },
 {
  "id": "tur-medipol-mega",
  "name": "Istanbul Medipol Mega Universite Hastanesi",
  "short": "Medipol Mega",
  "city": "Istanbul",
  "region": "Istanbul",
  "iso3": "TUR",
  "lat": 41.0082,
  "lon": 28.9784,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Turkey is structurally the most attractive VOLUME market in this region for pre-transplant risk assessment and post-transplant surveillance because of the enormous living-donor programme, and simultaneously the least attractive PRICE market because of SUT lira tariffs. The resolution is to sell into the private and health-tourism channel at international prices while using the public programme to generate evidence cheaply. JCI-accredited, very high private and international volume.",
  "source": "rest_europe"
 },
 {
  "id": "aut-kuk-linz",
  "name": "Kepler Universitatsklinikum Linz",
  "short": "KUK Linz",
  "city": "Linz",
  "region": "Oberosterreich",
  "iso3": "AUT",
  "lat": 48.3069,
  "lon": 14.2858,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Kidney only.",
  "source": "rest_europe"
 },
 {
  "id": "sau-kamc-jeddah",
  "name": "King Abdulaziz Medical City, Jeddah (Ministry of National Guard Health Affairs)",
  "short": "KAMC Jeddah",
  "city": "Jeddah",
  "region": "Makkah Province",
  "iso3": "SAU",
  "lat": 21.4858,
  "lon": 39.1925,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Same MNGHA procurement route as Riyadh. Secondary target.",
  "source": "gulf"
 },
 {
  "id": "sau-kamc-riyadh",
  "name": "King Abdulaziz Medical City, Riyadh (Ministry of National Guard Health Affairs)",
  "short": "KAMC Riyadh",
  "city": "Riyadh",
  "region": "Riyadh Province",
  "iso3": "SAU",
  "lat": 24.7136,
  "lon": 46.6753,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not verified.",
  "note": "MNGHA is a third, separate procurement universe alongside MOH/NUPCO and Ministry of Defence. It is well funded, research-active (King Abdullah International Medical Research Centre sits within it) and runs its own tenders. Strong paediatric transplant and allogeneic HSCT activity makes it a natural chimerism-monitoring account.",
  "source": "gulf"
 },
 {
  "id": "sau-kfmc",
  "name": "King Fahad Medical City",
  "short": "KFMC",
  "city": "Riyadh",
  "region": "Riyadh Province",
  "iso3": "SAU",
  "lat": 24.7136,
  "lon": 46.6753,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not verified.",
  "note": "MOH facility, so NUPCO route. Unusually strong concentration of society office-holders, so disproportionate influence relative to volume.",
  "source": "gulf"
 },
 {
  "id": "sau-kfshrc-jeddah",
  "name": "King Faisal Specialist Hospital & Research Centre, Jeddah",
  "short": "KFSHRC Jeddah",
  "city": "Jeddah",
  "region": "Makkah Province",
  "iso3": "SAU",
  "lat": 21.4858,
  "lon": 39.1925,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Department of Pathology and Laboratory Medicine at the Jeddah site includes histocompatibility staff. CAP accreditation applies at the KFSHRC group level; site-specific scope not verified. Accreditation: CAP.",
  "note": "Western-region counterpart to Riyadh. Same institutional procurement route. Best treated as an expansion site after the Riyadh flagship, not a first target.",
  "source": "gulf"
 },
 {
  "id": "sau-ksumc",
  "name": "King Saud University Medical City (King Khalid University Hospital)",
  "short": "KSUMC",
  "city": "Riyadh",
  "region": "Riyadh Province",
  "iso3": "SAU",
  "lat": 24.7136,
  "lon": 46.6753,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not verified.",
  "note": "University hospital with its own procurement route (Ministry of Education / university budget) separate from MOH. Historically the academic centre of gravity for Saudi nephrology: multiple SSN&T presidents and board members have come from KSU. High value as a publication and guideline partner even where the purchase volume is modest.",
  "source": "gulf"
 },
 {
  "id": "deu-tum-munchen",
  "name": "Klinikum rechts der Isar, Technische Universitat Munchen",
  "short": "TUM Munchen",
  "city": "Munich",
  "region": "Bayern",
  "iso3": "DEU",
  "lat": 48.1351,
  "lon": 11.582,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Second Munich programme. Smaller than LMU for kidney.",
  "source": "rest_europe"
 },
 {
  "id": "deu-lmu-munchen",
  "name": "LMU Klinikum Munchen - Transplantationszentrum",
  "short": "LMU Munchen",
  "city": "Munich",
  "region": "Bayern",
  "iso3": "DEU",
  "lat": 48.1351,
  "lon": 11.582,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "One of two Munich programmes (with TUM). Bavaria is a comparatively wealthy Land with a high private-insurance share, which raises the value of the GOA private-pay route here.",
  "source": "rest_europe"
 },
 {
  "id": "fra-ap-hp-regional-h-i-platform-saint-loui",
  "name": "Laboratoire d'Immunologie et Histocompatibilite (Laboratoire Jean Dausset) - Plate-forme regionale AP-HP d'histocompatibilite, Hopital Saint-Louis",
  "short": "AP-HP regional H&I platform (Saint-Louis)",
  "city": "Paris",
  "region": "",
  "iso3": "FRA",
  "lat": 48.8566,
  "lon": 2.3522,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "THE most important single laboratory account in France. Constituted as the REGIONAL AP-HP HISTOCOMPATIBILITY PLATFORM, not merely a hospital lab: AP-HP's own research-platform page describes it as the reference histocompatibility platform for solid organ AND haematopoietic stem cell transplantation across the whole Ile-de-France region, which it states represents 35% of national transplant activity. EFI-accredited since 1997 and separately authorised by the ARS (after Agence de la biomedecine opinion) to perform 'examens des caracteristiques genetiques' under article L.1131-2-1 of the Code de ",
  "note": null,
  "source": "france"
 },
 {
  "id": "fra-saint-louis-hla-laboratory",
  "name": "Laboratoire d'Immunologie et Histocompatibilite, Hopital Saint-Louis (AP-HP)",
  "short": "Saint-Louis HLA laboratory",
  "city": "Paris",
  "region": "Ile-de-France",
  "iso3": "FRA",
  "lat": 48.8566,
  "lon": 2.3522,
  "geo": "city",
  "kinds": [
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "The HLA laboratory founded by Jean Dausset (Nobel laureate, discoverer of the HLA system), currently headed by Jean-Luc Taupin (PharmD, PhD). A public professional profile states it handles tissue compatibility for approximately 25% of French transplant activity; that proportion is NOT independently verified and should be treated as a claim rather than a fact. EFI accreditation is inferred from the LAHN requirement that NGS typing and antibody characterisation acts be performed in EFI-accredited laboratories. Accreditation: EFI.",
  "note": "If the 25% national share is even approximately right, this is the highest-leverage laboratory account in France for the HLA typing pillar - a single technical decision here moves a quarter of the national market. Jean-Luc Taupin is also a member of the Paris Transplant Group, which links the laboratory directly to the Loupy/Lefaucheur clinical research axis. Verify the 25% claim before using it in an investor deck.",
  "source": "france"
 },
 {
  "id": "nld-lumc",
  "name": "Leids Universitair Medisch Centrum",
  "short": "LUMC",
  "city": "Leiden",
  "region": "Zuid-Holland",
  "iso3": "NLD",
  "lat": 52.1601,
  "lon": 4.497,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "LUMC hosts the Eurotransplant Reference Laboratory and has been the intellectual centre of European histocompatibility for four decades (Acceptable Mismatch programme, eplet work). Note the late Prof. Frans Claas, its long-standing figurehead and former ET Reference Laboratory director, died on 2 February 2025. Accreditation: EFI.",
  "note": "The most influential HLA laboratory in continental Europe by reputation. Not the biggest transplant volume, but a scientific endorsement here carries across the whole Eurotransplant region. Treat as a reference and validation partner.",
  "source": "rest_europe"
 },
 {
  "id": "nld-mumc",
  "name": "Maastricht UMC+",
  "short": "MUMC+",
  "city": "Maastricht",
  "region": "Limburg",
  "iso3": "NLD",
  "lat": 50.8514,
  "lon": 5.691,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Smallest of the Dutch kidney programmes but historically the pioneer of DCD donation in Europe (the Maastricht DCD categories are named after it). Relevant for anything positioned around DCD graft injury.",
  "source": "rest_europe"
 },
 {
  "id": "tur-medical-park-antalya",
  "name": "Medical Park Antalya Hastanesi",
  "short": "Medical Park Antalya",
  "city": "Antalya",
  "region": "Antalya",
  "iso3": "TUR",
  "lat": 36.8969,
  "lon": 30.7133,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Turkey is structurally the most attractive VOLUME market in this region for pre-transplant risk assessment and post-transplant surveillance because of the enormous living-donor programme, and simultaneously the least attractive PRICE market because of SUT lira tariffs. The resolution is to sell into the private and health-tourism channel at international prices while using the public programme to generate evidence cheaply. Reported among the highest kidney exchange volumes in Turkey and a major private/health-tourism destination. Private centres like this are the realistic first paying customers in Turkey.",
  "source": "rest_europe"
 },
 {
  "id": "are-mediclinic-city",
  "name": "Mediclinic City Hospital",
  "short": "Mediclinic City",
  "city": "Dubai",
  "region": "Dubai (Dubai Healthcare City)",
  "iso3": "ARE",
  "lat": 25.2048,
  "lon": 55.2708,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Sits inside the Dubai Healthcare City free zone, which is regulated by DHCC Authority rather than DHA, a separate licensing regime worth checking before any facility-level agreement. Private, so self-pay and Enhanced insurance routes are open.",
  "source": "gulf"
 },
 {
  "id": "aut-meduni-graz",
  "name": "Medizinische Universitat Graz / LKH-Univ. Klinikum Graz",
  "short": "MedUni Graz",
  "city": "Graz",
  "region": "Steiermark",
  "iso3": "AUT",
  "lat": 47.0707,
  "lon": 15.4395,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Third Austrian academic centre.",
  "source": "rest_europe"
 },
 {
  "id": "aut-meduni-innsbruck",
  "name": "Medizinische Universitat Innsbruck",
  "short": "MedUni Innsbruck",
  "city": "Innsbruck",
  "region": "Tirol",
  "iso3": "AUT",
  "lat": 47.2692,
  "lon": 11.4041,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Historically pioneering multi-organ and composite tissue centre.",
  "source": "rest_europe"
 },
 {
  "id": "aut-meduni-wien-akh",
  "name": "Medizinische Universitat Wien / AKH Wien",
  "short": "MedUni Wien / AKH",
  "city": "Vienna",
  "region": "Vienna",
  "iso3": "AUT",
  "lat": 48.2082,
  "lon": 16.3738,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Vienna's Division of Transplantation and its transplant immunology laboratory are internationally prominent; the Vienna lung transplant programme is among the largest in the world. Accreditation: EFI.",
  "note": "Vienna is effectively the Austrian decision. A single account can carry most of the country's volume, and the lung programme's size makes it a globally relevant reference site for a lung dd-cfDNA product.",
  "source": "rest_europe"
 },
 {
  "id": "tur-memorial-sisli",
  "name": "Memorial Sisli Hastanesi - Organ Nakli Merkezi",
  "short": "Memorial Sisli",
  "city": "Istanbul",
  "region": "Istanbul",
  "iso3": "TUR",
  "lat": 41.0082,
  "lon": 28.9784,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Turkey is structurally the most attractive VOLUME market in this region for pre-transplant risk assessment and post-transplant surveillance because of the enormous living-donor programme, and simultaneously the least attractive PRICE market because of SUT lira tariffs. The resolution is to sell into the private and health-tourism channel at international prices while using the public programme to generate evidence cheaply. Large private group with a dedicated kidney transplantation centre and substantial international patient flow.",
  "source": "rest_europe"
 },
 {
  "id": "nor-ous-rikshospitalet",
  "name": "Oslo universitetssykehus, Rikshospitalet",
  "short": "OUS Rikshospitalet",
  "city": "Oslo",
  "region": "Oslo",
  "iso3": "NOR",
  "lat": 59.9139,
  "lon": 10.7522,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "National tissue typing laboratory (Immunologisk institutt). Accreditation: EFI.",
  "note": "ALL Norwegian solid organ transplantation happens here. One centre, one national HLA laboratory, one Nye Metoder decision. That is simultaneously the easiest sales conversation and the highest-stakes one in the region: there is no second chance and no way to route around a Beslutningsforum no.",
  "source": "rest_europe"
 },
 {
  "id": "sau-psmmc",
  "name": "Prince Sultan Military Medical City (formerly Riyadh Military Hospital)",
  "short": "PSMMC",
  "city": "Riyadh",
  "region": "Riyadh Province",
  "iso3": "SAU",
  "lat": 24.7136,
  "lon": 46.6753,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": {
   "value": 450,
   "confidence": "estimated",
   "method": "Crude: 750 lifetime kidney transplants, assume ~60% functioning and followed locally."
  },
  "tier": 2,
  "labNote": "JCI accredited institution. HLA laboratory accreditation not verified. Accreditation: JCI.",
  "note": "IMPORTANT NAMING POINT: PSMMC and 'Riyadh Military Hospital' are the same institution under its old and new names, not two separate accounts. Procurement runs through Ministry of Defence medical services, NOT through NUPCO/MOH, which means a completely separate supplier registration and tender process. This is a common and expensive mistake for new entrants.",
  "source": "gulf"
 },
 {
  "id": "nld-radboudumc",
  "name": "Radboudumc",
  "short": "Radboudumc",
  "city": "Nijmegen",
  "region": "Gelderland",
  "iso3": "NLD",
  "lat": 51.8126,
  "lon": 5.8372,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Mid-size kidney and pancreas programme.",
  "source": "rest_europe"
 },
 {
  "id": "pol-spsk-2-szczecin",
  "name": "Samodzielny Publiczny Szpital Kliniczny nr 2 PUM",
  "short": "SPSK-2 Szczecin",
  "city": "Szczecin",
  "region": "Zachodniopomorskie",
  "iso3": "POL",
  "lat": 53.4285,
  "lon": 14.5528,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Poland's very low living-donor share (82 of about 1,214 kidney transplants, under 7%) is the defining feature of this market and contrasts sharply with the Netherlands (43%) and Turkey (75-80%). It means Polish recipients are overwhelmingly deceased-donor, often extended-criteria, and therefore a higher-risk surveillance population. Financing for the transplant pathway runs partly through the Ministry of Health's national transplantation programme via Poltransplant rather than purely through NFZ, so Poltransplant is the first door. PUM publishes Polish transplant statistics summaries publicly.",
  "source": "rest_europe"
 },
 {
  "id": "are-ssmc",
  "name": "Sheikh Shakhbout Medical City",
  "short": "SSMC",
  "city": "Abu Dhabi",
  "region": "Abu Dhabi",
  "iso3": "ARE",
  "lat": 24.4539,
  "lon": 54.3773,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Not verified.",
  "note": "Mayo Clinic partnership means, like CCAD, US-derived clinical protocols and receptiveness to US-validated assays. Same SEHA/PureHealth procurement as SKMC, so a single group agreement could cover both.",
  "source": "gulf"
 },
 {
  "id": "swe-sus-malmo",
  "name": "Skanes universitetssjukhus (Malmo)",
  "short": "SUS Malmo",
  "city": "Malmo",
  "region": "Skane",
  "iso3": "SWE",
  "lat": 55.605,
  "lon": 13.0038,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Third Swedish kidney centre; strong pancreas and islet work.",
  "source": "rest_europe"
 },
 {
  "id": "pol-skpp-poznan",
  "name": "Szpital Kliniczny Przemienienia Panskiego UM w Poznaniu",
  "short": "SKPP Poznan",
  "city": "Poznan",
  "region": "Wielkopolskie",
  "iso3": "POL",
  "lat": 52.4064,
  "lon": 16.9252,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Poland's very low living-donor share (82 of about 1,214 kidney transplants, under 7%) is the defining feature of this market and contrasts sharply with the Netherlands (43%) and Turkey (75-80%). It means Polish recipients are overwhelmingly deceased-donor, often extended-criteria, and therefore a higher-risk surveillance population. Financing for the transplant pathway runs partly through the Ministry of Health's national transplantation programme via Poltransplant rather than purely through NFZ, so Poltransplant is the first door.",
  "source": "rest_europe"
 },
 {
  "id": "est-tartu-university-hospital",
  "name": "Tartu Ulikooli Kliinikum",
  "short": "Tartu University Hospital",
  "city": "Tartu",
  "region": "Tartu",
  "iso3": "EST",
  "lat": 58.3776,
  "lon": 26.729,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Included for completeness as a Scandiatransplant member; outside the 13 named countries. Very small volume.",
  "source": "rest_europe"
 },
 {
  "id": "prt-curry-cabral-lisbon",
  "name": "Unidade Local de Saude de Sao Jose - Hospital Curry Cabral",
  "short": "Curry Cabral Lisbon",
  "city": "Lisbon",
  "region": "Lisboa",
  "iso3": "PRT",
  "lat": 38.7223,
  "lon": -9.1393,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Principal Lisbon transplant centre; strong liver programme.",
  "source": "rest_europe"
 },
 {
  "id": "deu-uniklinik-koln",
  "name": "Uniklinik Koln - Transplantationszentrum",
  "short": "Uniklinik Koln",
  "city": "Cologne",
  "region": "Nordrhein-Westfalen",
  "iso3": "DEU",
  "lat": 50.9375,
  "lon": 6.9603,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Strong kidney programme; Cologne nephrology (CECAD-linked) is research-heavy and a good site for biomarker studies.",
  "source": "rest_europe"
 },
 {
  "id": "nld-umcg",
  "name": "Universitair Medisch Centrum Groningen",
  "short": "UMCG",
  "city": "Groningen",
  "region": "Groningen",
  "iso3": "NLD",
  "lat": 53.2194,
  "lon": 6.5665,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "The broadest Dutch multi-organ programme including intestinal transplantation, and a leading centre for machine perfusion and normothermic organ preservation. Highly relevant to donor-organ assessment products.",
  "source": "rest_europe"
 },
 {
  "id": "bel-uza",
  "name": "Universitair Ziekenhuis Antwerpen (UZA)",
  "short": "UZA",
  "city": "Edegem/Antwerp",
  "region": "Antwerpen",
  "iso3": "BEL",
  "lat": 50.6,
  "lon": 4.6,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Mid-size programme.",
  "source": "rest_europe"
 },
 {
  "id": "bel-uz-brussel",
  "name": "Universitair Ziekenhuis Brussel (UZ Brussel)",
  "short": "UZ Brussel",
  "city": "Jette/Brussels",
  "region": "Brussels-Capital",
  "iso3": "BEL",
  "lat": 50.6,
  "lon": 4.6,
  "geo": "approx",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Smaller kidney programme.",
  "source": "rest_europe"
 },
 {
  "id": "bel-uz-gent",
  "name": "Universitair Ziekenhuis Gent (UZ Gent)",
  "short": "UZ Gent",
  "city": "Ghent",
  "region": "Oost-Vlaanderen",
  "iso3": "BEL",
  "lat": 50.6,
  "lon": 4.6,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Large Flemish multi-organ programme.",
  "source": "rest_europe"
 },
 {
  "id": "che-usz-zurich",
  "name": "UniversitatsSpital Zurich - Transplantationszentrum",
  "short": "USZ Zurich",
  "city": "Zurich",
  "region": "Zurich",
  "iso3": "CHE",
  "lat": 47.3769,
  "lon": 8.5417,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Six centres nationally, all enrolled in the Swiss Transplant Cohort Study, which prospectively captures essentially every Swiss solid organ recipient. Combined with the Analysenliste (a single national listing decision, manufacturer may apply directly) this makes Switzerland the highest reimbursement-probability-per-unit-of-effort market in the region despite its size. USZ publishes its own transplant centre annual report in English, which is unusual and useful.",
  "source": "rest_europe"
 },
 {
  "id": "deu-uk-essen-wzo",
  "name": "Universitatsklinikum Essen - Westdeutsches Zentrum fur Organtransplantation",
  "short": "UK Essen / WZO",
  "city": "Essen",
  "region": "Nordrhein-Westfalen",
  "iso3": "DEU",
  "lat": 51.4556,
  "lon": 7.0116,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "High-volume multi-organ centre in the densest part of Germany (North Rhine-Westphalia has roughly 18 million people). Good candidate for a regional NUB campaign covering Essen, Cologne, Bonn, Munster and Aachen together.",
  "source": "rest_europe"
 },
 {
  "id": "deu-uk-frankfurt",
  "name": "Universitatsklinikum Frankfurt - Transplantationszentrum",
  "short": "UK Frankfurt",
  "city": "Frankfurt am Main",
  "region": "Hessen",
  "iso3": "DEU",
  "lat": 51.0,
  "lon": 10.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Mid-size programme. Frankfurt's DRK-Blutspendedienst has significant immunogenetics capability in the region.",
  "source": "rest_europe"
 },
 {
  "id": "deu-uk-freiburg",
  "name": "Universitatsklinikum Freiburg - Transplantationszentrum",
  "short": "UK Freiburg",
  "city": "Freiburg im Breisgau",
  "region": "Baden-Wurttemberg",
  "iso3": "DEU",
  "lat": 51.0,
  "lon": 10.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Mid-size programme with a very strong allogeneic HSCT service, which makes it a natural chimerism-monitoring account as well as a solid organ one.",
  "source": "rest_europe"
 },
 {
  "id": "deu-uke-hamburg",
  "name": "Universitatsklinikum Hamburg-Eppendorf - Universitares Transplantations-Centrum",
  "short": "UKE Hamburg",
  "city": "Hamburg",
  "region": "Hamburg",
  "iso3": "DEU",
  "lat": 53.5511,
  "lon": 9.9937,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Major northern German multi-organ centre with a strong liver programme and an active research culture. Hamburg has one of Germany's highest private-insurance shares.",
  "source": "rest_europe"
 },
 {
  "id": "deu-uk-leipzig",
  "name": "Universitatsklinikum Leipzig - Transplantationszentrum",
  "short": "UK Leipzig",
  "city": "Leipzig",
  "region": "Sachsen",
  "iso3": "DEU",
  "lat": 51.3397,
  "lon": 12.3731,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Principal eastern German programme alongside Dresden and Jena. Close to DKMS Life Science Lab in Dresden.",
  "source": "rest_europe"
 },
 {
  "id": "deu-uk-munster",
  "name": "Universitatsklinikum Munster - Transplantationszentrum",
  "short": "UK Munster",
  "city": "Munster",
  "region": "Nordrhein-Westfalen",
  "iso3": "DEU",
  "lat": 51.9607,
  "lon": 7.6261,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Part of the dense NRW cluster; sensible to approach alongside Essen and Cologne.",
  "source": "rest_europe"
 },
 {
  "id": "deu-uk-regensburg",
  "name": "Universitatsklinikum Regensburg",
  "short": "UK Regensburg",
  "city": "Regensburg",
  "region": "Bayern",
  "iso3": "DEU",
  "lat": 49.0134,
  "lon": 12.1016,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Mid-size Bavarian multi-organ centre.",
  "source": "rest_europe"
 },
 {
  "id": "deu-uksh",
  "name": "Universitatsklinikum Schleswig-Holstein (Kiel/Lubeck)",
  "short": "UKSH",
  "city": "Kiel and Lubeck",
  "region": "Schleswig-Holstein",
  "iso3": "DEU",
  "lat": 51.0,
  "lon": 10.4,
  "geo": "approx",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "UKSH has published research critical of inequities in Eurotransplant organ allocation, which signals an institution willing to challenge the status quo - often a good early-adopter signal.",
  "source": "rest_europe"
 },
 {
  "id": "deu-uk-tubingen",
  "name": "Universitatsklinikum Tubingen - Transplantationszentrum",
  "short": "UK Tubingen",
  "city": "Tubingen",
  "region": "Baden-Wurttemberg",
  "iso3": "DEU",
  "lat": 48.5216,
  "lon": 9.0576,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": true,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": "Tubingen has a notable immunology and peptide/HLA research tradition (Rammensee group), relevant to any epitope- or peptide-based product. Accreditation: EFI.",
  "note": "Smaller solid organ volume but disproportionate scientific weight in HLA and immunopeptidomics. Better as a scientific partner than a volume account.",
  "source": "rest_europe"
 },
 {
  "id": "pol-usk-wroclaw",
  "name": "Uniwersytecki Szpital Kliniczny we Wroclawiu",
  "short": "USK Wroclaw",
  "city": "Wroclaw",
  "region": "Dolnoslaskie",
  "iso3": "POL",
  "lat": 51.1079,
  "lon": 17.0385,
  "geo": "city",
  "kinds": [
   "transplant_centre"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Poland's very low living-donor share (82 of about 1,214 kidney transplants, under 7%) is the defining feature of this market and contrasts sharply with the Netherlands (43%) and Turkey (75-80%). It means Polish recipients are overwhelmingly deceased-donor, often extended-criteria, and therefore a higher-risk surveillance population. Financing for the transplant pathway runs partly through the Ministry of Health's national transplantation programme via Poltransplant rather than purely through NFZ, so Poltransplant is the first door.",
  "source": "rest_europe"
 },
 {
  "id": "pol-uck-wum-warszawa",
  "name": "Uniwersyteckie Centrum Kliniczne WUM - Szpital Kliniczny Dziecatka Jezus",
  "short": "UCK WUM Warszawa",
  "city": "Warsaw",
  "region": "Mazowieckie",
  "iso3": "POL",
  "lat": 52.2297,
  "lon": 21.0122,
  "geo": "city",
  "kinds": [
   "transplant_centre",
   "hi_lab"
  ],
  "paediatric": false,
  "volumes": [],
  "prevalentGrafts": null,
  "tier": 2,
  "labNote": null,
  "note": "Poland's very low living-donor share (82 of about 1,214 kidney transplants, under 7%) is the defining feature of this market and contrasts sharply with the Netherlands (43%) and Turkey (75-80%). It means Polish recipients are overwhelmingly deceased-donor, often extended-criteria, and therefore a higher-risk surveillance population. Financing for the transplant pathway runs partly through the Ministry of Health's national transplantation programme via Poltransplant rather than purely through NFZ, so Poltransplant is the first door. Historically the largest Polish kidney and kidney-pancreas programme.",
  "source": "rest_europe"
 }
] as unknown as (Site & { geo: string; source: string })[];

export const GEN_COUNTRIES = [
 {
  "iso3": "FRA",
  "name": "France",
  "population": 68200000,
  "donorsPmp": 27.4,
  "donorsPmpYear": 2024,
  "donationModel": "opt-out (soft)",
  "registry": "Agence de la biomedecine - registre CRISTAL, and the REIN registry for kidney failure",
  "registryUrl": "https://rams.agence-biomedecine.fr/2024/organes-tissus",
  "summary": "Single statutory payer in substance: Assurance Maladie (CNAM), funded by social contributions, with near-universal complementary insurance on top. Public hospitals are paid mainly by activity-based tariffs (T2A) via GHM/GHS per-stay prices set annually by the ministry on ATIH costing data, so any test performed on an inpatient is a cost inside the stay tariff, not extra revenue. Teaching hospitals (CHU) additionally receive MERRI grants for teaching, research and innovation; the MERRI G03 line is the closed envelope that pays for out-of-nomenclature biology acts (LAHN, formerly RIHN). Outpatient and out-of-nomenclature laboratory tests are paid per act against two separate national lists: the NABM for established acts (priced in 'B' units, B = EUR 0.25) and the LAHN for innovative/transitional acts (priced directly in euros). Diagnostics adoption is therefore never a single decision: it requires a national listing decision (UNCAM for NABM, ministry-on-HAS-advice for LAHN), a hospital budget holder willing to absorb the gap, and the performing laboratory to hold the method inside its mandatory COFRAC ISO 15189 accreditation scope.",
  "region": "france"
 },
 {
  "iso3": "SAU",
  "name": "Saudi Arabia",
  "population": 35300000,
  "donorsPmp": null,
  "donorsPmpYear": 2023,
  "donationModel": "opt-in",
  "registry": "Saudi Center for Organ Transplantation (SCOT)",
  "registryUrl": "https://www.scot.gov.sa/en",
  "summary": "Historically a fully tax-funded, state-delivered system in which the Ministry of Health owned and ran most hospitals, alongside large parallel systems: National Guard Health Affairs (King Abdulaziz Medical City, Riyadh and Jeddah), Ministry of Defence (Prince Sultan Military Medical City, formerly Riyadh Military Hospital), Ministry of Interior (Security Forces Hospital), university hospitals (King Saud University Medical City, King Abdulaziz University Hospital), and the autonomous King Faisal Specialist Hospital & Research Centre. Under Vision 2030's Health Sector Transformation Programme this is being restructured into roughly 20 semi-autonomous regional Health Clusters (e.g. the Eastern Health Cluster, which now contains King Fahad Specialist Hospital Dammam), with MOH retreating to a regulator and policy role and the PIF-owned Health Holding Company driving corporatisation and eventual privatisation. Payment is shifting from block government funding to insurance-based purchasing: the Council of Health Insurance (CHI, formerly CCHI) regulates mandatory cooperative insurance for private-sector employees and expatriates, with claims flowing through the NPHIES platform using ICD-10 and CPT. Consumables, devices and IVDs for government facilities are bought centrally through NUPCO, which is the single most important commercial gate in the country. Saudi Arabia also carries an exceptionally heavy ESKD burden driven by diabetes (diabetic nephropathy causes over 60% of ESKD) and, distinctly, a high consanguinity rate that raises the prevalence of inherited glomerular disease (Alport, familial FSGS) and early-onset ADPKD, which is directly relevant to HLA-driven immunological risk and to native-disease recurrence testing after transplant.",
  "region": "gulf"
 },
 {
  "iso3": "ARE",
  "name": "United Arab Emirates",
  "population": 11000000,
  "donorsPmp": null,
  "donorsPmpYear": 2024,
  "donationModel": "opt-in",
  "registry": "Hayat - National Programme for Donation and Transplantation of Human Organs and Tissues",
  "registryUrl": "https://mohap.gov.ae/en/more/hayat",
  "summary": "A federal state with strongly devolved health regulation. MOHAP covers the Northern Emirates and holds federal public-health functions; the Department of Health - Abu Dhabi (DoH) regulates Abu Dhabi and the Dubai Health Authority / Dubai Health regulates Dubai, with Dubai Healthcare City Authority regulating the DHCC free zone. Since 2 January 2025 the Emirates Drug Establishment (EDE) has been the federal regulator for medical products including devices and IVDs, progressively assuming the registration functions previously run by MOHAP. Funding is insurance-based and mandatory: Abu Dhabi requires cover for all residents (Thiqa for Emiratis holding an Abu Dhabi family book, administered by Daman on behalf of DoH; Basic and Enhanced products for expatriates), and Dubai requires cover under the DHA scheme. Payment runs against DoH's Mandatory Tariff and DHA's equivalent schedules, using CPT. Roughly 85-90% of the population are expatriates, so commercial insurance rather than government block funding is the dominant payer for diagnostics, and expatriate Basic plans are thin (Daman's Basic plan now carries a 20% co-payment on diagnostics including laboratory tests, capped at AED 50 per visit). Provider groups are large and consolidated: SEHA and Cleveland Clinic Abu Dhabi sit under the M42/PureHealth umbrella in Abu Dhabi, Dubai Health runs the Dubai public system, and Burjeel, Mediclinic and NMC are the major private players.",
  "region": "gulf"
 },
 {
  "iso3": "QAT",
  "name": "Qatar",
  "population": 3000000,
  "donorsPmp": null,
  "donorsPmpYear": 2024,
  "donationModel": "opt-in",
  "registry": "Qatar Organ Donation Center (Hiba) / Qatar Center for Organ Transplantation, Hamad Medical Corporation",
  "registryUrl": "https://hamad.qa/EN/your%20health/Organ-Donation/Transplant-in-Qatar/Pages/Qatar-Center-for-Organ-Transplantation.aspx",
  "summary": "Highly centralised. Hamad Medical Corporation (HMC) is the dominant public provider and runs essentially all solid-organ transplantation through the Qatar Center for Organ Transplantation (QCOT), with donation coordinated by the Qatar Organ Donation Center (Hiba, launched 2012 under the Doha Donation Accord). Nationals are covered by the state; expatriates through employer-provided insurance. Procurement is centralised through HMC. Small population, single buyer, high willingness to pay for prestige technology.",
  "region": "gulf"
 },
 {
  "iso3": "KWT",
  "name": "Kuwait",
  "population": 4900000,
  "donorsPmp": null,
  "donorsPmpYear": null,
  "donationModel": "opt-in",
  "registry": "Kuwait Transplant Society / MOH Kuwait",
  "registryUrl": "",
  "summary": "State-funded system under the Ministry of Health. Transplantation is concentrated in a single national centre. Free at the point of use for Kuwaitis; expatriates pay or are insured. Procurement is via MOH central tender.",
  "region": "gulf"
 },
 {
  "iso3": "OMN",
  "name": "Oman",
  "population": 5200000,
  "donorsPmp": null,
  "donorsPmpYear": null,
  "donationModel": "opt-in",
  "registry": "Ministry of Health Oman",
  "registryUrl": "https://moh.gov.om/en/hospitals-directorates/hospitals/royal-hospital/",
  "summary": "Ministry of Health-run system. Transplantation is concentrated at the Royal Hospital, Muscat (kidney since 1988, liver since 2017). Small programme, growing quickly from a low base.",
  "region": "gulf"
 },
 {
  "iso3": "BHR",
  "name": "Bahrain",
  "population": 1500000,
  "donorsPmp": null,
  "donorsPmpYear": null,
  "donationModel": "opt-in",
  "registry": "Ministry of Health Bahrain",
  "registryUrl": "https://www.moh.gov.bh/Contact/SMC?lang=en",
  "summary": "Ministry of Health system centred on Salmaniya Medical Complex. Kidney transplant only, at very low volume (approximately 10 per year nationally). No liver transplant facility; liver patients are sent abroad. Not a standalone commercial market.",
  "region": "gulf"
 },
 {
  "iso3": "ITA",
  "name": "Italy",
  "population": 58990000,
  "donorsPmp": 30.2,
  "donorsPmpYear": 2025,
  "donationModel": "opt-out (soft)",
  "registry": "Centro Nazionale Trapianti (CNT) / Sistema Informativo Trapianti (SIT)",
  "registryUrl": "https://www.trapianti.salute.gov.it/",
  "summary": "Italy has a tax-funded national health service (Servizio Sanitario Nazionale, SSN) that is heavily devolved to 19 regions and 2 autonomous provinces. Central government defines the LEA (Livelli Essenziali di Assistenza), the benefit basket every region must guarantee, and sets national maximum tariffs; each region then sets its own tariff schedule (nomenclatore tariffario regionale), runs its own hospital budgets and its own procurement. Transplant centres are public university hospitals (Aziende Ospedaliero-Universitarie), IRCCS research hospitals or large public trusts (Aziende Ospedaliere), funded by regional block budgets plus DRG-based activity payment. New diagnostics do not enter through a single national door: national LEA/HTA listing sets the ceiling, but real money is released region by region, and the actual purchase happens through a public tender run by a regional central purchasing body.",
  "region": "italy"
 },
 {
  "iso3": "DEU",
  "name": "Germany",
  "population": 83500000,
  "donorsPmp": 11.4,
  "donorsPmpYear": 2024,
  "donationModel": "opt-in",
  "registry": "Deutsches Transplantationsregister / DSO annual reporting; allocation by Eurotransplant",
  "registryUrl": "https://dso.de/organspende/statistiken-berichte",
  "summary": "Statutory health insurance (GKV, about 89% of the population, roughly 95 sickness funds) plus substitutive private insurance (PKV, about 10-11%). Hospitals are paid by G-DRG case rates negotiated annually with the sickness funds, with investment costs nominally borne by the Lander. Outpatient care is paid through the EBM catalogue via the regional Kassenarztliche Vereinigungen out of a capped morbidity-adjusted total. Adoption of a new diagnostic is gated differently in each setting: inpatient by InEK/NUB, outpatient by a G-BA method decision under section 135(1) SGB V. Private patients are billed under the GOA, which is the only route with no gatekeeper.",
  "region": "rest_europe"
 },
 {
  "iso3": "NLD",
  "name": "Netherlands",
  "population": 17900000,
  "donorsPmp": null,
  "donorsPmpYear": 2024,
  "donationModel": "opt-out (soft)",
  "registry": "Nederlandse Transplantatie Stichting (NTS)",
  "registryUrl": "https://www.transplantatiestichting.nl/",
  "summary": "Mandatory private health insurance regulated under the Zorgverzekeringswet, with about four dominant insurer groups. Hospitals are paid per DBC zorgproduct; roughly 70% of hospital care sits in a free-negotiation segment where price is agreed bilaterally with each insurer, the rest under NZa maximum tariffs. Laboratory diagnostics are normally bundled inside the DBC, so a new test is a cost to the hospital rather than a source of income unless a separate add-on is created. The basic package is an open system: care is covered if it meets the statutory 'stand van de wetenschap en praktijk' criterion, which Zorginstituut Nederland interprets.",
  "region": "rest_europe"
 },
 {
  "iso3": "BEL",
  "name": "Belgium",
  "population": 11800000,
  "donorsPmp": null,
  "donorsPmpYear": 2024,
  "donationModel": "opt-out (soft)",
  "registry": "Belgian Transplantation Society / Federal Public Service Health; allocation by Eurotransplant",
  "registryUrl": "https://www.transplant.be/",
  "summary": "Compulsory national health insurance administered by INAMI/RIZIV through sickness funds (mutualites/ziekenfondsen). Hospitals are paid by a Budget of Financial Means plus fee-for-service physician fees from the nomenclature. Clinical biology is a special case: it operates under a capped national budget with a per-admission lump sum for inpatients, so extra testing does not generate extra income for the laboratory. Novel molecular testing is increasingly handled through time-limited INAMI conventions with designated laboratories and pseudo-nomenclature codes rather than through the nomenclature itself.",
  "region": "rest_europe"
 },
 {
  "iso3": "CHE",
  "name": "Switzerland",
  "population": 8900000,
  "donorsPmp": 21.0,
  "donorsPmpYear": 2024,
  "donationModel": "opt-out (soft)",
  "registry": "Swisstransplant / Swiss Organ Allocation System (SOAS); Swiss Transplant Cohort Study (STCS)",
  "registryUrl": "https://www.swisstransplant.org/",
  "summary": "Compulsory private basic health insurance (OKP/LAMal) with community rating, plus widespread supplementary insurance. Inpatient care is paid under SwissDRG, cost-shared between insurer and canton. Every laboratory analysis reimbursed by basic insurance must be named on the Analysenliste, an annex to the KLV ordinance administered by the Federal Office of Public Health with a fixed national tariff. Switzerland is a high-price market with an unusually clean and manufacturer-accessible listing process.",
  "region": "rest_europe"
 },
 {
  "iso3": "AUT",
  "name": "Austria",
  "population": 9200000,
  "donorsPmp": null,
  "donorsPmpYear": 2024,
  "donationModel": "opt-out (hard)",
  "registry": "Austrian transplant registry, Gesundheit Osterreich GmbH; allocation by Eurotransplant",
  "registryUrl": "https://goeg.at/",
  "summary": "Social health insurance (Osterreichische Gesundheitskasse dominant since the 2020 merger) with hospital care financed through the Landesgesundheitsfonds under the LKF performance-oriented points system. New inpatient services enter through the annual revision of the LKF Leistungskatalog. Outpatient laboratory work is paid through negotiated Honorarordnung catalogues. AIHTA provides national HTA. Small market, four university transplant centres, Vienna dominant.",
  "region": "rest_europe"
 },
 {
  "iso3": "DNK",
  "name": "Denmark",
  "population": 5950000,
  "donorsPmp": 19.2,
  "donorsPmpYear": 2024,
  "donationModel": "opt-in",
  "registry": "Scandiatransplant (Danish data)",
  "registryUrl": "https://www.scandiatransplant.org/",
  "summary": "Tax-funded universal system. Five regions own and run the hospitals and hold the budget; the Danish DRG (takstsystem) is used for inter-regional settlement rather than for paying line items. There is no national fee schedule route for a hospital laboratory test. National technology recommendations come from Behandlingsradet, established 2021, whose evaluations are formally non-binding but in practice drive regional funding.",
  "region": "rest_europe"
 },
 {
  "iso3": "SWE",
  "name": "Sweden",
  "population": 10600000,
  "donorsPmp": 22.0,
  "donorsPmpYear": 2024,
  "donationModel": "opt-out (soft)",
  "registry": "Scandiatransplant (Swedish data); Svenskt Njurregister",
  "registryUrl": "https://www.scandiatransplant.org/",
  "summary": "Tax-funded, with 21 regions responsible for healthcare provision and purchasing. There is no national reimbursement list for in vitro diagnostics; laboratory testing is funded from the hospital laboratory's global budget. Purchasing is by public procurement under LOU, typically as multi-year framework agreements. TLV performs health economic assessment; MTP-radet issues national recommendations on medical technology and NT-radet on new therapies, both under SKR.",
  "region": "rest_europe"
 },
 {
  "iso3": "NOR",
  "name": "Norway",
  "population": 5550000,
  "donorsPmp": 18.8,
  "donorsPmpYear": 2024,
  "donationModel": "opt-out (soft)",
  "registry": "Norsk Nyreregister; Scandiatransplant (Norwegian data)",
  "registryUrl": "https://www.scandiatransplant.org/",
  "summary": "Tax-funded, delivered through four Regional Health Authorities which own the hospital trusts. Everything new must clear Nye Metoder, a mandatory national HTA and decision system, before it can be introduced into the specialist health service. Funding then comes from RHA block budgets, so a positive decision still requires a budget-impact case. Norway centralises all solid organ transplantation at a single hospital.",
  "region": "rest_europe"
 },
 {
  "iso3": "FIN",
  "name": "Finland",
  "population": 5550000,
  "donorsPmp": 27.7,
  "donorsPmpYear": 2024,
  "donationModel": "opt-out (soft)",
  "registry": "Scandiatransplant (Finnish data)",
  "registryUrl": "https://www.scandiatransplant.org/",
  "summary": "Tax-funded, reorganised on 1 January 2023 into 21 wellbeing services counties (hyvinvointialueet) plus Helsinki. All Finnish solid organ transplantation is performed at HUS Helsinki University Hospital, making Finland effectively a single-account market. Palko issues national recommendations on the publicly funded service range and FinCCHTA performs HTA. Laboratory services are provided by HUS Diagnostic Center (HUSLAB).",
  "region": "rest_europe"
 },
 {
  "iso3": "POL",
  "name": "Poland",
  "population": 36700000,
  "donorsPmp": null,
  "donorsPmpYear": 2024,
  "donationModel": "opt-out (soft)",
  "registry": "Poltransplant - Krajowy Rejestr Przeszczepien",
  "registryUrl": "https://poltransplant.org.pl/",
  "summary": "Single public payer (NFZ) funding a closed positive list of guaranteed benefits defined by Ministry of Health regulation. AOTMiT performs HTA and tariff-setting; the Minister decides. Hospital care is paid under JGP, the Polish DRG. Transplantation occupies a special position: procurement, preservation, tissue typing and elements of the transplant pathway are funded through the Ministry of Health's National Transplantation Development Programme and coordinated by Poltransplant, which makes Poltransplant rather than NFZ the correct first contact for a transplant-specific test.",
  "region": "rest_europe"
 },
 {
  "iso3": "CZE",
  "name": "Czechia",
  "population": 10900000,
  "donorsPmp": null,
  "donorsPmpYear": 2024,
  "donationModel": "opt-out (soft)",
  "registry": "Koordinacni stredisko transplantaci (KST)",
  "registryUrl": "https://kst.cz/",
  "summary": "Statutory health insurance with seven funds, VZP dominant. Providers are paid according to the Seznam zdravotnich vykonu, a national list of procedures with point values set by ministerial decree, converted to koruna by the annual reimbursement decree. New laboratory procedure codes must be proposed through the relevant professional society. Transplantation is heavily concentrated at IKEM in Prague.",
  "region": "rest_europe"
 },
 {
  "iso3": "PRT",
  "name": "Portugal",
  "population": 10600000,
  "donorsPmp": null,
  "donorsPmpYear": 2024,
  "donationModel": "opt-out (soft)",
  "registry": "IPST - Instituto Portugues do Sangue e da Transplantacao",
  "registryUrl": "https://ipst.pt/",
  "summary": "Tax-funded SNS with hospitals funded by contract-programme with ACSS, production paid against a national price table using GDH (Portuguese DRG). INFARMED holds the HTA mandate under SiNATS. IPST (Instituto Portugues do Sangue e da Transplantacao) runs national blood, tissue and transplant coordination and operates the national histocompatibility laboratories, which makes it the single most important national account for anything HLA-related.",
  "region": "rest_europe"
 },
 {
  "iso3": "TUR",
  "name": "Turkiye",
  "population": 85000000,
  "donorsPmp": null,
  "donorsPmpYear": 2024,
  "donationModel": "opt-in",
  "registry": "Saglik Bakanligi - TDIS / Organ ve Doku Nakli Koordinasyon Sistemi",
  "registryUrl": "https://organ.saglik.gov.tr/",
  "summary": "Universal coverage through SGK, a single dominant public payer, with services and prices fixed in the SUT (Health Implementation Communique). Public, university and private hospitals all contract with SGK. SUT lira prices are low and inflation-eroded, so premium imported diagnostics are effectively unfundable at SUT rates. Alongside this sits a very large private hospital and international health-tourism sector paying cash at international prices. TITCK regulates devices and IVDs and operates the UTS product tracking system.",
  "region": "rest_europe"
 },
 {
  "iso3": "ESP",
  "name": "Spain",
  "population": 49100000,
  "donorsPmp": 51.9,
  "donorsPmpYear": 2025,
  "donationModel": "opt-out (soft)",
  "registry": "Organizacion Nacional de Trasplantes (ONT) - Memorias de actividad de donacion y trasplante",
  "registryUrl": "https://www.ont.es/",
  "summary": "Tax-funded Sistema Nacional de Salud (SNS) with universal coverage, but operationally devolved to 17 autonomous communities plus INGESA for Ceuta and Melilla. The Ministry of Health (Ministerio de Sanidad) defines a national minimum benefit package, the cartera comun de servicios, but does not hold the operating budget. Each region runs its own health service (SAS Andalusia, CatSalut/ICS Catalonia, SERMAS Madrid, Osakidetza Basque Country, SERGAS Galicia, Conselleria de Sanitat Valencia, SESCAM, SACYL, SMS Murcia, IB-Salut, SCS Canarias, SESPA, SCS Cantabria, SNS-O Navarra, SERIS, SES Extremadura, SALUD Aragon), sets its own public prices and buys its own diagnostics through its own public tenders. Hospitals are financed by regional global budgets and contratos-programa, not by activity-based DRG payment in most regions, so a new laboratory test is absorbed into a hospital or regional laboratory budget rather than separately reimbursed. Practical consequence for a diagnostics company: there is no single national reimbursement decision to win, there are 17 procurement decisions, and the tender is the sales process.",
  "region": "spain"
 },
 {
  "iso3": "GBR",
  "name": "United Kingdom",
  "population": 69000000,
  "donorsPmp": 20.8,
  "donorsPmpYear": 2024,
  "donationModel": "opt-out (soft)",
  "registry": "UK Transplant Registry (UKTR), held by NHS Blood and Transplant / Organ and Tissue Donation and Transplantation (ODT)",
  "registryUrl": "https://www.odt.nhs.uk/statistics-and-reports/",
  "summary": "Tax-funded National Health Service, free at the point of use, with four separate national systems (NHS England, NHS Scotland, NHS Wales, HSC Northern Ireland). Solid organ transplantation is a nationally commissioned 'specialised service' — in England commissioned directly by NHS England Specialised Commissioning against national service specifications, not by local ICBs. There is no fee-for-service schedule for laboratory tests: hospital labs are funded from block contracts and from tariff income for the episode of care, so a new diagnostic must either displace existing spend, enter the National Genomic Test Directory, or be funded by a local business case. Private transplant activity is negligible (a handful of cases at London Cromwell, London Bridge, The London Clinic).",
  "region": "uk"
 },
 {
  "iso3": "USA",
  "name": "United States",
  "population": 342000000,
  "donorsPmp": 48.4,
  "donorsPmpYear": 2025,
  "donationModel": "opt-in",
  "registry": "Organ Procurement and Transplantation Network (OPTN), with analysis by the Scientific Registry of Transplant Recipients (SRTR)",
  "registryUrl": "https://optn.transplant.hrsa.gov/",
  "summary": "Multi-payer. Transplantation is unusual in being disproportionately federally funded: the Medicare End-Stage Renal Disease entitlement covers essentially all US citizens on dialysis or with a kidney transplant regardless of age, so Medicare is the dominant payer for kidney transplantation and its follow-up, alongside Medicaid and commercial insurance. Hospitals are paid per admission (MS-DRG) with transplant-specific cost reporting; laboratory tests are paid separately on the Clinical Laboratory Fee Schedule, which is why a send-out molecular test can be a standalone P&L rather than a cost inside the DRG. Diagnostics are adopted bottom-up: a clinician orders the test, the laboratory bills the payer, and coverage is decided not by a national HTA body but by Medicare Administrative Contractors through Local Coverage Determinations (in molecular diagnostics, almost always MolDX) and separately by each commercial payer's medical policy. There is no national tender and no single national price.",
  "region": "usa"
 }
] as unknown as (Country & { region: string })[];

export const GEN_PATHWAYS = [
 {
  "id": "fra-rihn-2-0-lahn-liste-des-actes-hors",
  "iso3": "FRA",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "RIHN 2.0 / LAHN (Liste des Actes Hors Nomenclature) - transitional early-access listing for innovative biology acts",
  "routeType": "innovation_list",
  "decisionBody": "Haute Autorite de Sante (evaluation) then Ministere de la Sante - DGOS/DGS/DSS (tariff and coverage decision)",
  "howItWorks": "This is the single most important route for Scira in France and it is genuinely distinctive: France is one of the few countries with a statutory early-access reimbursement list specifically for innovative laboratory tests, and since 2024 an IVD MANUFACTURER can apply directly rather than having to persuade a learned society to do it. Mechanically: you file a dossier on the HAS EVActe platform at https://evacte.has-sante.fr/ and email the same dossier simultaneously to DGS-RIHN@sante.gouv.fr (first-time applicants must request an EVActe account beforehand). Eligible applicants are limited to (a) an 'exploitant' of an in vitro diagnostic medical device, i.e. the manufacturer or its French distributor, or (b) a Conseil National Professionnel (CNP). Hospitals cannot apply. The dossier must argue four eligibility criteria set by articles R.162-122 onward of the Code de la securite sociale: genuine novelty going beyond a technical evolution of an existing method; early phase of diffusion; characterised risks for patients; and a significant clinical or medico-economic benefit answering an unmet need. It must contain a systematic literature review, a critical gap analysis, target population estimates, a full data-collection protocol synopsis, tabulated summaries of every study cited, a provisional budget grid, CE marking documentation, a GDPR compliance attestation, and a justification",
  "submissionWindow": "ROLLING, not annual. This is a common and expensive misconception. The RIHN 2.0 guichet opened on 9 January 2025 and HAS invites manufacturers and CNPs to file dossiers on a continuous basis - the instruction clock starts from HAS's receipt of a complete dossier, not from a fixed annual cut-off. The historic RIHN was an annual campaign; RIHN 2.0 is not. Separately, the ministry publishes the LAHN list and its indicative valuations annually (an act must appear on the year n-1 published list to be financed in year n), and hospitals must declare their prior-year activity in the FICHSUP reporting tool in January.",
  "difficulty": "medium",
  "evidence": "Lower than a full HTA appraisal, and that is precisely the point of the route: you are not required to prove clinical superiority up front, you are required to show credible novelty, plausible benefit against an unmet need, and a rigorous PROSPECTIVE data-collection protocol that will answer the open questions within 6 years. In practice the data-collection protocol is the part that gets dossiers rejected, not the clinical evidence. HAS specifically assesses 'the relevance of the study protocol proposed'. Note the real constraint on the other side: HAS historically evaluated only around 15 act",
  "precedent": "MIXED, and the honest read is that no molecular transplant surveillance product has yet been funded in France by any route. dd-cfDNA in France today exists only in research: (1) the AI-CARE randomised controlled trial, sponsored by AP-HP with Prof Carmen Lefaucheur (Saint-Louis) as principal investigator, testing whether dd-cfDNA monitoring improves kidney transplant follow-up and reduces biopsies in the first 18 months, target 500 patients, running across nine sites (AP-HP Bicetre, Bichat, Georges Pompidou, Pitie-Salpetriere, Necker, Saint-Louis, Tenon, plus CHU Montpellier Saint-Eloi and CHU",
  "priceLow": 250,
  "priceHigh": 500,
  "currency": "EUR",
  "codes": [
   {
    "code": "NONE",
    "desc": "CRITICAL FINDING: there is NO donor-derived cell-free DNA, molecular rejection surveillance, transcriptomic biopsy, or graft-injury biomarker act anywhere on th",
    "price": "n/a",
    "currency": "EUR"
   },
   {
    "code": "M101",
    "desc": "Genotypage du cytochrome P450 3A5 pour ajustement de la dose d'un traitement comprenant du tacrolimus en transplantation - the ONLY transplant-specific molecula",
    "price": "78.30",
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "fra-merri-g03-the-closed-envelope-that",
  "iso3": "FRA",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "MERRI G03 - the closed envelope that actually pays for LAHN acts",
  "routeType": "block_contract",
  "decisionBody": "Direction generale de l'offre de soins (DGOS), disbursed to establishments by the regional health agencies (ARS)",
  "howItWorks": "Getting an act onto the LAHN gives you a national price. MERRI G03 is where the money physically comes from, and understanding it is the difference between a listing and a sale. MERRI (Missions d'Enseignement, de Recherche, de Reference et d'Innovation) are grant allocations paid to hospitals outside the per-stay tariff system. Line G03 is the ring-fenced, CLOSED envelope for out-of-nomenclature biology and pathology acts. Hospitals do not invoice patients or CNAM per test; instead they record each act performed in a dedicated reporting tool (currently a FICHSUP file), declaring by early year n their in-house activity for year n-1 plus activity performed for and received from third parties invoiced between 1 and 31 January. DGOS then allocates the envelope against declared activity via the ARS. Because the envelope is closed and demand exceeds it, hospitals recover on average only about 50% of the declared cost of the acts they perform. Where one hospital prescribes and another performs, the performing establishment invoices the prescribing establishment using the published indicative valuations, and the invoice must break down by act code or it is not binding on the prescriber. An act is financed at most ONCE and cannot be re-billed to the patient. Patients who are not social security beneficiaries are excluded from this financing entirely.",
  "submissionWindow": "Hospitals declare prior-year activity in January each year. The LAHN list for year n is published in year n-1.",
  "difficulty": "high",
  "evidence": "None at this stage - this is a payment mechanism, not an assessment. The assessment happened at LAHN listing.",
  "precedent": "DGOS itself documented the failure mode in July 2024: little data collection was done, few HAS evaluations happened, few acts ever left the RIHN, so a stock of 616 formerly-innovative acts accumulated inside a closed envelope, making it impossible to finance genuinely new acts. The fix being applied is a 20% annual reduction ('decote') in the value of the 2024 stock acts each year from 2025 through 2029, to force acts out and free headroom. An act newly admitted through the RIHN 2.0 flux route is EXEMPT from this decote for its 6-year term.",
  "priceLow": 125,
  "priceHigh": 250,
  "currency": "EUR",
  "codes": [
   {
    "code": "MERRI G03",
    "desc": "Closed national envelope for out-of-nomenclature biology and anatomopathology acts",
    "price": "507000000",
    "currency": "EUR"
   },
   {
    "code": "MERRI G03 (2024)",
    "desc": "Same envelope, 2024 figure as reported by industry sources",
    "price": "521500000",
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "fra-nabm-nomenclature-des-actes-de-bio",
  "iso3": "FRA",
  "assayClass": "hla_typing",
  "routeName": "NABM (Nomenclature des Actes de Biologie Medicale) - the permanent fee schedule",
  "routeType": "fee_schedule",
  "decisionBody": "UNCAM, on hierarchisation by the Commission de Hierarchisation des Actes de Biologie (CHAB)",
  "howItWorks": "The NABM is the permanent national fee schedule for medical biology. Acts are priced in 'B' coefficient units, with B = EUR 0.25, so a B380 act pays EUR 95.00. NABM listing is the destination state: it gives uncapped, durable, nationwide reimbursement including in private ambulatory laboratories and outside the closed MERRI envelope. You cannot apply to the NABM directly for an innovative test - the intended route is LAHN first, then migration to NABM after a favourable HAS Service Attendu / Amelioration du Service Attendu evaluation, with UNCAM performing the inscription during a 6-month window while LAHN coverage is extended. Note the important asymmetry for hospital inpatients: in the public sector, biology performed on an inpatient is already covered inside the GHS per-stay tariff, so the NABM B coefficient functions there mainly as an internal activity-monitoring unit rather than as incremental revenue. NABM revenue is real for outpatients, consultations externes, and the private sector.",
  "submissionWindow": "No open manufacturer guichet. Entry is via the LAHN exit procedure, or via CHAB/UNCAM conventional negotiation.",
  "difficulty": "very_high",
  "evidence": "Full HAS Service Attendu and Amelioration du Service Attendu assessment. This is a genuine HTA judgement on clinical utility and place in the care pathway, not the lighter novelty test used for LAHN admission.",
  "precedent": "HLA typing is the clearest example in France of a diagnostic that lives across BOTH lists simultaneously: the broad phenotyping acts sit on the permanent NABM at EUR 95 and EUR 175, while molecular and NGS-based typing sits on the LAHN at EUR 67.50 to EUR 378. A vendor selling HLA typing into France must understand which list its customers are billing against for each indication, because that determines their willingness to pay. Also note the direction of travel on price: CNAM cut French biology tariffs by about 9.4% from September 2024, following 7% in 2023 and 4% in January 2024, before a re",
  "priceLow": 95,
  "priceHigh": 175,
  "currency": "EUR",
  "codes": [
   {
    "code": "1180",
    "desc": "Groupages tissulaires : phenotype HLA classe I. Note explicitly restricted: 'A utiliser pour tout examen typage HLA classe I et maladies auto-immunes' (chapter ",
    "price": "95.00",
    "currency": "EUR"
   },
   {
    "code": "1181",
    "desc": "Groupages tissulaires : phenotype HLA classe II (chapter 7-3, coefficient B700)",
    "price": "175.00",
    "currency": "EUR"
   },
   {
    "code": "1691",
    "desc": "Recherche de l'allele HLA-B*57:01 (pre-abacavir screening) (chapter 14, coefficient B200)",
    "price": "50.00",
    "currency": "EUR"
   },
   {
    "code": "1122",
    "desc": "Lymphocytes helpers/suppresseurs (CD4, CD8, CD3) (chapter 5-1, coefficient B78)",
    "price": "19.50",
    "currency": "EUR"
   },
   {
    "code": "160",
    "desc": "Groupage plaquettaire (B200)",
    "price": "50.00",
    "currency": "EUR"
   },
   {
    "code": "161",
    "desc": "Groupage granulocytaire (NA, NB, NC, ND, NE) (B200)",
    "price": "50.00",
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "fra-lahn-molecular-and-ngs-hla-typing",
  "iso3": "FRA",
  "assayClass": "hla_typing",
  "routeName": "LAHN molecular and NGS HLA typing acts (post-transplant and non-graft indications)",
  "routeType": "innovation_list",
  "decisionBody": "DGOS / Ministere de la Sante, tariffs published in the annual LAHN list",
  "howItWorks": "Molecular and NGS-based HLA typing is NOT on the NABM; it sits on the LAHN with its own act codes and official maximum tariffs, paid from MERRI G03. The commercially decisive detail, which is written into the act definitions themselves and which most foreign vendors miss: several of these acts are only payable if performed in an EFI-ACCREDITED LABORATORY. The official note on G305 (NGS typing) reads 'A realiser au sein de laboratoires accredites par l'European Federation for Immunogenetics (EFI)', and the same condition attaches to the chimerism acts G179/G180/G225 and to the antibody characterisation acts G303/G304. Acts G174, G176, G224 and G300 carry the softer condition 'selon standards EFI'. In effect, EFI accreditation is a French reimbursement precondition. Tariffs are resolution-banded: a two-digit (low/intermediate resolution) locus typing pays EUR 67.50 regardless of technique including NGS; a four-digit (high resolution) locus typing pays EUR 189.00 including NGS; allelic resolution pays EUR 378.00; and there is a separate generic NGS act at EUR 270.00. Note these are PER LOCUS, so a full 11-locus high-resolution NGS typing is a substantial aggregate value.",
  "submissionWindow": "Rolling for new acts via RIHN 2.0; the priced list is republished annually.",
  "difficulty": "low",
  "evidence": "As for RIHN 2.0. For an EXISTING act, none - you simply need the customer laboratory to be able to bill it, which means holding EFI accreditation and having the method in COFRAC scope.",
  "precedent": "Directly applicable and favourable: France already reimburses NGS-based HLA typing at up to EUR 378 per locus for allelic resolution, and has done so without requiring a new listing for each new sequencing platform, because the acts are written technique-agnostically ('quelque soit la technique, y compris le NGS'). A new NGS or nanopore HLA typing product therefore does NOT need its own reimbursement application in France - it plugs straight into existing, well-paid act codes. That is a materially easier market entry than for dd-cfDNA. The gating factors are EFI accreditation of the customer l",
  "priceLow": 67.5,
  "priceHigh": 378,
  "currency": "EUR",
  "codes": [
   {
    "code": "G174",
    "desc": "Typage d'un locus HLA de classe I ou de classe II en biologie moleculaire, resolution basse ou intermediaire. Official note: 'A utiliser pour tout resultat atte",
    "price": "67.50",
    "currency": "EUR"
   },
   {
    "code": "G176",
    "desc": "Typage d'un locus HLA de classe I ou de classe II en biologie moleculaire, resolution haute. Official note: 'A utiliser pour un resultat 4 digits, quelque soit ",
    "price": "189.00",
    "currency": "EUR"
   },
   {
    "code": "G224",
    "desc": "Typage d'un locus HLA de classe I ou de classe II en biologie moleculaire, resolution allelique. Per locus. Highest-value HLA typing act in France.",
    "price": "378.00",
    "currency": "EUR"
   },
   {
    "code": "G305",
    "desc": "Typage d'un locus HLA de classe I ou de classe II par Next Generation Sequencing (NGS). CONDITION: must be performed in an EFI-accredited laboratory.",
    "price": "270.00",
    "currency": "EUR"
   },
   {
    "code": "G300",
    "desc": "Typage en urgence d'un locus HLA de classe I ou de classe II, resolution basse ou intermediaire. Official indication: 'Pour tout typage HLA urgent y compris don",
    "price": "270.00",
    "currency": "EUR"
   },
   {
    "code": "G301",
    "desc": "Recherche de la presence ou affirmation de l'absence d'un allele HLA (restricted prescription indication list). Exists to narrow use of NABM 1180/1181.",
    "price": "47.25",
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "fra-forfait-annuel-greffe-fag-the-capi",
  "iso3": "FRA",
  "assayClass": "hla_typing",
  "routeName": "Forfait Annuel Greffe (FAG) - the capitated bundle that pays for ALL pre-transplant HLA work",
  "routeType": "block_contract",
  "decisionBody": "Agence de la biomedecine (calculation, via the OFAS pole from CRISTAL data); paid to establishments by the ARS",
  "howItWorks": "This is the most commercially consequential and least understood fact about French transplant diagnostics. Pre-transplant HLA work is NOT billed per act in France. The Forfait Annuel Greffe is a capitated annual lump sum paid once a year to every establishment authorised to transplant, calculated by ABM's OFAS pole from the previous year's CRISTAL activity and paid by the ARS. The ABM's own 2025 financing brochure lists explicitly what the FAG is intended to cover, and the list includes three line items that matter enormously here: 'lors de l'inscription sur liste nationale d'attente : le typage HLA des patients'; 'le suivi HLA (recherche d'Ac anti-HLA) des patients sur liste'; and 'les analyses HLA pour cross match au moment de la greffe'. In other words, listing typage, on-waiting-list antibody monitoring, and the transplant crossmatch are all inside a FIXED annual envelope. The EFS 2025 tariff annexe corroborates this from the laboratory side: pre-graft acts are marked funding source 'FAG' while post-graft equivalents of the SAME test are marked 'MERRI 03'. The FAG is calculated in tranches: for 2025, EUR 49,060 per tranche of 10 kidney grafts (minimum 5 grafts) and EUR 43,488 per tranche of 10 for other organs; plus EUR 11,421 per tranche of 10 patients LISTED for kidney and EUR 10,308 for other organs; plus EUR 7,038 linearly per living-donor graft (subject to a 3-year ave",
  "submissionWindow": "Allocated annually at the start of the budget campaign, based on year n-1 CRISTAL activity. There is no application - it is automatic for authorised centres.",
  "difficulty": "very_high",
  "evidence": "None. This is a funding formula, not an assessment.",
  "precedent": "The direct commercial consequence, and it should shape the entire French go-to-market: a PRE-transplant product (HLA typing for listing, crossmatch, pre-transplant risk scoring, FcgR/KIR genotyping, APOL1 donor testing) must be sold as a COST-DISPLACEMENT or capacity argument, because it generates no new revenue for the buyer - it consumes a fixed FAG allocation. A POST-transplant product (dd-cfDNA surveillance, post-graft DSA monitoring, urinary CXCL9, chimerism) can be sold as REVENUE, because those acts are billable per test against the LAHN and MERRI G03. Scira's pillars therefore split cl",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "EUR",
  "codes": [
   {
    "code": "FAG rein - tranche de 10 greffes",
    "desc": "Kidney, per tranche of 10 transplants (minimum 5), 2025 rate (2024 was EUR 48,333)",
    "price": "49060",
    "currency": "EUR"
   },
   {
    "code": "FAG autres organes - tranche de 10 greffes",
    "desc": "Non-kidney organs, per tranche of 10 transplants, 2025 rate",
    "price": "43488",
    "currency": "EUR"
   },
   {
    "code": "FAG rein - tranche de 10 patients inscrits",
    "desc": "Kidney, per tranche of 10 patients on the waiting list, 2025 rate. THIS is the line that funds on-list anti-HLA antibody monitoring.",
    "price": "11421",
    "currency": "EUR"
   },
   {
    "code": "FAG DV",
    "desc": "Living donor, linear per living-donor transplant, 2025 rate (2024 was EUR 6,934)",
    "price": "7038",
    "currency": "EUR"
   },
   {
    "code": "G169 (EFS/V5, FAG-funded)",
    "desc": "Cross Match pre-greffe en LCT, per recipient, daytime - the highest-value single act in French histocompatibility",
    "price": "1215.00",
    "currency": "EUR"
   },
   {
    "code": "G030 (EFS/V5, FAG-funded)",
    "desc": "Cross Match pre-greffe en LCT, per recipient, on-call/out-of-hours",
    "price": "2025.00",
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "fra-lahn-chimerism-acts-post-allogenei",
  "iso3": "FRA",
  "assayClass": "chimerism",
  "routeName": "LAHN chimerism acts (post-allogeneic HSCT monitoring)",
  "routeType": "innovation_list",
  "decisionBody": "DGOS / Ministere de la Sante",
  "howItWorks": "Chimerism monitoring after allogeneic haematopoietic stem cell transplantation is already fully established on the French LAHN as three separate, well-paid acts, all restricted to EFI-accredited laboratories. There is no reimbursement work to do: a chimerism product sells into existing act codes. The three acts are structured to reflect the real workflow - one for defining the informative markers up front on donor and recipient (the highest value, EUR 459), then per-test acts for whole blood or marrow (EUR 135) and for sorted cell fractions (EUR 189). The sorted-cell act being priced 40% higher than whole blood is commercially significant: lineage-specific chimerism is explicitly recognised and better paid, which favours a higher-resolution technology.",
  "submissionWindow": "n/a for existing acts",
  "difficulty": "low",
  "evidence": "None for existing acts. Note the acts are on the LAHN 'stock' and therefore subject to the 20% annual decote from 2025 to 2029 UNLESS re-admitted through the RIHN 2.0 flux procedure. A manufacturer with a superior chimerism technology could file a RIHN 2.0 dossier to establish a NEW, decote-exempt act at a defensible price - a genuinely under-used play.",
  "precedent": "This is the strongest positive reimbursement precedent in France for anything Scira sells. It proves the French system will fund a molecular post-transplant monitoring test, repeatedly, at EUR 135-459 per act, tied to EFI-accredited laboratories - which is structurally identical to what a dd-cfDNA surveillance act would look like. Cite it directly in a RIHN 2.0 dossier as the comparator.",
  "priceLow": 135,
  "priceHigh": 459,
  "currency": "EUR",
  "codes": [
   {
    "code": "G225",
    "desc": "Definition des marqueurs informatifs pour le suivi du chimerisme post-greffe (chez donneur et receveur). EFI-accredited laboratories only. One-off per donor/rec",
    "price": "459.00",
    "currency": "EUR"
   },
   {
    "code": "G179",
    "desc": "Etude du chimerisme (sur sang total ou moelle). EFI-accredited laboratories only. Per test, repeated through follow-up.",
    "price": "135.00",
    "currency": "EUR"
   },
   {
    "code": "G180",
    "desc": "Etude du chimerisme (sur cellules triees du sang ou de la moelle). EFI-accredited laboratories only. Lineage-specific chimerism.",
    "price": "189.00",
    "currency": "EUR"
   },
   {
    "code": "N450",
    "desc": "Adjacent act: quantification d'une cible d'immunogenetique (Ig/TCR) lors du suivi d'une leucemie lymphoblastique ou d'un syndrome lymphoproliferatif (measurable",
    "price": null,
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "fra-ghm-ghs-per-stay-tariffs-t2a-inpat",
  "iso3": "FRA",
  "assayClass": "biopsy_molecular",
  "routeName": "GHM/GHS per-stay tariffs (T2A) - inpatient funding",
  "routeType": "drg_addon",
  "decisionBody": "Ministere de la Sante, on ATIH costing; tariffs set in the annual campagne tarifaire",
  "howItWorks": "Any test performed on an admitted inpatient in a French public hospital is paid for inside the GHS per-stay tariff for that admission. There is no separate line item and, for laboratory tests, no 'liste en sus' equivalent to the one that exists for expensive drugs and implantable devices. Transplant admissions sit in GHM root 27C0x, graded into four severity levels; graft rejection admissions sit in root 21M15. This matters for a molecular biopsy or rejection-adjudication product in a specific way: if your test is used during an inpatient episode, the hospital absorbs its full cost against a fixed stay tariff, so your commercial argument must be that the test SHORTENS the stay or avoids a subsequent one. Note graft rejection stays are stratified sharply by severity: level 1 pays EUR 2,124 for a mean 2.4 days while level 4 pays EUR 30,737 for a mean 30.8 days, so preventing escalation from level 1-2 to level 3-4 is worth EUR 10,000-28,000 per avoided episode. That is the single strongest health-economic argument available in France for early rejection detection, and it is computable from public ATIH data. Transplant activity tariffs were uplifted 1% for 2025 against 0.2% for general activity, indicating deliberate policy support for transplantation.",
  "submissionWindow": "Annual tariff campaign (campagne tarifaire), tariffs effective 1 March each year.",
  "difficulty": "very_high",
  "evidence": "Not an assessment route for a diagnostic. Changing a GHS tariff requires ATIH cost-study evidence and is a multi-year policy exercise, not a product launch tactic.",
  "precedent": "The 2024 PMSI volumes are the most useful output of this route for market sizing: 3,550 kidney transplant stays and 2,334 graft rejection admissions across all severity levels. Those 2,334 rejection admissions, costing between EUR 2,124 and EUR 30,737 each, are the addressable clinical and economic target for a rejection surveillance product in France.",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "EUR",
  "codes": [
   {
    "code": "27C061 / GHS 8922",
    "desc": "Transplantations renales, niveau 1. 192 stays in 2024, mean length of stay 6.91 days.",
    "price": "13989.24",
    "currency": "EUR"
   },
   {
    "code": "27C062 / GHS 8923",
    "desc": "Transplantations renales, niveau 2. 1,896 stays in 2024, mean 11.59 days. The modal kidney transplant stay.",
    "price": "17624.08",
    "currency": "EUR"
   },
   {
    "code": "27C063 / GHS 8924",
    "desc": "Transplantations renales, niveau 3. 979 stays in 2024, mean 16.71 days.",
    "price": "24358.91",
    "currency": "EUR"
   },
   {
    "code": "27C064 / GHS 8925",
    "desc": "Transplantations renales, niveau 4. 483 stays in 2024, mean 24.71 days.",
    "price": "36328.46",
    "currency": "EUR"
   },
   {
    "code": "21M151 / GHS 7604",
    "desc": "Rejets de greffe, niveau 1. 843 stays in 2024, mean 2.39 days.",
    "price": "2124.46",
    "currency": "EUR"
   },
   {
    "code": "21M152 / GHS 7605",
    "desc": "Rejets de greffe, niveau 2. 729 stays in 2024, mean 8.29 days.",
    "price": "8690.99",
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "fra-forfait-innovation-article-l165-1",
  "iso3": "FRA",
  "assayClass": "poc_biomarker",
  "routeName": "Forfait innovation (Article L165-1-1 du Code de la securite sociale)",
  "routeType": "hta_appraisal",
  "decisionBody": "HAS - Commission Nationale d'Evaluation des Dispositifs Medicaux et des Technologies de Sante (CNEDiMTS), with ministerial decision",
  "howItWorks": "A separate, derogatory and temporary reimbursement scheme allowing early patient access to innovative health technologies still at an early stage of clinical development, conditional on the applicant conducting a clinical study to generate the missing evidence. It is evaluated by HAS (CNEDiMTS for devices) and decided by the ministers for health and social security. It is the natural route for a DEVICE-shaped product - a point-of-care instrument plus cartridge, for example a urinary CXCL9 reader - as opposed to a laboratory ACT, which goes down the RIHN 2.0/LAHN route. HONEST LIMITATION: the detailed HAS procedural pages for the forfait innovation could not be retrieved in this session (the HAS site returned its homepage rather than the target page, and the corresponding Legifrance article URL 404'd), so the specific dossier contents, decision timelines, funding ceilings, and the question of whether a pure in vitro diagnostic is eligible are NOT verified here. Treat this pathway as identified but not yet mapped. It has historically been used sparingly - a handful of technologies - so it should be regarded as a specialist option, not a default.",
  "submissionWindow": "Rolling application to HAS. Not verified.",
  "difficulty": "high",
  "evidence": "Early clinical data plus a committed, funded prospective clinical study protocol. Not verified in detail.",
  "precedent": "None found for a transplant diagnostic. No comparable transplant product (AlloSure, Prospera, MMDx, AlloMap) has been funded in France by this or any other route.",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "fra-public-procurement-marches-publics",
  "iso3": "FRA",
  "assayClass": "hla_typing",
  "routeName": "Public procurement (marches publics) - the route to actually selling reagents and instruments",
  "routeType": "tender",
  "decisionBody": "Individual CHU/EFS purchasing departments, or central purchasing bodies UniHA and RESAH, under the Code de la commande publique",
  "howItWorks": "Reimbursement listing tells you what a test is worth; procurement determines whether you can sell it. French public hospital and EFS purchasing runs as formal tenders (accords-cadres) published on BOAMP.fr and, above EU thresholds, on TED. There are two routes. First, central purchasing bodies: UniHA (about 1,500 members, EUR 7.7bn purchases in 2025, runs an Immuno-Hematologie framework 2022-2027) and RESAH (Biology-Pathology division, about EUR 110m in 2023, extended into molecular biology in 2024, and which publicly cites 4-6 weeks to get referenced on a framework). UGAP is generalist and less relevant; CAIH is hospital IT only and is NOT relevant to IVDs despite often being listed. Second, and importantly for histocompatibility specifically, many HLA tenders are run DIRECTLY by the CHU or by EFS rather than through a central body, because the requirement is too specialist. The dominant contract structure is 'mise a disposition' (MAD) reagent rental: the vendor supplies or cheaply rents the analyser and locks in exclusive reagent supply for the framework term, typically multiple years. That is the real barrier for a new entrant - you are not competing on assay merit, you are bidding to displace an installed analyser base, and only at renewal. Practical requirements to bid: CE-IVDR marking, ISO 13485 quality system, compatibility with the hospital's existing LIS and analyser e",
  "submissionWindow": "Rolling but framework-gated. Monitor BOAMP.fr and TED continuously for 'typage HLA', 'histocompatibilite', 'immunogenetique' and 'reactifs immuno-hematologie'. The UniHA Immuno-Hematologie framework expires in 2027, which is the single most important date in the French HLA procurement calendar.",
  "difficulty": "medium",
  "evidence": "CE-IVDR marking, ISO 13485, technical conformity to the tender's cahier des charges, price. Clinical evidence is largely irrelevant at this stage - that battle was fought at the reimbursement listing.",
  "precedent": "Werfen (Immucor LIFECODES) won all three identified 2025 French histocompatibility tenders. Assume Werfen incumbency across much of EFS and a significant number of CHUs, with Thermo Fisher One Lambda and EuroBio Scientific/GenDx as the other named competitors in French framework agreements. Note that ANSM published a safety notice for a Werfen LIFECODES class I histocompatibility reagent in July 2026 - incumbent quality events are the classic opening for a challenger at renewal.",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "EUR",
  "codes": [
   {
    "code": "EFS tender, published 13 Oct 2025",
    "desc": "Reactifs et references annexes pour le typage HLA de haute resolution, specified for MiSeq AND Nanopore platforms. Awarded to Werfen. Confirms nanopore is an ac",
    "price": "not disclosed",
    "currency": "EUR"
   },
   {
    "code": "EFS tender, published 25 Jul 2025",
    "desc": "Reagents for Luminex single-antigen anti-HLA antibody identification. Awarded to Werfen.",
    "price": "not disclosed",
    "currency": "EUR"
   },
   {
    "code": "CHRU Caen, awarded 20 Jan 2025",
    "desc": "Produits d'histocompatibilite avec ou sans mise a disposition (MAD). Awarded to Werfen.",
    "price": "not disclosed",
    "currency": "EUR"
   },
   {
    "code": "CHU Clermont-Ferrand, published 3 Feb 2025, deadline 3 Mar 2025",
    "desc": "Rental of an automated analyser with captive reagent supply for urgent HLA typing, Histocompatibility/Immunogenetics department",
    "price": "271488",
    "currency": "EUR"
   },
   {
    "code": "UniHA M-2677",
    "desc": "Immuno-Hematologie framework, 2022-2027, covering typing and screening instruments and reagents",
    "price": "not disclosed",
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "sau-sfda-medical-device-marketing-auth",
  "iso3": "SAU",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "SFDA Medical Device Marketing Authorisation (MDMA2) - the mandatory gate before any reimbursement conversation",
  "routeType": "tender",
  "decisionBody": "Saudi Food and Drug Authority (SFDA), Medical Devices Sector",
  "howItWorks": "Step 1: appoint an SFDA-licensed Authorised Representative established in Saudi Arabia. You cannot submit anything yourself as a foreign manufacturer, and the MDMA will be issued naming your AR. Step 2: classify the IVD. SFDA uses a risk-based classification aligned to IMDRF with classes A, B, C and D; IVDs follow a separate seven-rule classification set that mirrors EU IVDR, so an EU IVDR classification generally transfers directly. A dd-cfDNA rejection-surveillance assay used to guide transplant management will almost certainly fall in Class C or D. Step 3: your AR submits a full Technical File Application through the SFDA e-portal under the MDMA2 route. The old GHTF/MDMA1 abridged route, which allowed reliance on a reference-country approval, was cancelled in 2021 and MDMA2 has been the only route since January 2022, so a CE mark or FDA clearance no longer buys you a short-cut, only supporting evidence. IVD files additionally require analytical and clinical performance evaluation data in the Product Verification and Validation section. Step 4: pay the fee. 2026 fees: Class A SAR 15,000, Class B SAR 19,000, Class C SAR 21,000, Class D SAR 23,000; renewal SAR 5,000; minor label/IFU updates SAR 1,100. Step 5: SFDA reviews. The stated target is 35 business days but real-world experience is 3 to 6 months and can extend to 14 months for high-risk devices or where deficiency letter",
  "submissionWindow": "Rolling. No windows.",
  "difficulty": "high",
  "evidence": "Full technical file to IMDRF/EU-IVDR-equivalent standard: quality management system evidence (ISO 13485), design and manufacturing information, risk management, analytical performance (precision, LoD, linearity, interference, specimen stability), clinical performance evaluation, labelling and IFU, and post-market surveillance plan. SFDA does not run its own clinical trials requirement but will scrutinise the clinical evidence dossier. For a laboratory-developed-test business model this is the structural problem: SFDA regulates the product, so a pure send-out LDT service model has an awkward fi",
  "precedent": "No published precedent found for AlloSure, Prospera or MMDx holding a Saudi MDMA. This is a genuine gap in the research rather than evidence of absence, but it does suggest that transplant molecular surveillance is not yet formally registered in the Kingdom and that whoever registers first sets the reference.",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "SAR",
  "codes": []
 },
 {
  "id": "sau-nupco-national-tender-and-framewor",
  "iso3": "SAU",
  "assayClass": "hla_typing",
  "routeName": "NUPCO national tender and framework supply agreement (government sector)",
  "routeType": "tender",
  "decisionBody": "National Unified Procurement Company (NUPCO), PIF-owned",
  "howItWorks": "This is the route by which almost all HLA typing reagents, sequencing consumables and IVD kits reach Saudi government hospitals, and it is the practical definition of the Saudi market. Step 1: hold a valid SFDA MDMA. SFDA product registration is a mandatory prerequisite for participation and must be secured well before the bid deadline; there is no mechanism to bid conditionally. Step 2: register as a NUPCO supplier through the NUPCO supplier portal. Registration requires a Saudi commercial registration, so in practice your AR/distributor is the registered supplier, not you. Step 3: monitor tender announcements. NUPCO publishes tenders (reference format NPT00xx-yy) and, importantly, publishes final results as PDFs on nupco.com, so incumbent awards and pricing are partially discoverable, which is unusual and useful. Step 4: submit the bid. Documentation is primarily Arabic and requires Arabic-language capability or local support. Step 5: NUPCO awards multi-year framework supply agreements to qualified suppliers; MOH facilities and health clusters then place call-off orders against the framework. Local content and local manufacturing are increasingly weighted in evaluation, so a local packaging, kitting or laboratory presence materially improves scoring. NOTE: NUPCO covers MOH and most government entities but NOT the Ministry of Defence (PSMMC) or the National Guard (MNGHA), whic",
  "submissionWindow": "Per-tender deadlines announced on the NUPCO portal. Frameworks are typically multi-year, so missing a cycle can cost two to three years of access.",
  "difficulty": "high",
  "evidence": "Commercial and regulatory rather than clinical: valid SFDA MDMA, supplier registration, financial and technical qualification, sample provision and sometimes on-site evaluation. Clinical evidence matters at the stage where the specification is written, not at the bid stage, which is why influencing the tender specification through clinical champions and SCOT is more valuable than bidding harder.",
  "precedent": "One Lambda (Thermo Fisher) has been the global reference vendor for HLA typing since Thermo's 2012 acquisition and is the presumed incumbent across Gulf HLA laboratories, though a specific Saudi NUPCO award was not located in this run. Assume an entrenched incumbent and price and position accordingly.",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "SAR",
  "codes": []
 },
 {
  "id": "sau-cooperative-health-insurance-under",
  "iso3": "SAU",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Cooperative health insurance under the CHI Unified Policy, adjudicated through NPHIES (private and expatriate sector)",
  "routeType": "fee_schedule",
  "decisionBody": "Council of Health Insurance (CHI, formerly CCHI)",
  "howItWorks": "This is the route for the roughly 12 million privately insured lives (all private-sector employees and their dependants, and expatriates, for whom employer-provided cooperative insurance is compulsory). CHI licenses the insurers and TPAs and sets the Unified Policy, which defines the essential benefits every policy must cover. Claims are submitted electronically through the NPHIES national health information exchange using ICD-10 diagnoses and CPT procedure codes, with mandatory electronic pre-authorisation for higher-cost items. Mechanically, for a new laboratory test the sequence is: (1) confirm the test maps to an existing CPT code or an appropriate unlisted molecular pathology code; (2) get the ordering hospital's revenue-cycle team to load it into their chargemaster; (3) obtain pre-authorisation from the specific insurer per patient, which for an unlisted or novel code means a medical-necessity submission each time; (4) negotiate a price with the individual insurer or TPA, because there is no single published national laboratory tariff equivalent to Abu Dhabi's Mandatory Tariff. There is no formal HTA appraisal step and no innovation-list mechanism; adoption is insurer-by-insurer and, in practice, hospital-by-hospital.",
  "submissionWindow": "Rolling. Per-patient pre-authorisation rather than an annual coding cycle.",
  "difficulty": "high",
  "evidence": "Insurer medical policy standard rather than HTA standard: peer-reviewed evidence of clinical validity and utility, ideally with an international guideline or a US payer coverage policy to point at. Saudi insurers lean heavily on US precedent, so a US CPT/PLA code and a Medicare or major-commercial coverage policy for the comparable assay is the most persuasive single artefact you can carry into the meeting.",
  "precedent": "No evidence found of AlloSure, Prospera or MMDx being covered under the CHI Unified Policy. Assume no precedent and that you are creating the category.",
  "priceLow": 1500,
  "priceHigh": 4000,
  "currency": "SAR",
  "codes": []
 },
 {
  "id": "sau-direct-hospital-budget-purchase-at",
  "iso3": "SAU",
  "assayClass": "poc_biomarker",
  "routeName": "Direct hospital budget purchase at a Health Cluster or non-MOH institution (KFSHRC, MNGHA, MoD)",
  "routeType": "block_contract",
  "decisionBody": "Individual health cluster, KFSHRC, Ministry of National Guard Health Affairs, or Medical Services of the Armed Forces",
  "howItWorks": "The realistic route for a point-of-care urinary CXCL9 test, because a POC device consumed inside the transplant clinic does not need an insurer claim at all if the hospital absorbs it into its own budget. Under the Health Sector Transformation Programme, regional Health Clusters have devolved decision rights over resource allocation, so a cluster can fund a clinic-level test out of its own operating budget. Non-MOH institutions (KFSHRC, MNGHA, Ministry of Defence) have always had this latitude and their own tender processes. Mechanically: identify the clinical champion in the transplant unit, get the test into the departmental business case, have the department raise the requisition against its cost centre, and route the contract through whichever procurement body owns that institution (NUPCO for MOH clusters, institutional tender for KFSHRC/MNGHA/MoD). Volume is smaller than a NUPCO framework but the cycle is 6-12 months rather than 18-36.",
  "submissionWindow": "Aligned to institutional budget cycles, typically annual and tied to the Saudi fiscal year (calendar year since 2016).",
  "difficulty": "medium",
  "evidence": "A departmental business case: clinical rationale, comparison against current practice (surveillance biopsy and creatinine monitoring), cost per patient per year, and ideally a local pilot. Much lower evidentiary bar than a national policy change.",
  "precedent": "None found.",
  "priceLow": 150,
  "priceHigh": 600,
  "currency": "SAR",
  "codes": []
 },
 {
  "id": "are-emirates-drug-establishment-federa",
  "iso3": "ARE",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Emirates Drug Establishment federal device/IVD registration via a UAE Local Representative",
  "routeType": "tender",
  "decisionBody": "Emirates Drug Establishment (EDE), which assumed device registration from MOHAP",
  "howItWorks": "Step 1: appoint a UAE Local Representative. This must be an entity licensed by the health authority as a medical store or, alternatively, as a scientific office; if you appoint a scientific office, importation and distribution must be carried out by a separately appointed licensed medical store. Step 2: decide the structure deliberately. You may appoint your distributor as your Local Representative, which is simplest, OR you may appoint an independent Local Representative with no commercial interest in sales, which preserves the flexibility to appoint several distributors and to change them without losing the registration. THIS IS THE SINGLE MOST IMPORTANT COMMERCIAL DECISION IN UAE ENTRY. If the distributor holds the registration, moving distributor means losing or re-doing your registration and the incumbent has substantial leverage over you. Step 3: register the establishment and then list/register the product with EDE. Step 4: emirate layer. DHA does not maintain a separate device registry but requires evidence of federal registration at facility inspection and in procurement qualification; DoH Abu Dhabi likewise requires federally registered devices in DoH-licensed facilities and applies additional vendor qualification requirements on top. Note the live transition risk: EDE was established 2 January 2025 and absorbed MOHAP's registration services through 2025-2026, so guid",
  "submissionWindow": "Rolling.",
  "difficulty": "medium",
  "evidence": "Free-sale certificate and reference-market approval (CE or FDA) plus technical documentation, ISO 13485, labelling and IFU. The UAE has historically relied more heavily on reference-country approval than Saudi Arabia does, which makes it materially easier and faster than the SFDA MDMA2 route. That asymmetry is the reason to enter the UAE first.",
  "precedent": "Not established for transplant molecular surveillance.",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "AED",
  "codes": []
 },
 {
  "id": "are-doh-abu-dhabi-mandatory-tariff-sha",
  "iso3": "ARE",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "DoH Abu Dhabi Mandatory Tariff (Shafafiya) - CPT-based insurance reimbursement",
  "routeType": "fee_schedule",
  "decisionBody": "Department of Health - Abu Dhabi, Healthcare Payer Sector",
  "howItWorks": "This is the most mechanically tractable reimbursement route anywhere in the Gulf, and it is the reason the UAE should be entered before Saudi Arabia. DoH publishes a Mandatory Tariff Pricelist plus Claims and Adjudication Rules on the Shafafiya portal, which together bind insurers on what they must pay. DoH mandates the use of all CPT codes that are active and available for billing. Laboratory services in the CPT range 80047-89398 are reimbursed at 90% of the US Medicare 2008 RVU, and facilities may apply a multiplier of roughly 1x to 3x the base rate depending on facility tier. So: if your assay has a US CPT or PLA code, an Abu Dhabi price already exists by arithmetic, without any bespoke appraisal. Mechanically: (1) secure or identify a US CPT/PLA code for the assay; (2) confirm it appears in the current Mandatory Tariff Pricelist version on Shafafiya (V2025.1 at the time of writing); (3) if it is absent, DoH incorporates CPT additions, deletions and description updates released by the AMA and CMS at its periodic Mandatory Tariff updates, and revises prices using RVUs, demand and supply and market trends, so the ask is to have the new code picked up at the next update rather than to obtain a bespoke national decision; (4) engage the DoH Healthcare Payer Sector directly to confirm inclusion and the applicable rate; (5) separately, negotiate with Daman for Thiqa and Basic/Enhan",
  "submissionWindow": "Limited and periodic updates to the Mandatory Tariff Pricelist and the DoH Claims and Adjudication Rules, published on Shafafiya. Version V2025.1 was current at the time of research. There is no published fixed annual deadline; approach the Healthcare Payer Sector well before the update in which you want inclusion.",
  "difficulty": "medium",
  "evidence": "Notably lighter than a European HTA. DoH's stated methodology is price-setting based on RVUs, demand and supply, market trends and economic factors rather than a formal cost-effectiveness appraisal. Clinical evidence is needed to persuade the ordering clinicians and Daman's medical policy team rather than to satisfy a formal HTA body. A US payer coverage policy for a comparable assay is again the highest-leverage document.",
  "precedent": "No evidence found that AlloSure, Prospera, MMDx or AlloMap is listed in the DoH Mandatory Tariff. Given the CPT-derived mechanism, if any of them holds a US PLA code there is a plausible path for that code to already be adjudicable, which is worth checking directly against the current pricelist as a first research action.",
  "priceLow": 1200,
  "priceHigh": 4000,
  "currency": "AED",
  "codes": [
   {
    "code": "80047-89398 (range)",
    "desc": "Pathology and laboratory services CPT range, reimbursed at 90% of US Medicare 2008 RVU under the DoH Mandatory Tariff, with a facility-tier multiplier of approx",
    "price": "derived from Medicare 2008 RVU x 0.9 x facility multiplier",
    "currency": "AED"
   }
  ]
 },
 {
  "id": "are-dubai-mandatory-health-insurance-a",
  "iso3": "ARE",
  "assayClass": "biopsy_molecular",
  "routeName": "Dubai mandatory health insurance and Dubai Health institutional purchase",
  "routeType": "block_contract",
  "decisionBody": "Dubai Health Authority (payer policy) and Dubai Health (provider budget)",
  "howItWorks": "Dubai requires mandatory health insurance for all residents under the DHA scheme, with an Essential Benefits Plan floor for lower-income workers and richer commercial products above it. Unlike Abu Dhabi, there is no publicly confirmed mandatory clinical-costing framework or published RVU-derived tariff methodology, so laboratory pricing in Dubai is more negotiated and less rule-driven. The practical consequence is that the fastest route in Dubai is institutional rather than tariff-based: Dubai Health is simultaneously the provider (Rashid Hospital, Dubai Hospital) and, through DHA, the regulator, so a single institutional agreement with Dubai Health can cover clinical adoption and payment without a tariff change. Mechanically: secure the transplant clinical champion inside Dubai Health, build the departmental case, and negotiate a per-test or annual-volume contract. For private hospitals (Mediclinic City, American Hospital, and the DHCC free-zone facilities regulated by Dubai Healthcare City Authority rather than DHA), the route is direct commercial contracting plus billing to Enhanced insurance or self-pay.",
  "submissionWindow": "Rolling; negotiated.",
  "difficulty": "medium",
  "evidence": "Institutional business-case standard. Lower bar than Abu Dhabi's tariff route but with a correspondingly smaller and less durable revenue base, since it is a contract rather than a schedule entry.",
  "precedent": "None found.",
  "priceLow": 1500,
  "priceHigh": 5000,
  "currency": "AED",
  "codes": []
 },
 {
  "id": "are-seha-purehealth-and-m42-group-proc",
  "iso3": "ARE",
  "assayClass": "hla_typing",
  "routeName": "SEHA / PureHealth and M42 group procurement",
  "routeType": "tender",
  "decisionBody": "PureHealth (SEHA hospitals) and M42 (Cleveland Clinic Abu Dhabi) group procurement functions",
  "howItWorks": "The UAE has no NUPCO equivalent, but the effect of consolidation is similar: a small number of very large group buyers control most of the addressable volume. In Abu Dhabi, SEHA (which includes Sheikh Khalifa Medical City and Sheikh Shakhbout Medical City) and Cleveland Clinic Abu Dhabi sit within the PureHealth/M42 ecosystem, so one group framework can cover the majority of Abu Dhabi transplant activity. Mechanically: complete EDE registration through your Local Representative, get vendor-qualified with the group (which imposes requirements beyond federal registration), build the clinical case with the transplant units at SKMC/SSMC/CCAD in parallel, and then negotiate a group supply agreement. In Dubai, Dubai Health procures for Rashid and Dubai Hospital. Because HLA typing consumables are a recurring reagent spend rather than a claim-per-patient service, this contract route matters more for HLA than the tariff route does.",
  "submissionWindow": "Group tender cycles, not published.",
  "difficulty": "high",
  "evidence": "Regulatory registration, vendor qualification, technical evaluation and often an on-site laboratory evaluation against the incumbent platform. Switching costs in HLA are high because of validated workflows, LIS integration and staff training, which is the incumbent's main defence.",
  "precedent": "One Lambda (Thermo Fisher) is the presumed regional incumbent for HLA typing following Thermo's USD 925m acquisition in 2012; no specific UAE contract was located.",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "AED",
  "codes": []
 },
 {
  "id": "qat-hamad-medical-corporation-institut",
  "iso3": "QAT",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Hamad Medical Corporation institutional procurement",
  "routeType": "block_contract",
  "decisionBody": "Hamad Medical Corporation",
  "howItWorks": "Qatar is effectively a single-buyer market. HMC operates the only transplant centre (QCOT) and the national donation authority (Hiba), and it procures centrally. There is no tariff-code route to pursue because there is no meaningful competing private transplant activity. Mechanically: register the product with the Ministry of Public Health through a local agent, then sell institutionally to HMC's laboratory and transplant services. One clinical champion plus one procurement decision covers the whole country. Volume is small (60 kidney, 12 liver, 1 lung in 2024) but the decision cycle is short and per-unit price tolerance is high.",
  "submissionWindow": "HMC tender cycles.",
  "difficulty": "medium",
  "evidence": "Institutional business case plus MoPH product registration via a local agent.",
  "precedent": "None found.",
  "priceLow": 400,
  "priceHigh": 1500,
  "currency": "QAR",
  "codes": []
 },
 {
  "id": "deu-nub-neue-untersuchungs-und-behandl",
  "iso3": "DEU",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "NUB (Neue Untersuchungs- und Behandlungsmethoden) application to InEK, then hospital-level NUB-Entgelt negotiation",
  "routeType": "drg_addon",
  "decisionBody": "Institut fur das Entgeltsystem im Krankenhaus (InEK GmbH), then local sickness funds (Krankenkassen) at each hospital",
  "howItWorks": "NUB is the interim funding mechanism for methods that are not yet adequately paid for inside the G-DRG lump sum. Critically, the applicant is the HOSPITAL, not the manufacturer: each individual hospital must file its own application through the InEK Datenportal, and the annual deadline is 31 October for the following calendar year (e.g. 31 October 2026 for the 2027 budget year). InEK publishes its status decisions by 31 January. Status 1 means InEK accepts the method is new and not adequately reimbursed within the DRG, which gives that hospital permission to negotiate a hospital-specific NUB surcharge (NUB-Entgelt) with its local sickness funds under section 6(2) KHEntgG; Status 2 means the criteria are not met; Status 3 means the information provided was insufficient; Status 4 means it is already adequately funded. Status 1 is a permission to negotiate, not a price and not a guarantee of payment: the amount and the volume cap are agreed bilaterally in the hospital's annual Budgetverhandlung. NUB status must be re-applied for every single year and is typically time-limited before InEK expects the method to be absorbed into the DRG or converted into a Zusatzentgelt. Practically, a diagnostics company must run a coordinated NUB campaign: prepare a template dossier (method description, patient group, why the DRG does not cover the cost, cost per case) and push each target hospital",
  "submissionWindow": "Annual. InEK NUB applications due 31 October each year for the following calendar year; InEK decisions published by 31 January. Separate OPS code proposals to BfArM close around end of February for the following year's OPS version.",
  "difficulty": "medium",
  "evidence": "InEK does not assess clinical benefit at all. It assesses novelty and whether the cost is already covered by the DRG. The clinical evidence battle happens later, at the individual sickness fund negotiation and, if the method becomes contested, at the G-BA. This is why NUB is the fastest German route: low evidence bar at InEK, but the money still has to be won hospital by hospital.",
  "precedent": "No published evidence was found of a dd-cfDNA transplant surveillance test (AlloSure, Prospera) holding NUB status in Germany. MMDx-style molecular biopsy assessment has been used in German centres largely on a research or self-pay basis. The absence of precedent is itself the finding: Germany is an open field but also means there is no trail to follow.",
  "priceLow": 900,
  "priceHigh": 2200,
  "currency": "EUR",
  "codes": [
   {
    "code": "NUB (no permanent code)",
    "desc": "NUB entries carry an InEK NUB number for the application year only; they are not permanent OPS or DRG codes. A parallel OPS code application to BfArM (deadline ",
    "price": null,
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "deu-zusatzentgelt-ze-within-the-g-drg",
  "iso3": "DEU",
  "assayClass": "hla_typing",
  "routeName": "Zusatzentgelt (ZE) within the G-DRG catalogue",
  "routeType": "drg_addon",
  "decisionBody": "InEK GmbH (catalogue owner), Selbstverwaltung (GKV-Spitzenverband, PKV, DKG) as contracting parties",
  "howItWorks": "Zusatzentgelte are additional payments unbundled from the DRG lump sum for defined expensive items. They come in two forms: bewertete ZE, which appear in Anlage 2 of the Fallpauschalenkatalog with a nationally fixed price, and unbewertete ZE in Anlage 4/6, which are listed but priced hospital by hospital in the annual budget negotiation. New ZE are created by InEK on the basis of calculation-hospital cost data, so the practical route for a manufacturer is a multi-year one: get the procedure an OPS code, get it into routine hospital cost accounting through the calculation hospitals, and lobby the Selbstverwaltung. A method typically transitions NUB to ZE to fully-absorbed-in-DRG over about three to six years. For HLA typing specifically, transplant-related immunogenetics costs in Germany are largely absorbed into the transplant DRG and into separately negotiated Transplantationspauschalen, which materially reduces the willingness of a centre to pay incremental amounts for higher-resolution typing unless it changes allocation or outcome.",
  "submissionWindow": "The catalogue is renegotiated annually; changes take effect 1 January. InEK data delivery from calculation hospitals is due 31 March for the preceding year.",
  "difficulty": "high",
  "evidence": "Cost data rather than clinical evidence. InEK creates ZE where cost heterogeneity within a DRG is demonstrably large. You need the test to be visible and costed in calculation-hospital accounting.",
  "precedent": "Not verified for HLA typing. HSCT-related HLA typing is generally paid inside the allogeneic transplant DRG and via donor search cost reimbursement, which in Germany runs through a separate donor-search cost framework rather than the DRG.",
  "priceLow": 200,
  "priceHigh": 800,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "deu-ebm-einheitlicher-bewertungsmassst",
  "iso3": "DEU",
  "assayClass": "poc_biomarker",
  "routeName": "EBM (Einheitlicher Bewertungsmassstab) outpatient catalogue, gated by G-BA method assessment under section 135(1) SGB V",
  "routeType": "fee_schedule",
  "decisionBody": "Gemeinsamer Bundesausschuss (G-BA) for the method decision, then the Bewertungsausschuss (KBV plus GKV-Spitzenverband) for the EBM code and its point value",
  "howItWorks": "German statutory outpatient care operates a prohibition-with-permission-reservation (Erlaubnisvorbehalt): a new examination or treatment method may not be billed to the statutory funds until the G-BA has issued a positive decision under section 135(1) SGB V. Applications to the G-BA can be filed by the GKV-Spitzenverband, the KBV, a Kassenarztliche Vereinigung, or a patient organisation - NOT by a manufacturer, so you must recruit a sponsor. The G-BA's Unterausschuss Methodenbewertung runs a structured evidence appraisal, usually commissioning IQWiG, and the statutory clock is long (commonly two to three years, with a nominal three-year target). If the evidence is promising but insufficient the G-BA may instead issue an Erprobungsrichtlinie under section 137e SGB V, in which the manufacturer that benefits is normally required to co-fund the trial. Once the G-BA says yes, the Bewertungsausschuss must set an EBM position and its point value within six months; the EBM point value (Orientierungswert) is set nationally each year and multiplied by the point count to give the euro fee. There is also a parallel section 137h route for high-risk devices used in hospitals with NUB status.",
  "submissionWindow": "Rolling, but only via an entitled applicant. G-BA agenda-setting is effectively annual.",
  "difficulty": "very_high",
  "evidence": "The highest evidence bar in Germany. G-BA and IQWiG expect randomised evidence of patient-relevant benefit (mortality, morbidity, quality of life), not just diagnostic accuracy. A dd-cfDNA test would be expected to show that acting on the result changes graft outcomes, not merely that it detects rejection. This is why almost no novel diagnostic gets in via this route quickly.",
  "precedent": "No transplant molecular surveillance assay was found in the EBM. The general pattern in German outpatient diagnostics is that novel molecular tests take years to enter the EBM and are sold privately (GOA/IGeL) in the meantime.",
  "priceLow": 40,
  "priceHigh": 300,
  "currency": "EUR",
  "codes": [
   {
    "code": "EBM Kapitel 32",
    "desc": "Laboratory chapter of the EBM. Subsection 32.1 covers Grundleistungen and the Wirtschaftlichkeitsbonus mechanics; 32.3 covers spezielle Laboratoriumsuntersuchun",
    "price": null,
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "deu-ebm-laboratory-budget-and-wirtscha",
  "iso3": "DEU",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "EBM laboratory budget and Wirtschaftlichkeitsbonus - the practical barrier to outpatient lab testing",
  "routeType": "fee_schedule",
  "decisionBody": "Bewertungsausschuss / Kassenarztliche Bundesvereinigung (KBV) and the regional KVen",
  "howItWorks": "This deserves to be treated as its own pathway because it is the reason German nephrologists do not order expensive outpatient laboratory tests even when a code exists. Under EBM section 32.1 each practice has a specialty-specific laboratory case value (Laborfallwert) with a lower and an upper Grenzfallwert. If the practice's average laboratory spend per case stays under the lower value it receives the full Wirtschaftlichkeitsbonus; between the two values the bonus is tapered; above the upper value the bonus is lost. The bonus is real practice income, so ordering one expensive molecular test can cost the practice more in lost bonus than the test is worth to it. The escape valve is the Ausnahmekennziffern (exception codes) listed in the EBM, which take defined indications out of the budget calculation - but not all laboratory services are exempted even when an exception code applies. For a transplant surveillance assay the commercial implication is blunt: unless the test is billed by a transplant-centre outpatient clinic under a section 116b ASV (ambulante spezialfachartzliche Versorgung) contract or an Ausnahmekennziffer applies, the ordering nephrologist is personally financially penalised for using it. ASV is therefore the smarter German outpatient target than general nephrology practice.",
  "submissionWindow": "Ausnahmekennziffern are amended by the Bewertungsausschuss, normally with quarterly EBM updates.",
  "difficulty": "very_high",
  "evidence": "Political and economic rather than clinical: you are arguing that this indication should be budget-exempt.",
  "precedent": "Well documented as a general barrier to outpatient molecular diagnostics in Germany.",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "EUR",
  "codes": [
   {
    "code": "32006",
    "desc": "Ausnahmekennziffer - notifiable diseases and cystic fibrosis; example of an exception number taking laboratory spend out of the budget calculation.",
    "price": null,
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "deu-goa-gebuhrenordnung-fur-arzte-priv",
  "iso3": "DEU",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "GOA (Gebuhrenordnung fur Arzte) private schedule and self-pay",
  "routeType": "private_pay",
  "decisionBody": "Federal Ministry of Health (the GOA is a federal ordinance); in practice the private insurers (PKV) and Beihilfe decide what they actually pay",
  "howItWorks": "The GOA is the fee schedule for privately insured patients and for self-pay. Roughly 10-11 percent of the German population holds substitutive private cover, and civil servants additionally have Beihilfe. The GOA fee catalogue has not been substantively revised since 1996, so it contains no code for any modern molecular test. The workaround is section 6(2) GOA analogous billing (Analogbewertung): the physician bills the new service by analogy to an existing GOA position of comparable time, cost and difficulty, documenting the analogy on the invoice. Multipliers (Steigerungsfaktor, commonly 1.15x to 2.3x, up to 3.5x with justification) apply. Because there is no gatekeeper, this is by far the fastest route to first German revenue for a novel transplant assay: you can be billing within weeks. The risk is that individual PKV insurers refuse the analogy and the patient is left with the bill, so a documented analogy recommendation and a clear patient consent process matter. Pure self-pay (IGeL) is also lawful and needs no code at all.",
  "submissionWindow": "None. No application, no window. Available immediately.",
  "difficulty": "low",
  "evidence": "None formally. Medical necessity must be defensible to the private insurer if challenged.",
  "precedent": "This is the standard German launch route for unlisted molecular diagnostics, including oncology liquid biopsy. Strongly recommended as the Scira day-one German route while a NUB campaign runs in parallel.",
  "priceLow": 400,
  "priceHigh": 1500,
  "currency": "EUR",
  "codes": [
   {
    "code": "GOA Abschnitt M",
    "desc": "Laboratory chapter of the GOA. Molecular genetics positions M IV (e.g. 3920-3926 series) are the usual analogy anchors for modern molecular assays.",
    "price": null,
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "nld-dbc-dot-zorgproduct-structure-nza",
  "iso3": "NLD",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "DBC/DOT zorgproduct structure, NZa tariffs and the add-on facultatieve prestatie",
  "routeType": "fee_schedule",
  "decisionBody": "Nederlandse Zorgautoriteit (NZa) for the product and tariff structure; individual health insurers for the actual price",
  "howItWorks": "Dutch hospital care is billed as DBC zorgproducten. Clinicians record zorgactiviteiten (care activity codes); a national grouper algorithm rolls these into a DBC zorgproduct which is what is invoiced. Around 70 percent of hospital care sits in the free segment (segment B) where the price is negotiated bilaterally between the hospital and each health insurer, and about 30 percent sits in the regulated segment where NZa sets a maximum tariff. The crucial structural point for a diagnostics vendor is that laboratory diagnostics are normally BUNDLED INSIDE the DBC and generate no separate hospital income - the hospital pays for your test out of a fixed DBC price. To get separately paid you need either (a) a new zorgactiviteit code plus inclusion in the grouper, requested from NZa, or (b) an add-on facultatieve prestatie, which since 2023 can be requested but requires a JOINT application from a healthcare provider and a health insurer together - meaning you cannot proceed without an insurer sponsor. NZa also runs the Beleidsregel innovatie voor kleinschalige experimenten, a time-limited (maximum three years) innovation tariff for small-scale experiments, again requiring provider plus insurer agreement. DBC package updates (dbc-pakket) are issued annually.",
  "submissionWindow": "Annual DBC package cycle; requests for new zorgactiviteiten and add-ons follow the NZa release calendar with proposals generally needed roughly a year ahead of the effective date.",
  "difficulty": "high",
  "evidence": "NZa itself assesses whether a distinct payment product is warranted, not clinical benefit. Clinical benefit is Zorginstituut's territory (see separate pathway).",
  "precedent": "Not verified for any transplant molecular surveillance assay. Dutch transplant centres have historically run novel assays out of academic budgets (UMC research funding) before seeking a payment product.",
  "priceLow": 300,
  "priceHigh": 900,
  "currency": "EUR",
  "codes": [
   {
    "code": "dbc-pakket 2026",
    "desc": "Annual NZa DBC package defining zorgproducten and the associated zorgactiviteiten and add-ons for medical specialist care.",
    "price": null,
    "currency": "EUR"
   },
   {
    "code": "Beleidsregel prestaties en tarieven medisch-specialistische zorg 2026",
    "desc": "NZa policy rule setting the performance and tariff framework for medical specialist care, including add-on structures.",
    "price": null,
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "nld-zorginstituut-nederland-appraisal",
  "iso3": "NLD",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Zorginstituut Nederland appraisal - stand van de wetenschap en praktijk, and the conditional coverage routes",
  "routeType": "hta_appraisal",
  "decisionBody": "Zorginstituut Nederland (ZIN), advised by the Wetenschappelijke Adviesraad and the Adviescommissie Pakket",
  "howItWorks": "The Dutch basic package (basispakket) is an OPEN system: care is insured by operation of law if it meets the statutory criterion of stand van de wetenschap en praktijk (established medical science and practice, Besluit zorgverzekering art 2.1). There is therefore no positive listing step for most diagnostics - but there is also no certainty, because an insurer can simply refuse to pay on the grounds that the criterion is not met. Where there is doubt, ZIN issues a standpunt (position statement) after an evidence review, and that standpunt then binds insurers. Where a technology is promising but the evidence is not yet adequate, the historical route was voorwaardelijke toelating (conditional admission) under art 2.2 Bzv, which admitted the technology to the package for a defined period, typically four years, on condition that agreed outcomes research was carried out; entry required a joint dossier from the professional association, patient association, insurers and the manufacturer, with a ZIN-approved research protocol. Voorwaardelijke toelating has been largely superseded for new entrants by the Veelbelovende zorg (Promising Care) subsidy scheme, jointly run by ZIN and ZonMw, which funds the comparative study and pays for the care of trial participants rather than admitting the technology to the package. The practical Dutch play is therefore: get the Nederlandse Transplantatie",
  "submissionWindow": "Veelbelovende zorg has defined annual application rounds run by ZonMw. ZIN standpunt requests are rolling.",
  "difficulty": "high",
  "evidence": "High and explicitly comparative. ZIN expects controlled evidence that the technology improves patient-relevant outcomes over current practice, and Veelbelovende zorg exists precisely to generate an RCT.",
  "precedent": "Not verified for transplant diagnostics. Veelbelovende zorg has funded a range of device and procedure evaluations.",
  "priceLow": 300,
  "priceHigh": 900,
  "currency": "EUR",
  "codes": [
   {
    "code": "Overzicht zorgactiviteiten met aanspraakcode Zvw (2 January 2026)",
    "desc": "ZIN's list of care activities carrying a claim code, i.e. those whose package status is conditional or restricted.",
    "price": null,
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "bel-inami-riziv-nomenclature-for-clini",
  "iso3": "BEL",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "INAMI/RIZIV nomenclature for clinical biology (articles 24 and 33) and the convention route with pseudo-nomenclature codes",
  "routeType": "fee_schedule",
  "decisionBody": "INAMI/RIZIV - Technische Geneeskundige Raad / Conseil technique medical, the Commission for Clinical Biology, and the Comite de l'assurance; Minister of Social Affairs signs the Royal Decree",
  "howItWorks": "Belgian laboratory tests are paid through the nomenclature, a coded list in Royal Decree form. Article 24 covers routine clinical biology, article 33 covers human genetics and molecular biology (with article 33bis/33ter for specific genetic and molecular acts). A request to create or amend a code goes to the relevant technical council, is costed by INAMI, must clear the budget, and is then enacted by Royal Decree - a slow, political process that can run several years. Two structural features matter enormously. First, inpatient clinical biology in Belgium is paid substantially by a per-admission lump sum (forfait) rather than fee-for-service, and the overall clinical biology budget is capped with clawback (a global budget objective), so a hospital laboratory gains nothing by doing a new expensive test unless it is separately funded. Second, and this is the realistic route for a novel molecular assay, INAMI can bypass the nomenclature via a CONVENTION under the article 22/56 mechanism of the coordinated law of 14 July 1994: a time-limited contract between INAMI and a defined set of approved laboratories, funded through pseudo-nomenclature codes with negotiated tariffs and mandatory data collection. This is exactly how NGS in oncology and haemato-oncology was handled: a pilot convention from 2019 which was converted to permanent reimbursement on 1 July 2024 with 51 new pseudo-nome",
  "submissionWindow": "Rolling in principle; in practice governed by INAMI's annual budget cycle (the budgetary objective is set in the autumn for the following year). Convention negotiations open when INAMI decides to open them.",
  "difficulty": "high",
  "evidence": "For nomenclature: clinical utility plus budget impact, assessed by the technical council. For conventions: enough evidence to justify a controlled pilot, plus a willingness to generate registry data during the convention period. KCE (Belgian Health Care Knowledge Centre) reports frequently frame the debate and a favourable KCE report is a strong asset, though KCE does not itself decide.",
  "precedent": "The NGS oncology convention is the direct and highly relevant precedent for how Belgium funds a new molecular test class: pilot convention, restricted laboratory network, data collection, then permanent pseudocodes. No transplant-specific equivalent was found.",
  "priceLow": 250,
  "priceHigh": 700,
  "currency": "EUR",
  "codes": [
   {
    "code": "NGS oncology convention pseudocodes (from 1 July 2024)",
    "desc": "51 pseudo-nomenclature codes with tariffs introduced when the NGS oncology/haemato-oncology convention became permanent reimbursement, restricted to approved NG",
    "price": null,
    "currency": "EUR"
   },
   {
    "code": "Article 33 nomenclature (human genetics)",
    "desc": "Generic genetic-testing nomenclature used by the eight approved Belgian centres for human genetics; historically the funding vehicle for molecular testing outsi",
    "price": null,
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "che-analysenliste-al-the-single-route",
  "iso3": "CHE",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Analysenliste (AL) - the single route for a laboratory test in Switzerland",
  "routeType": "fee_schedule",
  "decisionBody": "Bundesamt fur Gesundheit (BAG/FOPH) secretariat, Eidgenossische Kommission fur Analysen, Mittel und Gegenstande (EAMGK/CFAMA), final decision by the Eidgenossisches Departement des Innern (EDI)",
  "howItWorks": "Switzerland has an unusually clean answer for a diagnostics company: essentially every laboratory analysis reimbursed by compulsory health insurance (OKP/AOS) is listed by name in the Analysenliste, Annex 3 to the KLV/OPAS ordinance, with a fixed national tariff expressed in tax points. If your test is not on the AL it is not covered, full stop; conversely once it is on the AL every insurer must pay the listed price. To get listed you submit a written application to the BAG secretariat (by email or post) using the BAG application forms. The responsible BAG section checks the dossier for completeness, requests missing material and prepares a standardised summary for the EAMGK. The EAMGK, a federal advisory commission of laboratory, clinical, insurer and patient representatives, assesses the dossier against the WZW criteria - Wirksamkeit (effectiveness), Zweckmassigkeit (appropriateness) and Wirtschaftlichkeit (economy/cost-effectiveness) - and issues a positive or negative recommendation. The EDI takes the final decision and amends the ordinance. Applicants can be manufacturers, laboratories or professional societies, which is a real advantage over Germany where manufacturers cannot apply to the G-BA. The AL is updated at defined points in the year (historically 1 January and 1 July) and BAG additionally runs a periodic re-evaluation programme (Monitoring der Analysenliste) that",
  "submissionWindow": "Rolling submission to the BAG secretariat, but decisions are batched to the AL revision dates; EAMGK meets a few times a year.",
  "difficulty": "medium",
  "evidence": "WZW. In practice EAMGK wants published peer-reviewed evidence of analytical and clinical validity, a clear clinical utility argument showing how the result changes management, and a cost-effectiveness or at minimum budget-impact case against the existing pathway (for transplant surveillance that means versus protocol biopsy and creatinine monitoring).",
  "precedent": "No AL position for a transplant dd-cfDNA assay was verified. Switzerland's Analysenliste has however absorbed complex NGS-based positions, so there is a template.",
  "priceLow": 500,
  "priceHigh": 1400,
  "currency": "CHF",
  "codes": [
   {
    "code": "Analysenliste (Anhang 3 KLV)",
    "desc": "Complete positive list of reimbursed laboratory analyses with national tariffs. Chapters cover genetics and molecular biology.",
    "price": null,
    "currency": "CHF"
   }
  ]
 },
 {
  "id": "nor-nye-metoder-the-mandatory-national",
  "iso3": "NOR",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Nye Metoder - the mandatory national HTA gate for the specialist health service",
  "routeType": "hta_appraisal",
  "decisionBody": "Bestillerforum for nye metoder (commissioning), Folkehelseinstituttet/DMP (assessment), Beslutningsforum for nye metoder (decision, the four regional health authority CEOs)",
  "howItWorks": "Norway is the strictest gate in the region and diagnostics companies routinely underestimate it. Nye Metoder is a mandatory national system: a new method may not be introduced into the specialist health service (which owns all Norwegian transplant care) until it has been through the process. A proposal (forslag) can come from a clinician, a regional health authority, the national horizon scanning function or the supplier itself; it goes to Bestillerforum, made up of the medical directors of the four regional health authorities plus two Directorate of Health representatives, which decides what kind of assessment to commission - a full HTA (metodevurdering), a simplified assessment, or nothing. The assessment is carried out by the Norwegian Institute of Public Health or the Norwegian Medical Products Agency (DMP). The decision is then taken by Beslutningsforum, the four RHA chief executives, who decide yes or no for the whole country. A revised process specifically for medical devices, in vitro diagnostics and AI-based devices entered into force on 1 May 2026, defining three entry pathways into the framework including a manufacturer request route. Crucially, everything in Norway is bought out of RHA block budgets; a Beslutningsforum yes creates the permission and the expectation to fund, but the money still comes out of the health trust's own budget, so a strong budget-impact cas",
  "submissionWindow": "Rolling proposals; Bestillerforum meets roughly monthly and Beslutningsforum roughly monthly.",
  "difficulty": "very_high",
  "evidence": "Full HTA standard: systematic review of clinical effectiveness plus a health-economic model with Norwegian costs. For diagnostics, Nye Metoder has published specific guidance criteria for handling medical devices, and the evidence expectation is linkage from test result to changed management to changed patient outcome.",
  "precedent": "Nye Metoder has assessed diagnostic tests (e.g. preeclampsia biomarker tests) via project plans and full HTAs. No transplant molecular surveillance assessment was verified.",
  "priceLow": 500,
  "priceHigh": 1200,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "swe-regional-block-funding-with-nation",
  "iso3": "SWE",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Regional block funding with national advice from TLV, MTP-radet and NT-radet; procurement under LOU",
  "routeType": "block_contract",
  "decisionBody": "The 21 regions (regioner) as payers and purchasers; TLV as the national HTA/pricing agency; MTP-radet (Medicintekniska produktradet) for medical technology and NT-radet (Nya terapier) for new therapies, both under SKR",
  "howItWorks": "There is no national reimbursement list for in vitro diagnostics in Sweden. Laboratory testing is funded from the hospital laboratory's global budget, which comes from the region. That means the sale is not a reimbursement application at all, it is (a) a clinical decision by the transplant unit, (b) a budget decision by the region or the laboratory division, and (c) a public procurement under the Lagen om offentlig upphandling (LOU), usually as a framework agreement (ramavtal) with a defined term, often four years, tendered by the region or by a joint regional purchasing body. TLV performs health economic assessments of medical devices on a selected basis and its reports carry weight but are advisory for devices. The national horizon-scanning and joint-decision machinery is split: NT-radet covers new pharmaceutical therapies and MTP-radet covers medical technology products, both issuing national recommendations to the regions on behalf of SKR (Sveriges Kommuner och Regioner). A national MTP-radet recommendation is the closest Sweden gets to a national yes. Sweden also runs Ordnat inforande (managed introduction) processes regionally. Practically: win the clinician, get a TLV or MTP-radet health economic assessment as air cover, then be ready for the tender.",
  "submissionWindow": "Tender-driven and therefore unpredictable. Watch the regions' procurement portals; framework agreements typically run 2-4 years with options.",
  "difficulty": "high",
  "evidence": "Health economics against Swedish standard care, plus the clinical evidence the transplant unit personally finds convincing. Swedish transplant nephrology is small, academically strong and consensus-driven; the opinion of Karolinska, Sahlgrenska and Uppsala effectively is the national decision.",
  "precedent": "No verified Swedish funding of a transplant dd-cfDNA assay.",
  "priceLow": 400,
  "priceHigh": 1000,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "dnk-behandlingsradet-danish-health-tec",
  "iso3": "DNK",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Behandlingsradet (Danish Health Technology Council) evaluation, then regional budget decision",
  "routeType": "hta_appraisal",
  "decisionBody": "Behandlingsradet (established 2021 under Danske Regioner); the five regions implement",
  "howItWorks": "Denmark has no national fee schedule route for a hospital laboratory test; the Danish DRG (takstsystem, maintained by Sundhedsdatastyrelsen) is used for inter-regional settlement and activity monitoring, not for paying for individual diagnostics. The national assessment body is Behandlingsradet, which produces two output types. Major analyses (2-3 per year) are on fundamental topics and can only be proposed by hospitals or regions, not industry. Evaluations (up to 15-25 per year) cover marketed medical devices and health technologies and CAN be proposed by any stakeholder including industry - this is the industry door. A proposal is submitted, screened, prioritised, then assessed against clinical effect and cost; the output is a recommendation to the regions. The recommendations are formally non-binding but are in practice followed and drive regional funding decisions. Because Denmark has only two adult kidney transplant programmes (Rigshospitalet and Aarhus) plus Odense, a Behandlingsradet evaluation is disproportionately powerful: one national recommendation effectively decides the whole market. Conversely a negative evaluation closes the market nationally, so the timing of a submission matters a great deal.",
  "submissionWindow": "Proposal rounds run by Behandlingsradet; check the current call schedule before submitting.",
  "difficulty": "high",
  "evidence": "Clinical effect documented to a defined standard plus a Danish cost analysis. Behandlingsradet has published updated evaluation methods and process documents; industry applicants are expected to supply a structured dossier.",
  "precedent": "Behandlingsradet has issued recommendations on a range of devices and technologies since 2021. No transplant diagnostic recommendation was verified.",
  "priceLow": 400,
  "priceHigh": 1000,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "fin-wellbeing-services-county-hyvinvoi",
  "iso3": "FIN",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Wellbeing services county (hyvinvointialue) budget, HUS as de facto national purchaser; Palko service selection",
  "routeType": "block_contract",
  "decisionBody": "HUS Helsinki University Hospital (the sole Finnish solid organ transplant centre) and its wellbeing services county funding; Palveluvalikoimaneuvosto (Palko, Council for Choices in Health Care in Finland) for national service-range recommendations; FinCCHTA for HTA",
  "howItWorks": "Finland is the simplest market in the region because ALL Finnish solid organ transplantation is performed at HUS in Helsinki. The purchase decision is therefore a single institutional decision funded from the wellbeing services counties' (hyvinvointialueet, in place since 1 January 2023) budgets, with transplantation centrally funded as a highly centralised service. Nationally, Palko issues recommendations on what belongs in the publicly funded service range; a Palko recommendation is advisory but influential, and FinCCHTA (Finnish Coordinating Centre for Health Technology Assessment, based at Oulu University Hospital) produces the underlying assessments including rapid HTAs. Public procurement rules apply to the laboratory contract, and HUSLAB (HUS Diagnostic Center) is the counterparty for laboratory services. One centre, one laboratory, one decision.",
  "submissionWindow": "Rolling, procurement-driven.",
  "difficulty": "medium",
  "evidence": "Clinical evidence adequate to convince the HUS transplant nephrology and HUSLAB leadership, plus a budget-impact case. A FinCCHTA rapid assessment can be requested.",
  "precedent": "Not verified.",
  "priceLow": 400,
  "priceHigh": 900,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "pol-guaranteed-benefits-basket-koszyk",
  "iso3": "POL",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Guaranteed benefits basket (koszyk swiadczen gwarantowanych) via AOTMiT, financed by NFZ under JGP",
  "routeType": "hta_appraisal",
  "decisionBody": "Agencja Oceny Technologii Medycznych i Taryfikacji (AOTMiT) recommends; the Minister of Health decides by regulation; Narodowy Fundusz Zdrowia (NFZ) contracts and pays",
  "howItWorks": "Poland runs a closed positive list: a health service is publicly financed only if it is a guaranteed benefit (swiadczenie gwarantowane) listed in a Ministry of Health regulation, and NFZ will only pay for a recognised billable act. To add a new non-drug technology, a request is made to the Minister of Health, who commissions AOTMiT to appraise it. AOTMiT runs an HTA (clinical effectiveness, safety, economic analysis, budget impact against Polish practice), its Transparency Council (Rada Przejrzystosci) issues an opinion, the President of AOTMiT issues a recommendation, and the Minister then amends the regulation. AOTMiT separately performs tariff-setting (taryfikacja) - it values the service, and the tariff is approved by the Minister and applied by NFZ. Hospital care is paid under JGP (Jednorodne Grupy Pacjentow, the Polish DRG). Transplantation in Poland sits in a special position: procurement, organ preservation, tissue typing and part of the transplant pathway are funded through the Ministry of Health's National Transplantation Programme (Narodowy Program Rozwoju Medycyny Transplantacyjnej) and coordinated by Poltransplant, rather than purely by NFZ - which means Poltransplant and the Ministry, not NFZ, are the right first door for a transplant-specific test. Poland is also the most credible place in this region to run a large, cheap, high-quality clinical validation study.",
  "submissionWindow": "Rolling requests to the Ministry of Health; AOTMiT appraisals are commissioned as they arrive.",
  "difficulty": "high",
  "evidence": "Full HTA dossier in Polish following AOTMiT's published guidelines: systematic review, economic analysis, budget impact analysis, all referenced to Polish comparators and Polish costs. This is a substantial and formal document, and it is usually outsourced to a Polish HTA agency.",
  "precedent": "Not verified for transplant diagnostics. AOTMiT has appraised companion diagnostics as part of drug programme submissions.",
  "priceLow": 150,
  "priceHigh": 450,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "tur-sgk-sut-saglik-uygulama-tebligi-re",
  "iso3": "TUR",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "SGK SUT (Saglik Uygulama Tebligi) reimbursement list, plus the large private and health-tourism self-pay channel",
  "routeType": "fee_schedule",
  "decisionBody": "Sosyal Guvenlik Kurumu (SGK); TITCK (Turkish Medicines and Medical Devices Agency) for product registration and UTS product tracking",
  "howItWorks": "Turkey has a single dominant public payer, SGK, covering the great majority of the population. After the device or IVD is registered with TITCK and entered in the UTS (Urun Takip Sistemi) product tracking system, the product or service must be listed on the SUT (Health Implementation Communique) annexes to be publicly reimbursed - laboratory tests sit in the EK-2/B and related annexes with fixed Turkish lira prices. An application is made to SGK with clinical and economic documentation; SGK's commissions review and the SUT is amended by published communique, updated irregularly through the year. Two things dominate the commercial reality. First, SUT prices are set in lira and are very low by European standards and have been badly eroded by inflation, so a premium imported molecular assay is effectively unfundable at SUT rates. Second, Turkey has an exceptionally large living-donor kidney transplant programme (living donors account for the large majority of Turkish kidney transplants) concentrated in a modest number of very high-volume centres, and a substantial private hospital and international health-tourism sector that pays cash outside SUT. The practical strategy is therefore inverted relative to western Europe: sell first into the private and health-tourism centres at international prices, build Turkish clinical data at very low cost through the enormous living-donor cohor",
  "submissionWindow": "Rolling application to SGK; SUT amendments published in the Resmi Gazete at irregular intervals through the year.",
  "difficulty": "very_high",
  "evidence": "Clinical documentation plus a cost case in lira. SGK is heavily budget-driven and strongly favours domestic production (localisation policy).",
  "precedent": "Not verified for transplant molecular surveillance. Turkish transplant centres have published extensively using research-funded assays.",
  "priceLow": 60,
  "priceHigh": 250,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "aut-lkf-leistungsorientierte-krankenan",
  "iso3": "AUT",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "LKF (Leistungsorientierte Krankenanstaltenfinanzierung) hospital points system and the MEL catalogue",
  "routeType": "drg_addon",
  "decisionBody": "Bundesministerium fur Soziales, Gesundheit, Pflege und Konsumentenschutz (BMSGPK) maintains the LKF model and the Leistungskatalog; the nine Landesgesundheitsfonds distribute the money; AIHTA (Austrian Institute for Health Technology Assessment) provides assessments",
  "howItWorks": "Austrian inpatient care is financed through the LKF system, in which each defined medical single service (Medizinische Einzelleistung, MEL) or diagnosis group earns points (LKF-Punkte) that are converted to euros at a point value set by each Land's health fund. New services are added to the Leistungskatalog through an annual revision run by the Ministry, informed by AIHTA assessments; hospitals and professional societies propose. Laboratory diagnostics are largely absorbed into the LKF case payment rather than earning separate points, which mirrors the German and Dutch problem. Outpatient laboratory work for the social insurance (OGK) is paid under the Honorarordnung/Gesamtvertrag between the OGK and the medical chamber, again a negotiated catalogue. Austria is small (four university transplant centres, Vienna dominant) and Vienna's decision effectively is the Austrian decision.",
  "submissionWindow": "Annual LKF model revision effective 1 January.",
  "difficulty": "high",
  "evidence": "AIHTA assessment standard for significant new technologies; cost data for LKF point derivation.",
  "precedent": "Not verified.",
  "priceLow": 400,
  "priceHigh": 1000,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "prt-sns-hospital-contract-programme-fu",
  "iso3": "PRT",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "SNS hospital contract-programme funding, INFARMED HTA for technologies, Portaria tabela de precos",
  "routeType": "hta_appraisal",
  "decisionBody": "INFARMED (SiNATS - National System for Health Technology Assessment); ACSS (Administracao Central do Sistema de Saude) sets the SNS price table and hospital contract-programmes; Ministry of Health",
  "howItWorks": "Portugal's SNS hospitals are funded by contract-programme (contrato-programa) with ACSS, with production paid against a national price table (tabela de precos do SNS, issued by Portaria) using GDH (Portuguese DRG) for inpatient episodes and a schedule of acts for outpatient and diagnostics. Since the 2015 creation of SiNATS, INFARMED has the legal mandate to assess health technologies including medical devices and can make funding conditional on evidence. For a novel laboratory test the realistic route is: get the test written into the relevant clinical pathway by the transplant centres, then have the act added to the SNS price table, which requires Ministry/ACSS action. Portugal has three transplanting regions centred on Lisbon, Porto and Coimbra, with a strong national coordination body (IPST - Instituto Portugues do Sangue e da Transplantacao) that runs the histocompatibility laboratories. IPST is the key national account for anything HLA-related in Portugal, because it operates the national tissue-typing service.",
  "submissionWindow": "Price table updated by Portaria irregularly; INFARMED submissions rolling.",
  "difficulty": "high",
  "evidence": "SiNATS dossier: clinical effectiveness, economic evaluation, budget impact.",
  "precedent": "Not verified.",
  "priceLow": 200,
  "priceHigh": 500,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "cze-seznam-vykonu-list-of-reimbursed-m",
  "iso3": "CZE",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Seznam vykonu (list of reimbursed medical procedures) and health insurance fund contracts",
  "routeType": "fee_schedule",
  "decisionBody": "Ministerstvo zdravotnictvi CR (Ministry of Health) maintains the Seznam zdravotnich vykonu by decree; the Pracovni skupina k Seznamu zdravotnich vykonu reviews applications; VZP and the other insurance funds contract and pay",
  "howItWorks": "Czech statutory health insurance pays hospitals and laboratories according to the Seznam zdravotnich vykonu s bodovymi hodnotami - a national list of procedures each carrying a point value, updated by ministerial decree (vyhlaska) annually. A new laboratory procedure code is applied for through the professional society (odborna spolecnost), which submits a costed application to the Ministry's working group; the working group reviews, the Ministry issues the amending decree, and the point value is converted to koruna by the annual reimbursement decree (uhradova vyhlaska) negotiated with the insurance funds. Almost all Czech transplantation is concentrated at IKEM in Prague, which is Europe's largest single-site transplant institute by some measures, so as in Finland the institutional decision matters more than the code.",
  "submissionWindow": "Annual decree cycle; applications go through the professional society, typically needing to be in during the first half of the year for the following year.",
  "difficulty": "high",
  "evidence": "Costed application plus professional society backing. Lower formal evidence bar than western Europe but you cannot apply yourself - you need the Czech nephrology or immunogenetics society to carry it.",
  "precedent": "Not verified.",
  "priceLow": 120,
  "priceHigh": 400,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "eur-eu-ivdr-regulation-eu-2017-746-con",
  "iso3": "EUR",
  "assayClass": "hla_typing",
  "routeName": "EU IVDR (Regulation (EU) 2017/746) conformity and the LDT carve-out under Article 5(5)",
  "routeType": "innovation_list",
  "decisionBody": "European Commission, national competent authorities, notified bodies; Medical Device Coordination Group (MDCG) guidance",
  "howItWorks": "Not a payment route, but the gate that stands in front of every payment route in twelve of these thirteen countries (Switzerland and Turkey have their own but IVDR-aligned regimes; Switzerland applies IvDO, Turkey applies TITCK regulations mirroring the EU). IVDR became applicable on 26 May 2022 and replaced the old IVDD self-certification regime with risk classes A to D, requiring notified body involvement for classes B, C and D. Transplant-relevant assays sit high: HLA typing and other tests used for tissue and organ compatibility fall in the highest-risk band, and dd-cfDNA rejection surveillance would typically be class C. Amending Regulation (EU) 2022/112 introduced staggered transition deadlines by class, and Regulation (EU) 2024/1860 extended these further, with the latest legacy-device deadlines running through the late 2020s; devices must additionally meet requirements on EUDAMED registration and, for manufacturers relying on extended transition periods, on notified body applications lodged by defined dates. Article 5(5) provides the health institution exemption (the laboratory-developed test carve-out) allowing an EU health institution to manufacture and use a device in-house without CE marking, but only if there is no equivalent CE-marked device on the market meeting the same performance, the institution meets an appropriate quality management standard, and it publicl",
  "submissionWindow": "Rolling notified body applications; transition deadlines are fixed in the amending regulations.",
  "difficulty": "high",
  "evidence": "Performance evaluation report covering scientific validity, analytical performance and clinical performance; for class C and D, notified body review of the technical documentation; class D additionally requires EU reference laboratory involvement and batch verification.",
  "precedent": "IVDR notified body capacity remains the sector-wide bottleneck and is the reason the transition deadlines have been extended twice.",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "esp-inclusion-in-the-cartera-comun-de",
  "iso3": "ESP",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Inclusion in the cartera comun de servicios del SNS (national benefit package)",
  "routeType": "hta_appraisal",
  "decisionBody": "Comision de Prestaciones, Aseguramiento y Financiacion / Consejo Interterritorial del SNS, on a RedETS evidence report",
  "howItWorks": "Step 1: the technique must be evaluated by RedETS. RedETS assessment of a new non-pharmacological technique or procedure is legally mandatory and must happen BEFORE the technique is used in the SNS (Real Decreto 1030/2006, art. 5-7 and the RedETS mandate). You normally cannot commission this yourself: topics reach RedETS either through the annual horizon-scanning list (Plan de Deteccion de Tecnologias Sanitarias Nuevas y Emergentes, TSNE), or by nomination from the Ministry, an autonomous community or a scientific society into the annual RedETS work plan, which is ratified each year by the Consejo Interterritorial. Practical action: get the assay onto the TSNE list first, and simultaneously get a region (its coordinador autonomico or its HTA agency) or the SET/S.E.N. to nominate it. Step 2: the proposal to include a new technique in the cartera comun must be accompanied by a memoria tecnica setting out the evaluation results and the bioethical and social implications, and a memoria economica quantifying budget impact. If budget impact is material, it goes additionally to the interministerial commission for matters with budgetary significance. Step 3: the Comision de Prestaciones, Aseguramiento y Financiacion (CPAF), where the Ministry and all 17 regions sit, must reach consensus. Step 4: the Consejo Interterritorial del SNS (CISNS) plenary approves. Step 5: publication as a Min",
  "submissionWindow": "Effectively annual. The RedETS work plan and the TSNE horizon-scanning list are both published annually; cartera updates are then published as Ministerial Orders at irregular intervals with a formal public consultation (audiencia e informacion publica) window of roughly 15 working days on each draft order.",
  "difficulty": "very_high",
  "evidence": "RedETS applies full HTA: systematic review of clinical effectiveness and safety, plus economic evaluation and budget impact. For a surveillance assay it will ask specifically for evidence of change in clinical management and patient-relevant outcomes (graft survival, avoided biopsies, avoided rejection), not analytical performance alone. Spanish-population data or Spanish centres in the evidence base materially improve the odds, because the regions on the CPAF discount foreign cost-effectiveness.",
  "precedent": "The closest and most useful precedent is the 2024-2025 update of the cartera comun (draft Ministerial Order taken to public consultation, consultation closing 10 March), which incorporated the fetal cell-free DNA test (test de ADN fetal libre circulante) as a SECOND-LINE prenatal screening test for trisomies 21, 18 and 13, plus a general update of the genetics section of the portfolio. That is a cfDNA assay entering the Spanish national package through exactly this route: RedETS report, then CPAF, then CISNS. No dd-cfDNA transplant surveillance assay (AlloSure, Prospera) has been through this ",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "esp-regional-cartera-complementaria-an",
  "iso3": "ESP",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Regional cartera complementaria and regional hospital budget (the route that actually pays)",
  "routeType": "block_contract",
  "decisionBody": "Regional health service (Servicio Andaluz de Salud, CatSalut, SERMAS, Osakidetza, SERGAS, Conselleria de Sanitat, etc.) advised by its own HTA agency",
  "howItWorks": "Article 71 of Ley 16/2003 lets each autonomous community add services to the national package as a cartera complementaria, funded entirely from its own budget. In practice the mechanism for a laboratory test is simpler than that: the hospital laboratory or immunology service builds a business case, the hospital's Comision de Farmacia/Tecnologias or equivalent new-technology committee reviews it, and the regional health service either raises the laboratory's budget line in the annual contrato-programa or authorises a specific tender. Where the region has its own HTA agency it will usually be asked for a rapid report first: AQuAS in Catalonia, AETSA in Andalusia, Osteba in the Basque Country, Avalia-t/ACIS in Galicia, UETS in Madrid, SESCS in the Canaries, IACS in Aragon. Those agencies are the same bodies that make up RedETS, so a good national RedETS report is directly reusable at regional level and vice versa - this is the single most important structural fact in Spanish market access. What to do on Monday: identify the hospital's clinical champion and the head of the laboratory that would run the test, ask which regional HTA agency their health service uses, and ask whether the test can be absorbed into the existing laboratory contract or needs its own expediente.",
  "submissionWindow": "Rolling, but budget-locked. Regional health budgets are annual and contratos-programa are negotiated in the autumn for the following year, so a new test that needs new money is realistically an October-to-December conversation for a January start.",
  "difficulty": "medium",
  "evidence": "Materially lower than the national route. A regional agency rapid report plus a local budget-impact model plus a credible clinical champion is often enough. Regions differ sharply in appetite: Catalonia and the Basque Country will fund ahead of national consensus; smaller regions will wait for the cartera comun.",
  "precedent": "Regional adoption of NGS oncology panels followed exactly this pattern (regional funding and regional reference-laboratory designation years before any national decision). No published regional funding decision for transplant dd-cfDNA in Spain was found.",
  "priceLow": 150,
  "priceHigh": 450,
  "currency": "EUR",
  "codes": [
   {
    "code": "n/a",
    "desc": "Andalusian precios publicos catalogue includes a Blood Transfusion Centre and Blood/Tissue Bank price section, which is where HLA and histocompatibility determi",
    "price": null,
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "esp-public-tender-for-laboratory-reage",
  "iso3": "ESP",
  "assayClass": "hla_typing",
  "routeName": "Public tender for laboratory reagents (contrato de suministros) under Ley 9/2017 de Contratos del Sector Publico",
  "routeType": "tender",
  "decisionBody": "Individual hospital or regional health service contracting authority (organo de contratacion)",
  "howItWorks": "This is the sales process in Spain, exactly as it is in Italy. Mechanics: (1) The contracting authority is usually the individual hospital's Direccion Gerencia, not the region, although several regions run central purchasing bodies and framework agreements (acuerdos marco) that hospitals then call off from. (2) Every tender is published on the Plataforma de Contratacion del Sector Publico (contrataciondelestado.es) and/or the regional platform (contratos-publicos.comunidad.madrid, contractaciopublica.gencat.cat, contratacion.euskadi.eus, contratacion.sergas.gal, etc.), and above the EU harmonised threshold also in TED. (3) The two governing documents are the PCAP (pliego de clausulas administrativas particulares, the commercial and legal terms) and the PPT (pliego de prescripciones tecnicas, the technical specification). The PPT is written by the laboratory that will use the product. Whoever helps write the PPT effectively writes the shortlist - this is the single most important commercial fact about Spanish diagnostics procurement. (4) Contracts are split into lots (lotes), one lot per assay family; you bid lot by lot. (5) Common procedures: procedimiento abierto for large contracts, procedimiento abierto simplificado for mid-size supplies, and contrato menor for very small direct purchases (LCSP art. 118 sets the contrato menor ceiling for supplies and services at EUR 15,000 ",
  "submissionWindow": "Rolling but individually dated. Simplified open procedures typically give 15 days from publication; full open procedures for SARA contracts give 30+ days. Contract terms are usually 12-48 months with optional prorrogas, so each account has a predictable re-tender clock. Track expiry dates, not tender dates.",
  "difficulty": "low",
  "evidence": "Regulatory only, plus whatever technical performance the PPT specifies. CE-IVD under IVDR is mandatory. There is no HTA gate on a reagent tender - which is why the tender route is the fastest way into a Spanish laboratory and why the national cartera route is a strategic rather than a tactical objective.",
  "precedent": "Thermo Fisher/One Lambda, Immucor/Werfen Lifecodes, Omixon and Illumina-based workflows all reach Spanish laboratories through this route. Hospital Clinic de Barcelona has historically tendered HLA reagents jointly for its own Immunology Service AND for the Banc de Sang i Teixits (BOE-B-2018-15059) - a single award covering a hospital and a regional blood bank, which is the largest single HLA prize in Catalonia. Hospital 12 de Octubre bundles HLA-transplant, monogenic disease and SNP reagents plus serological typing, crossmatch and cell culture material into ONE contract, so a single-assay ven",
  "priceLow": 60,
  "priceHigh": 180,
  "currency": "EUR",
  "codes": [
   {
    "code": "33696500-0",
    "desc": "Reactivos de laboratorio - the CPV under which HLA typing reagent contracts are advertised",
    "price": "EUR 131,904 ex-VAT / 24 months (Ramon y Cajal HLA NGS, expediente A/SUM-022401/2026)",
    "currency": "EUR"
   }
  ]
 },
 {
  "id": "esp-haematology-immunology-laboratory",
  "iso3": "ESP",
  "assayClass": "chimerism",
  "routeName": "Haematology / immunology laboratory reagent tender, usually inside a wider molecular biology lot",
  "routeType": "tender",
  "decisionBody": "Hospital contracting authority (Direccion Gerencia), technical specification written by the Servicio de Hematologia or Servicio de Inmunologia",
  "howItWorks": "Same LCSP mechanics as HLA typing, but chimerism rarely gets its own expediente. It is normally one lot inside a broader molecular biology or haemato-oncology reagents contract, or absorbed under an instrument reagent-rental agreement. Because allo-HSCT in Spain is concentrated in the GETH-TC network centres, the addressable list is short and the technical specification is written by a small number of haematology molecular laboratory heads. Route in: get chimerism specified as its own lot in the next re-tender at a GETH-TC centre, which requires the laboratory head to want it.",
  "submissionWindow": "Rolling, tied to each centre's molecular biology contract expiry.",
  "difficulty": "medium",
  "evidence": "CE-IVD plus demonstrated sensitivity against the incumbent STR or qPCR method; EQA participation expected.",
  "precedent": "Not established in this research pass. Marked as a gap.",
  "priceLow": null,
  "priceHigh": null,
  "currency": null,
  "codes": []
 },
 {
  "id": "esp-point-of-care-test-adoption-hospit",
  "iso3": "ESP",
  "assayClass": "poc_biomarker",
  "routeName": "Point-of-care test adoption: hospital new-technology committee plus regional HTA rapid report, then tender",
  "routeType": "hta_appraisal",
  "decisionBody": "Regional HTA agency (AQuAS, AETSA, Osteba, Avalia-t/ACIS, UETS, SESCS, IACS) and the hospital's technology committee",
  "howItWorks": "A urinary POC biomarker sits awkwardly in Spain because it crosses the boundary between the central laboratory (which owns the budget and the accreditation) and the clinic (which would use it). The realistic sequence is: clinical champion in a transplant nephrology unit runs a local validation, the regional HTA agency produces a rapid report, the hospital's technology committee authorises use, and the device plus cartridges then enter through a supplies tender. Central laboratory buy-in is not optional - Spanish laboratory directors control POC device governance under ISO 15189/ISO 22870 arrangements and can block a device that bypasses them. Budget note: a POC test that displaces an outpatient laboratory test may have to be funded from the clinic budget rather than the laboratory budget, which is a harder sell than it sounds.",
  "submissionWindow": "Rolling.",
  "difficulty": "high",
  "evidence": "Regional agencies will want head-to-head performance against the current standard of care in a Spanish cohort, plus a cost-consequence analysis showing displaced activity (avoided biopsies, avoided outpatient visits).",
  "precedent": "None found for a transplant POC biomarker in Spain.",
  "priceLow": 15,
  "priceHigh": 60,
  "currency": "EUR",
  "codes": []
 },
 {
  "id": "esp-send-out-private-pay-and-research",
  "iso3": "ESP",
  "assayClass": "biopsy_molecular",
  "routeName": "Send-out / private pay and research funding, pending any RedETS assessment",
  "routeType": "private_pay",
  "decisionBody": "Individual hospital research budget, industry-sponsored study, or private hospital group",
  "howItWorks": "No molecular biopsy classifier is in the cartera comun. In the Spanish public system this work is currently funded as research (ISCIII Fondo de Investigacion Sanitaria / FIS grants, CIBER networks, or industry-sponsored studies) or bought ad hoc from a hospital's own funds. The private route exists but is small: Quiron Salud (which also operates the publicly funded Fundacion Jimenez Diaz under a SERMAS concession), HM Hospitales, Vithas, plus insurer-funded work through Adeslas, Sanitas, DKV and the civil-servant mutual schemes MUFACE/MUGEJU/ISFAS. Practical route: fund a Spanish multicentre validation with ONT-visible investigators, publish it, and use it to nominate the technique into the RedETS work plan.",
  "submissionWindow": "n/a",
  "difficulty": "very_high",
  "evidence": "For any future RedETS assessment: demonstrated change in management versus histology alone.",
  "precedent": "MMDx and similar classifiers have been used in Spanish centres in a research context; no public funding decision was found.",
  "priceLow": null,
  "priceHigh": null,
  "currency": null,
  "codes": []
 },
 {
  "id": "usa-laboratory-licensure-gate-clia-cer",
  "iso3": "USA",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Laboratory licensure gate: CLIA certification + New York State CLEP permit (+ post-2025 FDA LDT position)",
  "routeType": "regulatory_gate",
  "decisionBody": "CMS / CDC / FDA (CLIA); New York State Department of Health, Wadsworth Center, Clinical Laboratory Evaluation Program (CLEP)",
  "howItWorks": "Any laboratory reporting patient-specific results on US specimens must hold a CLIA certificate; for a high-complexity molecular lab that means a CLIA Certificate of Accreditation (usually via CAP) or Certificate of Compliance, plus state licensure where required. Separately, New York State requires its OWN permit: any laboratory anywhere in the world that accepts a specimen originating in New York State must hold a NYS CLEP permit in the relevant permit category (e.g. Genetic Testing - Molecular, Histocompatibility, Cellular Immunology) and must obtain individual approval of each laboratory-developed test by submitting the full SOP manual and validation dossier to Wadsworth for review, with an on-site inspection (out-of-state labs pay the inspectors' travel costs). NY approval is granted per assay, not per lab, and Wadsworth reviewers routinely demand additional accuracy/precision/reproducibility data, so 6-12 months should be assumed. FDA is currently NOT a gate: the May 2024 LDT Final Rule was vacated in its entirety on 31 March 2025 by Judge Sean D. Jordan (ED Tex, ACLA v FDA), HHS did not appeal, and in September 2025 FDA published a final rule reverting the CFR text to its pre-2024 state, so LDTs remain under CLIA-only oversight as of August 2026. A distributed IVD kit sold to US hospital labs (rather than a central-lab LDT) would still need 510(k) or De Novo.",
  "submissionWindow": "Rolling. CLIA certificate application (CMS-116) any time. NY CLEP permit applications and per-assay LDT approval submissions are rolling; proficiency-testing enrolment is annual.",
  "difficulty": "high",
  "evidence": "CLIA/CAP: analytical validation only (accuracy, precision, analytical sensitivity/specificity, reportable range, reference interval). NY CLEP: analytical validation to a materially higher documentary standard plus clinical validity justification and a compliant report template. Neither requires an outcomes trial.",
  "precedent": "CareDx (AlloSure), Natera (Prospera) and Eurofins-Viracor (TRAC) all run as CLIA/CAP LDTs from single central laboratories and hold NY CLEP approval. Several dd-cfDNA entrants launched nationally while excluding New York specimens for the first 12-18 months - a legitimate but revenue-limiting tactic.",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "USD",
  "codes": []
 },
 {
  "id": "usa-ama-cpt-proprietary-laboratory-ana",
  "iso3": "USA",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "AMA CPT Proprietary Laboratory Analyses (PLA) code assignment",
  "routeType": "fee_schedule",
  "decisionBody": "American Medical Association CPT Editorial Panel / PLA Technical Advisory Group (PLA-TAG)",
  "howItWorks": "A PLA code is a proprietary, test-specific CPT code (4 digits + the letter U) owned by the test's manufacturer or sole-source laboratory. Without one, a novel test is billed under an unlisted code (81479 for molecular pathology, 81599 for multianalyte algorithmic analyses), which MACs and private payers price ad hoc or deny. Application is made by the lab through the AMA CPT Smart App; the PLA-TAG reviews the application on a quarterly cycle, the CPT Editorial Panel votes, and accepted codes are published quarterly with a set effective date. In 2026 the cycle ran: Q1 application deadline 9 December 2025; Q3 deadline 8 September 2026; PLA-TAG met 21 July 2026 with the CPT Editorial Panel voting 4 August 2026. Effective dates are the first of January, April, July or October. Getting the code is administrative, not evidentiary: the AMA is not deciding coverage, only nomenclature. Budget roughly 4-6 months from application to effective code, and note the code must exist before CMS will price it on the CLFS.",
  "submissionWindow": "Quarterly. 2026 known deadlines: Q1 application 9 Dec 2025; Q3 application 8 Sep 2026. PLA-TAG 21 Jul 2026; CPT Editorial Panel 4 Aug 2026. Codes publish quarterly, effective 1 Jan / 1 Apr / 1 Jul / 1 Oct.",
  "difficulty": "low",
  "evidence": "Minimal clinical evidence. The AMA requires a clear analyte/method/intended-use description, evidence the test is commercially available and performed by a single sole-source lab or is a sole-source kit, and a proposed code descriptor. It does NOT assess clinical utility - that is MolDX's job.",
  "precedent": "Every incumbent transplant dd-cfDNA assay holds a PLA code: 0118U (AlloSure Kidney), 0087U (AlloSure Heart), 0088U/0319U (Prospera kidney/heart), plus TRAC and later entrants. AlloMap uses a Category I code, 81595, having been on the market long enough to graduate out of PLA.",
  "priceLow": 0,
  "priceHigh": 0,
  "currency": "USD",
  "codes": [
   {
    "code": "0118U",
    "desc": "Transplantation medicine, quantification of donor-derived cell-free DNA using whole genome NGS, plasma - CareDx AlloSure Kidney",
    "price": "2840.75",
    "currency": "USD"
   },
   {
    "code": "0087U",
    "desc": "Cardiology, heart transplant, dd-cfDNA - CareDx AlloSure Heart",
    "price": null,
    "currency": "USD"
   },
   {
    "code": "0088U",
    "desc": "Transplantation medicine, dd-cfDNA, kidney - Natera Prospera (original code)",
    "price": null,
    "currency": "USD"
   },
   {
    "code": "0319U",
    "desc": "Transplantation medicine, dd-cfDNA, heart - Natera Prospera Heart",
    "price": null,
    "currency": "USD"
   },
   {
    "code": "0493U",
    "desc": "Transplantation medicine, dd-cfDNA quantification (identified in Medicare dd-cfDNA utilisation analysis)",
    "price": null,
    "currency": "USD"
   },
   {
    "code": "0540U",
    "desc": "dd-cfDNA transplant surveillance PLA code appearing in 2026 Medicare utilisation analysis",
    "price": null,
    "currency": "USD"
   }
  ]
 },
 {
  "id": "usa-medicare-clinical-laboratory-fee-s",
  "iso3": "USA",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Medicare Clinical Laboratory Fee Schedule (CLFS) pricing - crosswalk or gapfill, then PAMA private-payer rate reporting",
  "routeType": "fee_schedule",
  "decisionBody": "Centers for Medicare & Medicaid Services (CLFS), advised by the Advisory Panel on Clinical Diagnostic Laboratory Tests; gapfill amounts developed by the Medicare Administrative Contractors",
  "howItWorks": "Once a new CPT/PLA code exists, CMS must set a national payment amount. Each summer CMS holds the CLFS Annual Public Meeting where the test's sponsor presents a recommended payment basis; CMS then publishes preliminary determinations (crosswalk vs gapfill), takes 30 days of public comment, and publishes final determinations in the autumn, effective 1 January. CROSSWALK means the new code is priced to an existing code or blend of codes judged to use comparable methods and resources - fast, but it anchors you to someone else's price. GAPFILL means no comparable test exists, so in Year 1 each MAC independently develops a local rate (using charges, resources, other payers' rates, and clinical utility); CMS publishes preliminary MAC-level gapfill amounts around May-June with comments due in July, finalises them in the autumn, and the MEDIAN of the MAC rates becomes the national rate on the following January CLFS. Practically that is a two-year lag: a code effective 1 Jan 2026 that goes to gapfill has preliminary MAC amounts in mid-2026, final determinations late 2026, and a national rate on the CY2027 CLFS. For the 2026 cycle, 18 codes entered gapfill with comments accepted to 13 July 2026, to be implemented on the CY2027 CLFS. Thereafter rates are reset by PAMA private-payer reporting: applicable laboratories report the weighted median of the private-payer rates they were actually ",
  "submissionWindow": "CLFS Annual Public Meeting each summer (new code presentations). Gapfill comment period mid-year (2026: closed 13 July 2026). PAMA data reporting window 1 May - 31 July 2026 for rates effective 1 Jan 2027.",
  "difficulty": "medium",
  "evidence": "CMS pricing is a resource and comparability exercise, not a clinical evidence review. What moves the number is a well-argued cost/resource dossier, comparator selection, and the MACs' view of clinical utility. No RCT required.",
  "precedent": "Yes, repeatedly. AlloSure was gapfilled and landed at approximately USD 2,841; Natera publicly announced the same favourable gapfill outcome for Prospera; AlloMap sits on Category I code 81595 at a materially lower rate. This is a proven, well-trodden route for exactly this assay class - which is the good news and the bad news, since it sets the anchor price a newcomer will be crosswalked to.",
  "priceLow": 1800,
  "priceHigh": 2900,
  "currency": "USD",
  "codes": [
   {
    "code": "0118U",
    "desc": "AlloSure Kidney dd-cfDNA",
    "price": "2840.75",
    "currency": "USD"
   },
   {
    "code": "n/a",
    "desc": "Aggregate 2021 Medicare spend on dd-cfDNA transplant testing",
    "price": "85,400,000 total across 38,961 beneficiaries; USD 2,193 mean per beneficiary; kidney transplant subgroup n=4,613, USD 34.5m, USD 7,468 mean per beneficiary",
    "currency": "USD"
   }
  ]
 },
 {
  "id": "usa-moldx-programme-dex-z-code-registr",
  "iso3": "USA",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "MolDX programme: DEX Z-code registration, Technical Assessment, and LCD L40060 (Molecular Testing for Solid Organ Allograft Rejection)",
  "routeType": "hta_appraisal",
  "decisionBody": "MolDX, administered by Palmetto GBA on behalf of the participating MACs (Palmetto GBA, Noridian, WPS, CGS)",
  "howItWorks": "MolDX is the de facto national coverage gatekeeper for molecular diagnostics in the US, covering roughly two thirds of Medicare fee-for-service lives across four MAC jurisdictions. Three sequential steps. (1) Register the test in the DEX Diagnostics Exchange registry and obtain a unique Z-code, which must be submitted on every claim line alongside the CPT/PLA code; without a registered Z-code the claim is denied regardless of coverage. (2) Submit a Technical Assessment dossier (instructions M00115) unless the test is FDA-approved and used on-label. The TA is a full evidence dossier: intended use and clinical context, analytical validation, clinical validity in the intended-use population, and - the part that kills most submissions - clinical utility, i.e. published evidence that acting on the result changes management and improves outcomes. Expect 6-12 months and at least one round of questions. (3) Bill under the applicable LCD, which sets the covered indications and frequency limits. The governing policy has just been overhauled: MolDX finalised a new foundational LCD, L40060 'MolDX: Molecular Testing for Solid Organ Allograft Rejection', expected to take effect 30 August 2026, replacing/superseding the earlier L38629 / L38568 / L38582 / L38671 family. The new LCD is written as a universal, test-agnostic policy: any test meeting the evidence bar via TA can be covered, and it ",
  "submissionWindow": "Rolling. DEX registration and TA submission accepted continuously. LCD reconsideration requests may be filed at any time; new/revised LCDs follow a statutory 45-day comment period plus a 45-day notice period before the effective date.",
  "difficulty": "high",
  "evidence": "The highest bar in the US pathway. MolDX demands analytical validation, clinical validity in the specific intended-use population, and demonstrated CLINICAL UTILITY - peer-reviewed, ideally prospective, showing the result changes management and improves patient outcomes. Registry or single-arm data is usually insufficient on its own. For dd-cfDNA the reference evidence base MolDX has previously leaned on includes DART and ADMIRAL (elevated dd-cfDNA >=0.5% correlating with clinical and subclinical rejection, and persistent elevation predicting >25% eGFR decline over 3 years).",
  "precedent": "Strong and recent. AlloSure Kidney was the first dd-cfDNA test covered by MolDX; Prospera, TRAC and AlloMap followed; in July 2026 both CareDx and Natera issued releases welcoming the finalised universal LCD, and Transplant Genomics/iMDx announced a favourable Medicare coverage decision for the GraftAssure portfolio in the same week. The route unambiguously works - but it now works via a test-agnostic evidence bar rather than bespoke per-company policies, which is materially better for a new entrant.",
  "priceLow": 1800,
  "priceHigh": 2900,
  "currency": "USD",
  "codes": [
   {
    "code": "L40060",
    "desc": "Final LCD - MolDX: Molecular Testing for Solid Organ Allograft Rejection, expected effective 30 August 2026",
    "price": null,
    "currency": "USD"
   },
   {
    "code": "L38629",
    "desc": "LCD - MolDX: Molecular Testing for Solid Organ Allograft Rejection (predecessor policy, Palmetto GBA)",
    "price": null,
    "currency": "USD"
   },
   {
    "code": "L38568",
    "desc": "LCD - MolDX: Molecular Testing for Solid Organ Allograft Rejection (parallel MAC version)",
    "price": null,
    "currency": "USD"
   },
   {
    "code": "L38582",
    "desc": "LCD - MolDX: Molecular Testing for Solid Organ Allograft Rejection (parallel MAC version)",
    "price": null,
    "currency": "USD"
   },
   {
    "code": "L38671",
    "desc": "LCD - MolDX: Molecular Testing for Solid Organ Allograft Rejection (parallel MAC version)",
    "price": null,
    "currency": "USD"
   },
   {
    "code": "A58019",
    "desc": "Billing and Coding article for the above LCDs - contains the Z-code requirement and the concurrent dd-cfDNA + GEP billing restriction introduced March 2023",
    "price": null,
    "currency": "USD"
   }
  ]
 },
 {
  "id": "usa-histocompatibility-testing-on-the",
  "iso3": "USA",
  "assayClass": "hla_typing",
  "routeName": "Histocompatibility testing on the Medicare CLFS under NCD 190.1, plus OPTN/ASHI laboratory requirements",
  "routeType": "fee_schedule",
  "decisionBody": "CMS (National Coverage Determination 190.1 Histocompatibility Testing); MACs for local edits; ASHI/CAP for laboratory accreditation",
  "howItWorks": "HLA typing in the US is NOT an emerging-technology sale, it is an established, nationally covered service with mature Category I CPT codes. NCD 190.1 provides national Medicare coverage for histocompatibility testing for solid organ and marrow transplantation, platelet refractoriness and certain HLA-disease associations. Molecular HLA typing is billed in the 81370-81383 range (low, intermediate and high resolution, by locus group), crossmatching in 86825/86826, and antibody identification via solid phase assays in the 86828-86835 range. There is no PLA code and no MolDX Technical Assessment for standard typing, though MolDX/MAC LCDs such as L34518 (Molecular Pathology HLA Typing) set which indications are payable. Because these codes are all on the CLFS and are heavily crosswalked, the price is fixed and low relative to dd-cfDNA: 86825 is USD 109.49 and 86826 USD 36.53 on a published clinical lab fee schedule. The commercial consequence is that HLA is an in-house reagent-and-instrument market sold to ~150-200 ASHI- or CAP-accredited hospital and OPO histocompatibility laboratories, with real capital tenders and multi-year consumable contracts, rather than a send-out LDT market. To sell here you need ASHI/CAP-compatible validation documentation, IVD or RUO positioning, and in many cases FDA 510(k) clearance if the product is a kit distributed to those labs.",
  "submissionWindow": "n/a - codes and coverage already exist. New CPT codes for genuinely novel HLA methods would go through the standard AMA CPT cycle.",
  "difficulty": "medium",
  "evidence": "Low for coverage, because coverage already exists. High for laboratory adoption: ASHI accreditation standards, CAP checklists and UNOS/OPTN proficiency requirements govern what a lab may use, and lab directors expect full concordance data against an established typing platform and IMGT/HLA-consistent allele calling before switching.",
  "precedent": "Yes - this is a fully reimbursed, mature service line. The commercial incumbents are Thermo Fisher One Lambda and Immucor/Werfen, with NGS typing from Omixon, GenDx (EuroBio) and CareDx's legacy Olerup/QTYPE reagent lines. Reimbursement is not the barrier here; displacing an entrenched reagent contract is.",
  "priceLow": 36,
  "priceHigh": 400,
  "currency": "USD",
  "codes": [
   {
    "code": "81370",
    "desc": "HLA Class I and II typing, low resolution (antigen equivalents), complete",
    "price": null,
    "currency": "USD"
   },
   {
    "code": "81370-81383",
    "desc": "Full molecular HLA typing code range, low/intermediate/high resolution by locus",
    "price": null,
    "currency": "USD"
   },
   {
    "code": "86825",
    "desc": "HLA crossmatch, non-cytotoxic (eg flow cytometry), first serum sample",
    "price": "109.49",
    "currency": "USD"
   },
   {
    "code": "86826",
    "desc": "HLA crossmatch, non-cytotoxic, each additional serum sample",
    "price": "36.53",
    "currency": "USD"
   },
   {
    "code": "NCD 190.1",
    "desc": "Histocompatibility Testing - national Medicare coverage determination",
    "price": null,
    "currency": "USD"
   },
   {
    "code": "L34518",
    "desc": "MAC LCD - Molecular Pathology HLA Typing (indication limits)",
    "price": null,
    "currency": "USD"
   }
  ]
 },
 {
  "id": "usa-commercial-payer-medical-policy-un",
  "iso3": "USA",
  "assayClass": "molecular_surveillance_ddcfdna",
  "routeName": "Commercial payer medical policy (UnitedHealthcare, Aetna, Anthem/Elevance, Cigna, BCBS plans) and hospital/OPO direct contracting",
  "routeType": "private_pay",
  "decisionBody": "Each national and Blues plan's own medical technology assessment committee; BCBS Association Evidence Street; hospital value analysis committees for in-house purchases",
  "howItWorks": "Roughly half of US transplant recipients under 65 are covered by commercial insurance, and each plan writes its own medical policy independently of Medicare. The submission is an unsolicited dossier to the plan's medical policy team, typically comprising analytical validation, clinical validity, clinical utility, a budget-impact model and any guideline citations, followed by a policy review cycle (usually annual, with off-cycle reviews possible). Achieving Medicare/MolDX coverage first is close to mandatory because commercial plans lean on it, but it is not sufficient: several major plans still classify parts of transplant molecular surveillance as investigational, and in-network contracting with each plan is a separate negotiation from coverage. Note the PAMA interaction - the rates you agree here become your Medicare rate three years later. A separate direct-contract route exists for anything a hospital or OPO buys as a good rather than a service (instruments, reagents, kits), which goes through the health system's value analysis committee or Group Purchasing Organization (Vizient, Premier) rather than through any payer at all.",
  "submissionWindow": "Rolling submission; most plans run annual medical policy review cycles with published update dates.",
  "difficulty": "high",
  "evidence": "Generally the same or higher bar than MolDX, plus an explicit budget-impact argument. Plans want randomised or at least prospective comparative evidence that the test reduces biopsies, hospitalisations or graft loss, and they are markedly more sceptical of surveillance (asymptomatic) testing than of for-cause testing.",
  "precedent": "CareDx and Natera both have substantial commercial books alongside Medicare, but both have also reported payer pushback, denials and retrospective audits on transplant surveillance testing. This is the most volatile part of US transplant diagnostics revenue and the reason both companies' reported average selling prices sit well below list.",
  "priceLow": 1900,
  "priceHigh": 4500,
  "currency": "USD",
  "codes": [
   {
    "code": "0118U",
    "desc": "AlloSure Kidney - illustrative commercial rate",
    "price": "4001.00",
    "currency": "USD"
   },
   {
    "code": "81595",
    "desc": "AlloMap Heart - illustrative commercial rates",
    "price": "1877.12-4493.66",
    "currency": "USD"
   }
  ]
 }
];

export const GEN_STATS = {
 "geo_city": 399,
 "sites": 301,
 "geo_approx": 162,
 "duplicates_merged": 86,
 "pathways": 49,
 "volumes_from_followup": 81,
 "registry_centres": 72,
 "srtr_centres": 188
};
